import { TeacherDataService } from './../../administration/teacher/shared/teacher-data.service';
import { Logger, GlobalNotifierService } from '@app/core';
import { AccionModal } from './../models/modal-select.model';
import { Static, Condicion } from './../util/static';
import { CheckTableComponent } from './../component-table/check-table.component';
import { Tarea, TareaAsociacion, TareaCondicion } from './../models/tarea.model';
import { BaseControl } from './../dynamic-form/shared/controls/base-control';
import {
  ButtonsAccionDynamicFormsTableComponent
} from './../component-table/buttons-accion-dynamic-forms-table.component';
import { CoordinateDynamicFormsComponent } from './../component-table/coordinates-dynamic-forms.component';
import {
  RangeRefactoryTableDynamicComponent
} from './../component-table/date-refactory/range-refactory-table-dynamic.component';
import {
  RangeTimerRefactoryTableDynamicComponent
} from './../component-table/date-refactory/rangeTimer-refactory-table-dynamic.component';
import {
  RangeDateRefactoryTableDynamicComponent
} from './../component-table/date-refactory/rangeDate-refactory-table-dynamic.component';
import {
  DateTimerRefactoryTableDynamicComponent
} from './../component-table/date-refactory/dateTimer-refactory-table-dynamic.component';
import {
  TimerRefactoryTableDynamicComponent
} from './../component-table/date-refactory/timer-refactory-table-dynamic.component';
import {
  CalendarRefactoryTableDynamicComponent
} from './../component-table/date-refactory/calendar-refactory-table-dynamic.component';
import {
  ColumnaMaestra,
  EstructuraEspecifica,
  ValoresEspecificos,
  FiltroTableMasterGeneral
} from './../models/tabla-maestra.model';
import { ConfirmComponent } from './../confirm/confirm.component';
import { Custom } from './../dynamic-form/shared/controls/custom';
import {
  Control,
  Datos,
  Forma,
  TablaDatos,
  SubForma,
  ValoresOperacionesControl,
  FiltrosSelectores,
  InformacionGuardadaFormulario,
  SincronizacionTabla,
  TareaSincronizada,
  AccionSincronizacionTabla,
  DatosSincronizacion,
  AccesoMaestra,
  CondicionColumna,
  CondicionColumnaSelector,
  OpcionesListaChequeo,
  OperacionesControl,
  ValoresMaestraPorDefectoSeletor,
  CondicionForma
} from './../models/formulario-dinamico.model';
import { RefactorDynamicFormsFormService } from './shared/refactor-dynamic-forms-form.service';
import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ViewRef,
  ViewContainerRef,
  ComponentRef,
  ComponentFactoryResolver,
  ViewChildren,
  QueryList,
  OnDestroy
} from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { RefactorDynamicFormDataService } from './shared/refactor-dynamic-form-data.service';
import { find, result, Partial, findLastIndex, findIndex, filter, merge } from 'lodash';
import { BsModalService, BsModalRef, TabsetComponent } from 'ngx-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {
  RadioButtonsCheckListComponent,
  ThousandsSeparatorNumberFormatComponent,
  LabelNgSelectDynamicTableComponent
} from './../component-table';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Option, DynamicFormComponent, Container } from '../dynamic-form';
import { ColumnsTableModalSelect } from '../models/modal-select.model';
import { InputTableComponent, UpdateData } from '../component-table/input-table/input-table.component';
import { environment } from '@env/environment';
import { Const } from '../util/constants';
import { Subject } from 'rxjs';

const log = new Logger('RefactorDynamicFormComponent');

type ActtionValidationColum = 'Requerir' | 'Ignorar' | 'No eliminar registro';

export interface OptionCondiction extends Option {
  idOption: number;
}

export interface OptionDocumentsAssociations extends Option {
  id: number;
  expediente: string;
  fecha_radicado: string;
}

export interface OptionActas extends Option {
  id: number;
  consecutivo: string;
}

export interface UpdateTable {
  table: TablaDatos[];
  type: 'current' | 'association';
}

export interface SaveTables {
  tables: TablaDatos[];
  saveMunicipality: any;
}

interface CalculateDatesWorkingDays {
  date: Date;
  quantityDays: number;
  dateResult?: Date;
  operaction: string;
}

interface SyncTaskListCheck {
  data: any;
  form: SubForma;
  action?: AccionSincronizacionTabla;
}

interface SearchWorkingDays {
  date: Date;
  quantityDays: number;
  operaction: string;
}

interface ChangeQueue {
  subForm: SubForma;
  ixf: number;
  nameControl: string;
  data?: any;
}

@Component({
  selector: 'iw-refactor-dynamic-form',
  templateUrl: './refactor-dynamic-form.component.html',
  styleUrls: ['./refactor-dynamic-form.component.scss'],
  providers: [
    RefactorDynamicFormsFormService,
    RefactorDynamicFormDataService,
    TeacherDataService
  ]
})
export class RefactorDynamicFormComponent implements OnInit, OnDestroy {

  // Id de a tarea
  @Input() idtask = 0;
  // Define si el componente esta siendo renderizado en una tarea
  @Input() task = false;
  // Define cuando realizar el auto guardado de la tarea
  @Input() autoSave = false;
  // Datos del formulario de la forma
  @Input() data: Array<Datos> = [];
  // Forma a renderizar
  @Input() formI: Forma;
  form: Forma;
  // Define si la tarea esta finalizada
  @Input() finishTask = false;
  // Tarea actual
  @Input() taskActually: Tarea;
  // Forma de las tareas asociadas con los campos sincronizados
  @Input() formAssociationSync: Array<TareaSincronizada>;
  // Ruta de la mopoteca
  urlMapoteca = 'http://201.236.232.74:8128/maps/index.html';
  // Contiene el nombre de la tabla del scroll
  tableScroll = '';
  // Ruta en la cual se vera mapoteca
  urlViewMapoteca = '';
  // define la pregunta del componente de confirmacion
  question = '';
  // Define la pregunta del componente de confirmacion
  actionTable = '';
  // Contiene el nombre del formulario de cambio
  nameFormChange = '';
  // Contiene el tab donde se realiza la accion
  tabEdit = '';
  // Index de la fila que se desea modificar de la tabla del formulario
  indexSelectUpdate = -1;
  // Contiene el numero de formularios
  numberForms = 0;
  // Contiene las veces que se llama el refrescar de la forma desde el init
  countInit = 0;
  // Contiene el index temporal de el campo a modificar
  tmpIndexRow = -1;
  // Define cuando se va agregr un registro en una de las tablas de la forma renderizada
  addDataForm = false;
  // Define si todos los campos tienen la propiedad modificar en tabla
  updateInTable = false;
  // Define cuando va agregar o actualizar un regitro en una de las tablas de la forma renderizada
  update = false;
  // Define cuando se esta haciendo modificacion en la tabla
  tableUpdate = false;
  // Define cuando va agregar o actualizar un regitro en un formulario unico
  updateForm = {};
  // Define la accion a relaizar en la tabla
  actionTableRow = '';
  // Define cuando se esta modificando el formulario por las validaciones y no por cambios del usuario
  updateCondictions = false;
  // Define cuando se estan ejecutando los filtros de los selects
  updateFilters = false;
  // Define cuando aplicar los autoguardado de FormularioListaChequeo
  applyAutosavedFormularios = false;
  // Define cuando muestra el formulario unico
  onlyOpenForm = {};
  // Define si muestra el refrescar de formularios y tablas
  hideRefreshForms = environment.hideRefreshForms;
  // Contiene los templetes de los campos personalizados del formulario
  templatesFomr = {};
  // Datos de las tablas de la forma renderizada
  dataTable: Array<TablaDatos> = [];
  // Contiene los datos de todas las tablas inplicadas contando las tareas asociadas
  dataTableAll: Array<TablaDatos> = [];
  // Contiene las consultas de las columnas de las maestras
  acomulateColumns: Array<{
    name: string,
    columns: ValoresEspecificos[],
  }> = [];
  // Contiene los formularios dinamicos
  formularios: Array<{
    name: string,
    form: FormGroup,
    saved?: boolean
  }> = [];
  // Contiene los formularios refrescados
  formsRefresh: Array<{
    name: string
  }> = [];
  // Contiene los formularios que se estan cargando
  showForms = {};
  // Define cuando esta realizando carga de fuente de datos
  loadingDataSource = {};
  // Contiene la data de todos los formularios
  dataForm: Array<{
    name: string,
    data: any,
    nameChange?: string
  }> = [];
  // Contiene la informacion de la tabla donde se ejecuta alguna accion
  formSelect: SubForma;
  // Contiene la informacion de las tablas de registro unico donde se ejecuta alguna accion
  formSelectOnly = {};
  // Contiene la data de la accion de la modal
  dataAccionModal: AccionModal;
  // Contiene un control temporal
  tmpControl: Control;
  // Condiciones de la tarea
  condictions: Condicion[] = [];
  // Contiene la fila seleccionada de la tabla
  rowSelect: any;
  // Contiene la ultima fecha de los campos tipo fecha en el formulario
  currentDateFormsControls = {};
  // Contiene las validaciones de campos generales
  validGeneralControl = {};
  // Determina los tabs visibles
  tabsVisible = {};
  // Contexto para el control personalizado
  ctxSelectTpl: Custom;
  // Referencia de la modal del fomulario de la maestra
  modalRefMasterTable: BsModalRef;
  // Referencia de la modal de mapoteca
  modalRefMapoteca: BsModalRef;
  // Referencia de la modal del fomulario de la tabla
  modalRef: BsModalRef;
  // Define cuando esta accion una accion
  loadingProcess = false;
  // Mensaje de la ventan de cargando
  messaggeLoading = '';
  // Variables utilizan modal selector
  // Accion que se esta realizando
  actionRow = 'Agregar';
  // Define el nombre de la tabla maestra a la que se le desea realizar la accion de modificar o actualizar
  masterTable = '';
  // Define si la accion a realizar es modificar o actualizar
  modificar = false;
  // Contiene el registro seleccionado de la tabla
  registroSeleccionado: any;
  // Contiene temporalmente la informacion del formulario general de la tabla
  temporalFormGeneral: any = {};
  // Contiene la estructura de la maestra
  structureMaster: Array<ColumnaMaestra> = [];
  // Contiene la configuracion de acceso a las maestras para el control actualmente
  configMasterAccessControl: Array<AccesoMaestra> = [];
  // Contiene la configuracion de valores por defecto de la maestras para el control actualmente
  configDefaultValues: ValoresMaestraPorDefectoSeletor[] = [];
  // Contiene la cola de cambios a ejecutar
  changeQueue: ChangeQueue[] = [];
  // Contiene los valores or defecto del formulario de la maestra a agregar
  dataDefaultValueMaster: any;
  // Contiene el id de la tabla maestra
  idMasterTable = 0;
  // Contiene una copia de las tablas para que al refrescarlas desde el ícono se cargue 
  // su información no operada
  copyDataTable: Array<TablaDatos> = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // modal de las opciones especiales para tablas
  @ViewChild('templateModal') private templateModal: TemplateRef<any>;
  // Referencia de la template que renderiza un formulario
  @ViewChild('templateSubForm') subFormTpl: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelectGenerals') ngSelectGeneralsTpl: TemplateRef<any>;
  // Referencia al modal de mapoteca
  @ViewChild('mapoteca') private mapoteca: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de label
  @ViewChild('label') labelTpl: TemplateRef<any>;
  // Referencia a la plantilla para el botton de coordenadas
  @ViewChild('buttonCordenadas') buttonCordenadasTpl: TemplateRef<any>;
  // Referencia al componente de confirmación de las tablas
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Referencia al componente de confirmación de los selectores con modal
  @ViewChild('confirmActionSelectModal') private confirmActionSelectModal: ConfirmComponent;
  // Referencia al componente de confirmación dinamico
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia al componente de refactorizacion del formulario de la tabla maestra
  @ViewChild('templateRefactorMasterTable') private templateRefactorMasterTable: TemplateRef<any>;
  // Anclaje al contenedor que emula el formulario para el valor del campo en tabla a modificar
  @ViewChild('emulateForm', { read: ViewContainerRef }) emulateForm: ViewContainerRef;
  // Contiene el tab de pestañas de la tarea_asociacion
  @ViewChildren(TabsetComponent) tabPestanasForm: QueryList<TabsetComponent>;
  // Referencia al componente de formualrios dinamicos
  private componentRef: ComponentRef<DynamicFormComponent>;
  // Evento de salida con la informacion guardada en el formulario
  @Output() formSave: EventEmitter<InformacionGuardadaFormulario> = new EventEmitter();
  // Evento de salida con la informacion guardada en una de las tablas
  @Output() saveDataTable: EventEmitter<SaveTables> = new EventEmitter();
  // Evento de sincronizacion de las tablas
  @Output() eventSyncDataTable: EventEmitter<DatosSincronizacion> = new EventEmitter();
  // Evento de salida que identifica si el formulario ya esta completo con la informacion
  @Output() validForm: EventEmitter<boolean> = new EventEmitter();
  // Evento de salida para ejecutar la finalizacion de la tarea para los casos en que aplica el auto guardado
  @Output() finishAutoSave: EventEmitter<boolean> = new EventEmitter();
  // Emite los consecutivos de actas seleccionados
  @Output() consecutiveActa: EventEmitter<number> = new EventEmitter();
  // Actualizacion de las tablas asociadas y principales de la tarea
  @Output() updatedTable: EventEmitter<UpdateTable> = new EventEmitter();

  constructor(
    private rdffs: RefactorDynamicFormsFormService,
    private rdfds: RefactorDynamicFormDataService,
    private modalService: BsModalService,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private sts: ScrollToService,
    private tds: TeacherDataService,
    private gns: GlobalNotifierService,
    private cfr: ComponentFactoryResolver,
  ) { }

  async ngOnInit() {
    if (this.formI) {
      this.form = Static.copyObjet(this.formI);
    }
    this.templatesFomr = {
      ngSelectTpl: this.ngSelectTpl,
      labelTpl: this.labelTpl,
      buttonCordenadasTpl: this.buttonCordenadasTpl
    };

    if (this.task) {
      await Static.asyncForEach(this.form.sub_formas, async (subForm: SubForma) => {
        if (!this.loadingDataSource[subForm.alias + '_init']) {
          this.loadingDataSource[subForm.alias + '_init'] = true;
        }
      });
      if (
        this.taskActually &&
        this.taskActually.tarea_condicion &&
        this.taskActually.tarea_condicion.length &&
        this.form.condicion
      ) {
        this.condictions = Static.getMapConditions(<TareaCondicion[]>this.taskActually.tarea_condicion);
      }
      if (this.taskActually.tarea_asociacion.length) {
        this.taskActually.tarea_asociacion.forEach((asociation, index) => {
          if (asociation.tarea_condicion && asociation.tarea_condicion.length) {
            const associationCondictions: Condicion[] =  Static.getMapConditions(
              <TareaCondicion[]>asociation.tarea_condicion
            );
            if (associationCondictions && associationCondictions.length) {
              associationCondictions.forEach(condiction => {
                this.condictions.push(condiction);
              });
            }
          }

          this.rdfds.getDataTables(asociation.id_tarea_destino).subscribe(async data => {
            if (data.tabla_datos) {
              data.tabla_datos.forEach(dataTable => {
                dataTable['alias_form'] = asociation.alias;
                this.dataTableAll.push(dataTable);
              });
            }
            if (index === (this.taskActually.tarea_asociacion.length - 1)) {
              this.updatedTable.emit({
                table: this.dataTableAll,
                type: 'association'
              });
              await this.validateForm();
              this.refreshForm(true);
            }
          });
        });
      } else {
        this.updatedTable.emit({
          table: this.dataTableAll,
          type: 'association'
        });
        this.refreshForm(true);
      }
      this.rdfds.getDataTables(this.idtask).subscribe(async data => {
        if (data.tabla_datos) {
          this.dataTable = data.tabla_datos;
        } else {
          this.dataTable = [];
        }
        this.form.sub_formas.forEach(subForm => {
          const d: any = this.loadingDataTable(subForm.id_forma);
          subForm.datos = new LocalDataSource(d);
        });
        await this.valid();
        this.form.sub_formas.forEach(subForm => {
          const controlsGeneral = find(subForm.campos, ctrl => ctrl.propiedades['columna_general']);
          if (controlsGeneral) {
            this.loadFormControlsGeneral(subForm);
          }
        });
        await this.validateForm();
        this.refreshForm(true);
        this.updatedTable.emit({
          table: this.dataTable,
          type: 'current'
        });
      });
    } else {
      this.refreshForm();
    }
    this.form.sub_formas.sort((a, b) => a.orden - b.orden);
    await Static.asyncForEach(this.form.sub_formas, async subForm => {
      subForm.formulario = await this.rdffs.getForm(subForm, this.templatesFomr, this.data);
      const tabs = find(this.form.sub_formas, f => f.estilo['formulario_pestaña'] === subForm.alias);
      if (tabs) {
        subForm.pestanas = true;
      }
      if (subForm.tabla) {
        subForm.configuracion_tabla = this.creationTable(subForm);
        const controlsGeneral = find(subForm.campos, ctrl => ctrl.propiedades['columna_general']);
        if (controlsGeneral) {
          this.numberForms++;
        }
      } else {
        this.numberForms++;
      }
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  trackByEmpCode(_index: number, subForm: SubForma): any {
    return subForm.id_forma;
  }

  /**
   * Renderiza el formulario general de una tabla
   *
   * @param {SubForma} subForm
   * @memberof RefactorDynamicFormComponent
   */
  loadFormControlsGeneral(subForm: SubForma) {
    const controlsGeneral = filter(subForm.campos, ctrl => ctrl.propiedades['columna_general']);
    if (controlsGeneral.length) {
      const controls: BaseControl<any>[] = [new Container({
        class: 'form-row form-check form-check-inline col-12',
        order: 1,
        controls: [ ]
      })];
      controlsGeneral.forEach(field => {
        let value = this.temporalFormGeneral ?
                      this.temporalFormGeneral[subForm.alias] ?
                        this.temporalFormGeneral[subForm.alias][field.nombre_campo]
                      : null
                    : null;
        if (field.validaciones.condiciones && field.validaciones.condiciones.length) {
          field.validaciones.condiciones.forEach( condiction => {
            const campoDepende = find(subForm.campos, {alias: condiction.campoDepende});
            if (campoDepende) {
              condiction.campoDepende = campoDepende.nombre_campo;
            }
          });
        }
        field.requerido = true;
        const temp = {
          form: subForm,
          control: field
        };
        const tpl = {
          ngSelectTpl: this.ngSelectGeneralsTpl,
        };
        if (
          this.validGeneralControl[subForm.id_forma] &&
          this.validGeneralControl[subForm.id_forma].length
        ) {
          if (field.propiedades['options'] && field.propiedades['options'].length) {
            if (value) {
              const existOpction = find(field.propiedades['options'], {value: value});
              if (!existOpction) {
                value = null;
              }
            }
            field.propiedades['options'].forEach((opt: Option) => {
              const dataFilter = {
                complete: false
              };
              dataFilter[field.nombre_campo] = opt.value;
              const complete = find(
                this.validGeneralControl[subForm.id_forma],
                dataFilter
              );
              if (complete) {
                opt['complete'] = false;
              } else {
                opt['complete'] = true;
              }
            });
          } else {
            if (value) {
              value = null;
            }
          }
        }
        controls[0]['controls'].push(this.rdffs.getControl(field, tpl, value, temp, true));
      });
      subForm['controles_generales'] = controls;
    }
  }

  /**
   * Indica si el formulario general de una tabla esta completo
   *
   * @param {string} aliassubForm
   * @returns {boolean}
   * @memberof RefactorDynamicFormComponent
   */
  completeFormGeneral(aliassubForm: string): boolean {
    const form = find(this.formularios, {name: aliassubForm});
    if (form) {
      return form.form.valid;
    } else {
      return true;
    }
  }

  validComplete(subForm: SubForma, data: any) {
    let valid = true;
    if (data) {
      const controlsGeneral = filter(subForm.campos, ctrl => ctrl.propiedades['columna_general']);
      if (controlsGeneral.length) {
        controlsGeneral.forEach(control => {
          if (!data[control.nombre_campo]) {
            valid = false;
          }
        });
      }
    } else {
      valid = false;
    }
    return valid;
  }

  /**
   * Filtra la tabla basado en las opciones seleccionadas en el formulario general
   *
   * @param {SubForma} subForm
   * @param {*} data
   * @memberof RefactorDynamicFormComponent
   */
  filterTableGeneral(subForm: SubForma, data: any) {
    let apply = false;
    if (this.temporalFormGeneral[subForm.alias]) {
      if (Object.keys(this.temporalFormGeneral[subForm.alias]).length) {
        Object.keys(this.temporalFormGeneral[subForm.alias]).forEach(key => {
          if (data[key]) {
            if (this.temporalFormGeneral[subForm.alias][key] !== data[key]) {
              apply = true;
            }
          } else {
            apply = true;
          }
        });
      } else {
        apply = true;
      }
    } else {
      apply = true;
    }
    if (apply || !subForm.estilo['registro_unico']) {
      this.temporalFormGeneral[subForm.alias] = Static.copyObjet(data);
      const tableData = find(this.dataTable, {id_tabla: subForm.id_forma});
      if (tableData && data) {
        const values = this.loadingDataTable(subForm.id_forma, false, false);
        const filterValues = filter(values, data);
        this.validTabsVisible(subForm, tableData, filterValues);
        const complete = find(
          this.validGeneralControl[subForm.id_forma],
          data
        );
        if (this.tabsVisible[subForm.alias]) {
          this.tabsVisible[subForm.alias]['complete'] = complete ? true : false;
        } else {
          this.tabsVisible[subForm.alias] = {
            complete: complete ? true : false
          };
        }
        const tabs = filter(this.form.sub_formas, f => f.estilo['formulario_pestaña'] === subForm.alias);
        if (tabs.length) {
          tabs.forEach(tab => {
            if (
              this.tabsVisible[subForm.alias] &&
              this.tabsVisible[subForm.alias][tab.alias] &&
              this.tabsVisible[subForm.alias][tab.alias]['visible'] &&
              tab.tabla
            ) {
              const valuesPestana = this.loadingDataTable(tab.id_forma, false, false);
              const filterValuesPestana = filter(valuesPestana, data);
              tab.datos = new LocalDataSource(filterValuesPestana);
              tab.datos.refresh();
            }
          });
        }
        if (complete && complete['tabs'] && Object.keys(complete['tabs']).length) {
          Object.keys(complete['tabs']).forEach((key: string) => {
            if (this.tabsVisible[subForm.alias][key]) {
              this.tabsVisible[subForm.alias][key]['complete'] = complete['tabs'][key] ? true : false;
            } else {
              this.tabsVisible[subForm.alias][key] = {
                complete: complete['tabs'][key] ? true : false
              };
            }
          });
        }
        if (this.tabPestanasForm.length) {
          this.tabPestanasForm.forEach((tabSet) => {
            if (tabSet.tabs.length) {
              tabSet.tabs.forEach(tab => {
                if (
                  (tab.id === 'tab-' + subForm.alias && !this.tabEdit) ||
                  (tab.id === 'tab-' + this.tabEdit)
                ) {
                  tab.active = true;
                  this.tabEdit = '';
                }
              });
            }
          });
        }
        if (!subForm.estilo['registro_unico']) {
          subForm.datos = new LocalDataSource(filterValues);
          subForm.datos.refresh();
        } else if (this.validComplete(subForm, data)) {
          if (!filterValues || !filterValues.length) {
            this.onlyOpenForm[subForm.alias] = false;
            delete subForm.formulario;
            delete this.formSelectOnly[subForm.alias];
            this.addDataTable(subForm);
            this.refreshFormormulario(subForm.id_forma, subForm.alias);
          } else {
            this.onlyOpenForm[subForm.alias] = false;
            this.updateDataTable(filterValues[0]);
          }
        } else {
          if (this.onlyOpenForm[subForm.alias]) {
            this.closeAddDataTable(subForm.alias);
          }
        }
      } else if (
        this.validComplete(subForm, data) &&
        subForm.estilo['registro_unico']
      ) {
        this.onlyOpenForm[subForm.alias] = false;
        delete subForm.formulario;
        this.addDataTable(subForm);
        this.refreshFormormulario(subForm.id_forma, subForm.alias);
      }
    }
  }

  /**
   * Retorna las dependencias de los formularios generales de un formulario
   *
   * @param {SubForma} subForm
   * @memberof RefactorDynamicFormComponent
   */
  filterDependenciControlsGeneral(subForm: SubForma) {
    Static.asyncForEach(this.form.sub_formas, async form => {
      if (form.tabla) {
        const fields = find(
          form.campos,
          field => field.propiedades['cargar_tabla'] &&
                  field.propiedades['cargar_tabla']['form'] === this.form.alias &&
                  field.propiedades['cargar_tabla']['formulario'] === subForm.alias &&
                  field.propiedades['columna_general']
        );
        if (fields) {
          this.refreshForm(false, form.id_forma);
        }
      }
    });
  }

  /**
   * Filtra el grupo de las opciones de campos generales
   *
   * @param {SubForma} subForm
   * @returns {Promise<Array<any>>}
   * @memberof RefactorDynamicFormComponent
   */
  async groupFilterGeneral(subForm: SubForma): Promise<any> {
    return new Promise(async (resolve, _reject) => {
      const controlsGeneral = filter(subForm.campos, ctrl => ctrl.propiedades['columna_general']);
      const dataL: any[] = [];
      if (controlsGeneral.length) {
        const ctrl = await this.refresControlForm(
          subForm,
          Static.copyObjet(controlsGeneral[0]),
          [],
          false,
          false,
          true,
          false
        );
        controlsGeneral.splice(0, 1);
        const options = ctrl.propiedades['options'] as Option[];
        if (options.length) {
          await Static.asyncForEach(options, async opt => {
            const data = {};
            data[ctrl.nombre_campo] = opt.value;
            if (controlsGeneral[0]) {
              const dL = await this.filterGroup(
                data,
                Static.copyObjet(controlsGeneral[0]),
                subForm,
                controlsGeneral,
                0
              );
              if (dL.length) {
                dL.forEach((el: any) => {
                  dataL.push(el);
                });
              }
            } else {
              dataL.push(data);
            }
          });
        }
      }
      resolve(dataL);
    });
  }

  /**
   * Filtra un grupo de una opcion indicada
   *
   * @param {*} data
   * @param {Control} field
   * @param {SubForma} subForm
   * @param {Control[]} controlsGeneral
   * @param {number} i
   * @returns {Promise<any>}
   * @memberof RefactorDynamicFormComponent
   */
  filterGroup(data: any, field: Control, subForm: SubForma, controlsGeneral: Control[], i: number): Promise<any> {
    return new Promise(async (resolve, _reject) => {
      const dataL: any[] = [];
      const ctrl = await this.refresControlForm(
        subForm,
        Static.copyObjet(field),
        data,
        false,
        false,
        true,
        false
      );
      const options = ctrl.propiedades['options'] as Option[];
      if (options.length) {
        await Static.asyncForEach(options, async opt => {
          const d = Static.copyObjet(data);
          d[field.nombre_campo] = opt.value;
          const ix = i + 1;
          if (controlsGeneral[ix]) {
            const dL = await this.filterGroup(d, controlsGeneral[ix], subForm, controlsGeneral, ix);
            if (dL.length) {
              dL.forEach((el: any) => {
                dataL.push(el);
              });
            }
          } else {
            dataL.push(d);
          }
        });
      }
      resolve(dataL);
    });
  }

  /**
   * Refresca todos los formularios de la forma
   * Cuando se es llamado desde la funcion init se acumula el numero de llamados y apartir de la segunda ejecucion
   * se refresca la forma
   *
   * @param {boolean} [init=false]
   * @param {number} [idForm=-1]
   * @param {*} [data]
   * @param {boolean} [ignoreRefresh=false]
   * @param {boolean} [onlyTable=false]
   * @param {boolean} [viewLoad=true]
   * @return {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  async refreshForm(
    init: boolean = false,
    idForm: number = -1,
    data?: any,
    ignoreRefresh: boolean  = false,
    onlyTable: boolean = false,
    viewLoad: boolean = true
  ) {
    return new Promise(async (resolve, _reject) => {
      if (init) {
        this.countInit++;
      }
      if (!init || this.countInit >= 2) {
        this.form.sub_formas.sort((a, b)  => a.orden - b.orden);
        await Static.asyncForEach(this.form.sub_formas, async subForm => {
          if (init && !this.loadingDataSource[subForm.alias + '_init'] && viewLoad) {
            this.loadingDataSource[subForm.alias + '_init'] = true;
          }
        // this.form.sub_formas.forEach(async subForm => {
          if (idForm === -1) {
            if (!ignoreRefresh) {
              if (this.showForms[subForm.alias]) {
                this.showForms[subForm.alias] = false;
                if (!(this.cd as ViewRef).destroyed) {
                  this.cd.detectChanges();
                }
              }
            }
            if (data) {
              await this.loadingFormSelects(subForm, data, false, onlyTable);
            } else {
              await this.loadingFormSelects(
                subForm,
                init ?
                  this.data ?
                    this.data.length ?
                      this.data
                    : null
                  : null
                : null,
                false,
                onlyTable
              );
            }
            if (!ignoreRefresh) {
              setTimeout(() => {
                this.showForms[subForm.alias] = true;
                if (!(this.cd as ViewRef).destroyed) {
                  this.cd.detectChanges();
                }
              });
            }
          } else {
            if (subForm.id_forma === idForm) {
              if (!ignoreRefresh) {
                if (this.showForms[subForm.alias]) {
                  this.showForms[subForm.alias] = false;
                  if (!(this.cd as ViewRef).destroyed) {
                    this.cd.detectChanges();
                  }
                }
              }
              if (data) {
                await this.loadingFormSelects(subForm, data, false, onlyTable);
              } else {
                await this.loadingFormSelects(subForm, null, false, onlyTable);
              }
              if (!ignoreRefresh) {
                setTimeout(() => {
                  this.showForms[subForm.alias] = true;
                  if (!(this.cd as ViewRef).destroyed) {
                    this.cd.detectChanges();
                  }
                });
              }
              this.filterDependenciControlsGeneral(subForm);
              await this.validateForm();
            }
          }
        });
        if (init) {
          this.applyAutosavedFormularios = true;
          setTimeout(() => {
            this.form.sub_formas.forEach(subForm => {
              if (init && this.loadingDataSource[subForm.alias + '_init'] && viewLoad) {
                this.loadingDataSource[subForm.alias + '_init'] = false;
              }
            });
            if (!(this.cd as ViewRef).destroyed) {
              this.cd.detectChanges();
            }
          });
        }
      }
      resolve(true);
    });
  }

  /**
   * Carga las opciones de los selects, tanto desde una tabla maestra o una tabla dinamica
   * Carga los datos de la lista de chequeo
   * Carga los registros de la fuente de datos
   *
   * @param {SubForma} [subForm]
   * @param {*} [dataForm]
   * @param {boolean} [refresCheckList=false]
   * @param {boolean} [onlyTable=false]
   * @return {*}  {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  loadingFormSelects(
    subForm?: SubForma,
    dataForm?: any,
    refresCheckList: boolean = false,
    onlyTable: boolean = false
  ): Promise<boolean> {
    return new Promise(async (resolve, _reject) => {
      subForm.campos.sort((a, b) => a.orden - b.orden);
      if (!subForm.estilo.hasOwnProperty('tipo') && !onlyTable) {
        await Static.asyncForEach(subForm.campos, async control => {
          if (control.tipo_campo.nombre === 'ngSelect') {
            if (!subForm.tabla) {
              if (control.propiedades['tipoSelector'] !== 'EnModal') {
                await this.refresControlForm(subForm, control, dataForm);
              } else {
                this.updatedControlColumns(control, subForm);
                const formGr = find(this.formularios, {name: subForm.alias});
                let idrecord = null;
                if (
                  formGr && formGr.form.value[control.nombre_campo]
                ) {
                  idrecord = formGr.form.value[control.nombre_campo];
                } else {
                  const dt = find(this.data, {
                    nombre_campo: control.nombre_campo,
                    alias_formulario: subForm.alias
                  });
                  if (dt && dt.valor) {
                    idrecord = dt.valor;
                  }
                }
                if (idrecord) {
                  await this.refresControlForm(
                    subForm,
                    control,
                    dataForm,
                    false,
                    false,
                    false,
                    false,
                    '(' + String(idrecord) + ')'
                  );
                }
                control.propiedades['loadData'] = (idrecord?: any) => {
                return new Promise(async (resolve) => {
                  const formGr = find(this.formularios, {name: subForm.alias});
                  if (formGr) {
                    let ctrl: any;
                    if (idrecord) {
                      ctrl = await this.refresControlForm(
                        subForm,
                        control,
                        formGr.form.value,
                        false,
                        false,
                        true,
                        false,
                        '(' + String(idrecord) + ')'
                      );
                    } else {
                      ctrl = await this.refresControlForm(
                        subForm,
                        control,
                        formGr.form.value,
                        false,
                        false,
                        true,
                      );
                    }
                    resolve({
                      data: ctrl.propiedades['dataSelectorModal']
                    });
                  }
                  resolve([]);
                });
              };
            }
            } else if (control.propiedades['columna_general']) {
              const ctrl = await this.refresControlForm(
                subForm,
                control,
                this.temporalFormGeneral[subForm.alias],
                false,
                false,
                true
              );
              control.propiedades['options'] = ctrl.propiedades['options'];
            }
          }
        });
        if (dataForm) {
          subForm.formulario = await this.rdffs.getForm(subForm, this.templatesFomr, dataForm);
        } else {
          subForm.formulario = await this.rdffs.getForm(subForm, this.templatesFomr, this.data);
        }
        if (subForm['controles_generales'] && subForm['controles_generales'].length) {
          this.loadFormControlsGeneral(subForm);
        }
      } else if (subForm.estilo.hasOwnProperty('tipo') && !onlyTable) {
        const shortid = require('shortid');
        const dataTExist = find(this.dataTable, {alias: subForm.alias});
        const indexDataTExist = findIndex(this.dataTable, {alias: subForm.alias});
        const recordsSpecific: number[] = [];
        let exist = true;
        if (dataTExist) {
          const cols: ValoresEspecificos[] = await this.getTableMaster(subForm, refresCheckList);
          if (
            subForm.estilo['registros_especificos'] &&
            subForm.estilo['registros_especificos'].length &&
            dataTExist.valores.length
          ) {
            for (const el of subForm.estilo['registros_especificos']) {
              const indexRecord = find(dataTExist.valores, {id_registro: el});
              if (!indexRecord) {
                exist = false;
                recordsSpecific.push(el);
              }
            }
            dataTExist.valores.forEach(val => {
              const valE = find(cols, {id: val['id_registro']});
              if (!valE) {
                if (subForm.estilo['ocultar_registros']) {
                  val['ocultar'] = true;
                }
                val['block'] = true;
              } else {
                val['block'] = false;
              }
            });
          } else if (subForm.estilo['tipo'] === 'TablaMaestra') {
            if (!refresCheckList) {
              cols.forEach(col => {
                const valE = find(dataTExist.valores, {id_registro: col.id});
                recordsSpecific.push(col.id);
                if (!valE) {
                  exist = false;
                }
              });
              dataTExist.valores.forEach(val => {
                const valE = find(cols, {id: val['id_registro']});
                if (!valE) {
                  if (subForm.estilo['ocultar_registros']) {
                    val['ocultar'] = true;
                  }
                  val['block'] = true;
                } else {
                  val['block'] = false;
                }
              });
            } else {
              if (!dataTExist.valores.length) {
                exist = false;
              } else if (cols.length) {
                const valExist: any[] = [];
                cols.forEach(col => {
                  const valE = find(dataTExist.valores, {id_registro: col.id});
                  if (valE) {
                    valExist.push(valE);
                  } else {
                    recordsSpecific.push(col.id);
                    exist = false;
                  }
                });
                if (valExist.length === dataTExist.valores.length && !recordsSpecific.length) {
                  exist = true;
                } else {
                  exist = false;
                  const rowDelete: any[] = [];
                  if (dataTExist.valores.length) {
                    dataTExist.valores.forEach(valDE => {
                      const valE = find(cols, {id: valDE['id_registro']});
                      if (!valE) {
                        if (subForm.estilo['ocultar_registros']) {
                          valDE['ocultar'] = true;
                        }
                        valDE['block'] = true;
                        if (!valDE['sync']) {
                          rowDelete.push(valDE);
                        }
                      } else {
                        valDE['block'] = false;
                      }
                    });
                  }
                  if (rowDelete.length) {
                    rowDelete.forEach(async row => {
                      const indexVal = findIndex(dataTExist.valores, {id_registro: row['id_registro']});
                      await this.syncDataTable(row, subForm, {}, 'eliminar');
                      await this.syncDataTablesActually(row, subForm, 'eliminar');
                      this.dataTable[indexDataTExist].valores.splice(indexVal, 1);
                    });
                  }
                }
              } else {
                if (dataTExist.valores.length) {
                  dataTExist.valores.forEach(async valE => {
                    await this.syncDataTable(valE, subForm, {}, 'eliminar');
                    await this.syncDataTablesActually(valE, subForm, 'eliminar');
                  });
                }
                this.dataTable[indexDataTExist].valores = [];
                exist = true;
              }
            }
          }
        } else {
          exist = false;
        }
        if (!exist) {
          if (subForm.estilo['tipo'] === 'TablaMaestra') {
            // let specificEstructure: EstructuraEspecifica;

            // specificEstructure = this.generateStructureMasterTable(
            //   subForm.estilo['maestra'],
            //   subForm.estilo['columna_seleccionada']
            // );

            const columns: ValoresEspecificos[] = await this.getTableMaster(subForm);

            // const colsMaster = find(this.acomulateColumns, {name: subForm.nombre + '_tabla'});
            let colsSeleccion: Array<any> = [];
            if (subForm.estilo['columna_seleccionada']) {
              colsSeleccion = [subForm.estilo['columna_seleccionada']];
            }
            // if (!colsMaster) {
            //   columns = await this.rdfds.getColumnsSpecificMasterTable(specificEstructure);

            //   this.acomulateColumns.push({
            //     name: subForm.nombre + '_tabla',
            //     columns: columns
            //   });
            // } else {
            //   columns = colsMaster.columns;
            // }

            if (columns) {
              columns.sort((a, b) => a.id - b.id);
              let dataCheckList: TablaDatos;
              if (dataTExist) {
                dataCheckList = dataTExist;
              } else {
                dataCheckList = {
                  alias: subForm.alias,
                  nombre: subForm.nombre,
                  id_tabla: subForm.id_forma,
                  labels: {},
                  valores: [],
                  valueSelects: {},
                };
              }
              subForm.campos.forEach(field => {
                dataCheckList.labels[field.alias] = field.nombre_campo;
              });
              await this.asyncForEach(columns, async (column: ValoresEspecificos) => {
              // columns.forEach(async column => {
                let valid = true;
                if (recordsSpecific && recordsSpecific.length) {
                  if (recordsSpecific && recordsSpecific.length) {
                    const recordSpecific = recordsSpecific.indexOf(column.id);
                    if (recordSpecific !== -1) {
                      valid = true;
                    } else {
                      valid = false;
                    }
                  }
                } else if (subForm.estilo['registros_especificos'] && subForm.estilo['registros_especificos'].length) {
                  const recordSpecific = subForm.estilo['registros_especificos'].indexOf(column.id);
                  if (recordSpecific !== -1) {
                    valid = true;
                  } else {
                    valid = false;
                  }
                } else {
                  const existRow = find(dataCheckList.valores, {id_registro: column.id});
                  if (existRow) {
                    valid = false;
                  }
                }
                if (valid) {
                  const value = {
                    id: shortid.generate()
                  };
                  let valueDefault = 'No';
                  if (subForm.estilo['opciones_chequeo'] && subForm.estilo['opciones_chequeo'].length) {
                    valueDefault = '';
                    const option = find(
                      subForm.estilo['opciones_chequeo'],
                      {por_defecto: true}
                    ) as OpcionesListaChequeo;
                    if (option) {
                      valueDefault = option.valor;
                    }
                  }
                  value[dataCheckList.labels[subForm.alias + '_opciones']] = valueDefault;
                  colsSeleccion.forEach((col: number, index: any) => {
                    if (column.valores[col]) {
                      value[dataCheckList.labels[subForm.alias + '_requisitos']] = column.valores[col];
                      value['id_registro'] = column.id;
                      value['block'] = false;
                    }
                  });
                  dataCheckList.valores.push(value);
                  const infoCheckList: SyncTaskListCheck = {
                    data: value,
                    form: subForm,
                    action: 'agregar'
                  };
                  await this.syncTasks(infoCheckList, infoCheckList);
                  // await this.syncCheckList(value, subForm, 'agregar');
                  // await this.syncCheckListCurrent(value, subForm, 'agregar');
                }
              });
              if (!dataTExist) {
                this.dataTable.push(dataCheckList);
              } else {
                const indexTable = findIndex(this.dataTable, {id_tabla: dataTExist.id_tabla});
                this.dataTable[indexTable] = dataCheckList;
              }
              this.purgeDataTable(this.dataTable);
              this.valid();
              const d: any = this.loadingDataTable(subForm.id_forma);
              subForm.datos = new LocalDataSource(d);
              subForm.datos.refresh();
            }
          } else {
            if (subForm.estilo['cargar_tabla']) {
              if (subForm.estilo['cargar_tabla']['form']) {
                let formSelect: SubForma;
                if (this.form.alias === subForm.estilo['cargar_tabla']['form']) {
                  formSelect = find(this.form.sub_formas, {alias: subForm.estilo['cargar_tabla']['formulario']});
                  if (formSelect) {
                    if (this.dataTable.length) {
                      await this.asyncForEach(this.dataTable, async (data: TablaDatos) => {
                      // this.dataTable.forEach(async data => {
                        if (data.alias === subForm.alias) {
                          const dataCheckList: TablaDatos = ({
                            alias: subForm.alias,
                            nombre: subForm.nombre,
                            id_tabla: subForm.id_forma,
                            labels: {},
                            valores: [],
                            valueSelects: {},
                          });
                          subForm.campos.forEach(field => {
                            dataCheckList.labels[field.alias] = field.nombre_campo;
                          });
                          await this.asyncForEach(data.valores, async (val: any) => {
                          // data.valores.forEach(async val => {
                            const value = {
                              id: shortid.generate()
                            };
                            if (val[data.labels[subForm.estilo['cargar_tabla']['column']]]) {
                              if (val[data.labels[subForm.estilo['cargar_tabla']['formulario'] + '_opciones']]) {
                                value[
                                  dataCheckList.labels[subForm.alias + '_opciones']
                                ] = val[data.labels[subForm.estilo['cargar_tabla']['formulario'] + '_opciones']];
                              } else {
                                value[
                                  dataCheckList.labels[subForm.alias + '_opciones']
                                ] = 'No';
                              }
                              value[
                                dataCheckList.labels[subForm.alias + '_requisitos']
                              ] = val[data.labels[subForm.estilo['cargar_tabla']['column']]];
                            }
                            dataCheckList.valores.push(value);
                            await this.syncCheckList(value, subForm, 'agregar');
                            await this.syncCheckListCurrent(value, subForm, 'agregar');
                          });
                          this.dataTable.push(dataCheckList);
                          this.purgeDataTable(this.dataTable);
                          this.valid();
                          const d: any = this.loadingDataTable(subForm.id_forma);
                          subForm.datos = new LocalDataSource(d);
                          subForm.datos.refresh();
                        }
                      });
                    }
                  }
                } else {
                  const dataT = find(this.dataTableAll, {alias: subForm.estilo['cargar_tabla']['formulario']});
                  if (dataT) {
                    const dataCheckList: TablaDatos = ({
                      alias: subForm.alias,
                      nombre: subForm.nombre,
                      id_tabla: subForm.id_forma,
                      labels: {},
                      valores: [],
                      valueSelects: {},
                    });
                    subForm.campos.forEach(field => {
                      dataCheckList.labels[field.alias] = field.nombre_campo;
                    });
                    await this.asyncForEach(dataT.valores, async (val: any) => {
                    // dataT.valores.forEach(async val => {
                      const value = {
                        id: shortid.generate()
                      };
                      if (val[dataT.labels[subForm.estilo['cargar_tabla']['column']]]) {
                        if (val[dataT.labels[subForm.estilo['cargar_tabla']['formulario'] + '_opciones']]) {
                          value[
                            dataCheckList.labels[subForm.alias + '_opciones']
                          ] = val[dataT.labels[subForm.estilo['cargar_tabla']['formulario'] + '_opciones']];
                        } else {
                          value[
                            dataCheckList.labels[subForm.alias + '_opciones']
                          ] = 'No';
                        }

                        value[
                          dataCheckList.labels[subForm.alias + '_requisitos']
                        ] = val[dataT.labels[subForm.estilo['cargar_tabla']['column']]];
                      }
                      dataCheckList.valores.push(value);
                      await this.syncCheckList(value, subForm, 'agregar');
                      await this.syncCheckListCurrent(value, subForm, 'agregar');
                    });
                    this.dataTable.push(dataCheckList);
                    this.purgeDataTable(this.dataTable);
                    this.valid();
                    const d: any = this.loadingDataTable(subForm.id_forma);
                    subForm.datos = new LocalDataSource(d);
                    subForm.datos.refresh();
                  }
                }
              }
            }
          }
        }
      }
      if (
        !subForm['hidde'] &&
        subForm.estilo.hasOwnProperty('fuente') &&
        Object.keys(subForm.estilo['fuente']).length
      ) {
        const dataTExist = find(this.dataTable, {alias: subForm.alias});
        if (!dataTExist) {
          if (subForm.estilo['fuente']['form']) {
            if (!this.loadingDataSource[subForm.alias]) {
              this.loadingDataSource[subForm.alias] = true;
              let formSelect: SubForma;
              if (this.form.alias === subForm.estilo['fuente']['form']) {
                formSelect = find(this.form.sub_formas, {alias: subForm.estilo['fuente']['formulario']});
                if (formSelect) {
                  if (this.dataTable.length) {
                    const data = find(this.dataTable, {alias: formSelect.alias});
                    if (data) {
                      const dataTable: TablaDatos = ({
                        alias: subForm.alias,
                        nombre: subForm.nombre,
                        id_tabla: subForm.id_forma,
                        labels: {},
                        valores: [],
                        valueSelects: {},
                      });
                      subForm.campos.forEach(field => {
                        dataTable.labels[field.alias] = field.nombre_campo;
                      });
                      await this.asyncForEach(data.valores, async (val: any) => {
                      // data.valores.forEach(async val => {
                        const selects: Object = new Object();
                        const value = {
                          id: val['id']
                        };
                        subForm.campos.forEach(field => {
                          if (data.labels[field.alias]) {
                            value[field.nombre_campo] = val[data.labels[field.alias]];
                            if (field.tipo_campo.nombre === 'ngSelect') {
                              if (data.valueSelects[data.labels[field.alias] + '_' + val['id']]) {
                                // tslint:disable-next-line:max-line-length
                                dataTable.valueSelects[field.nombre_campo + '_' + value['id']] = data.valueSelects[data.labels[field.alias] + '_' + val['id']];
                                // tslint:disable-next-line:max-line-length
                                selects[field.nombre_campo + '_' + value['id']] = data.valueSelects[data.labels[field.alias] + '_' + val['id']];
                              }
                            }
                          }
                        });
                        if (subForm.estilo['formulario_pestaña']) {
                          const tabFormulario = find(
                            this.form.sub_formas,
                            {alias: subForm.estilo['formulario_pestaña']}
                          );
                          if (tabFormulario) {
                            const controlsGeneral = filter(
                              tabFormulario.campos,
                              ctrl => ctrl.propiedades['columna_general']
                            );
                            if (controlsGeneral.length) {
                              controlsGeneral.forEach(fieldGeneral => {
                                value[fieldGeneral.nombre_campo] = val[fieldGeneral.nombre_campo];
                              });
                            }
                          }
                        }
                        const fields = filter(
                          subForm.campos,
                          field => !value[field.nombre_campo] && field.validaciones.operaciones.length
                        );
                        if (fields.length) {
                        await Static.asyncForEach(fields, async field => {
                            await Static.asyncForEach(field.validaciones.operaciones, async opr => {
                              if (!value[field.nombre_campo]) {
                                const resultOperaction = await this.executeOperation(
                                  subForm,
                                  field,
                                  opr,
                                  value,
                                  dataTable.valueSelects
                                );
                                if (resultOperaction) {
                                  value[field.nombre_campo] = resultOperaction;
                                  if (field.tipo_campo.nombre === 'ngSelect') {
                                    const ctrl = await this.refresControlForm(
                                      subForm,
                                      field,
                                      value as any,
                                      false,
                                      false,
                                      true
                                    );
                                    const vlSelect = result(find(ctrl.propiedades['options'], {value: resultOperaction}), 'others');
                                    if (vlSelect) {
                                      dataTable.valueSelects[field.nombre_campo + '_' + value['id']] = vlSelect;
                                      selects[field.nombre_campo + '_' + value['id']] = vlSelect;
                                    }
                                  }
                                }
                              }
                            });
                          });
                        }
                        dataTable.valores.push(value);
                        await this.syncDataTable(value, subForm, selects);
                      });
                      this.dataTable.push(dataTable);
                      await Static.asyncForEach(this.dataTable, async table => {
                        if (table.id_tabla === dataTable.id_tabla) {
                          await Static.asyncForEach(table.valores, async val => {
                            await this.updatedTableFount(val, subForm, table.valueSelects);
                            this.syncDataTablesActually(val, subForm, 'agregar');
                          });
                        }
                      });
                      this.purgeDataTable(this.dataTable);
                      const d: any = this.loadingDataTable(subForm.id_forma);
                      subForm.datos = new LocalDataSource(d);
                      subForm.datos.refresh();
                      this.valid().then(_ => {
                        this.loadFormControlsGeneral(subForm);
                      });
                    }
                  }
                }
              } else {
                const dataT = find(
                  this.dataTableAll,
                  {
                    alias: subForm.estilo['fuente']['formulario'],
                    alias_form: subForm.estilo['fuente']['form']
                  }
                );
                if (dataT) {
                  const dataTable: TablaDatos = ({
                    alias: subForm.alias,
                    nombre: subForm.nombre,
                    id_tabla: subForm.id_forma,
                    labels: {},
                    valores: [],
                    valueSelects: {},
                  });
                  subForm.campos.forEach(field => {
                    dataTable.labels[field.alias] = field.nombre_campo;
                  });
                  await this.asyncForEach(dataT.valores, async (val: any) => {
                  // dataT.valores.forEach(async val => {
                    const selects: Object = new Object();
                    const value = {
                      id: val['id']
                    };
                    subForm.campos.forEach(field => {
                      if (dataT.labels[field.alias]) {
                        value[field.nombre_campo] = val[dataT.labels[field.alias]];
                        if (field.tipo_campo.nombre === 'ngSelect') {
                          if (dataT.valueSelects[dataT.labels[field.alias] + '_' + val['id']]) {
                            // tslint:disable-next-line:max-line-length
                            dataTable.valueSelects[field.nombre_campo + '_' + value['id']] = dataT.valueSelects[dataT.labels[field.alias] + '_' + val['id']];
                            // tslint:disable-next-line:max-line-length
                            selects[field.nombre_campo + '_' + value['id']] = dataT.valueSelects[dataT.labels[field.alias] + '_' + val['id']];
                          }
                        }
                      }
                    });
                    if (subForm.estilo['formulario_pestaña']) {
                      const tabFormulario = find(
                        this.form.sub_formas,
                        {alias: subForm.estilo['formulario_pestaña']}
                      );
                      if (tabFormulario) {
                        const controlsGeneral = filter(
                          tabFormulario.campos,
                          ctrl => ctrl.propiedades['columna_general']
                        );
                        if (controlsGeneral.length) {
                          controlsGeneral.forEach(fieldGeneral => {
                            value[fieldGeneral.nombre_campo] = val[fieldGeneral.nombre_campo];
                          });
                        }
                      }
                    }
                    const fields = filter(
                      subForm.campos,
                      field => !value[field.nombre_campo] && field.validaciones.operaciones.length
                    );
                    if (fields.length) {
                      await Static.asyncForEach(subForm.campos, async field => {
                        await Static.asyncForEach(field.validaciones.operaciones, async opr => {
                          if (!value[field.nombre_campo]) {
                            const resultOperaction = await this.executeOperation(
                              subForm,
                              field,
                              opr,
                              value,
                              dataTable.valueSelects
                            );
                            if (resultOperaction) {
                              value[field.nombre_campo] = resultOperaction;
                              if (field.tipo_campo.nombre === 'ngSelect') {
                                const ctrl = await this.refresControlForm(
                                  subForm,
                                  field,
                                  value as any,
                                  false,
                                  false,
                                  true
                                );
                                const vlSelect = result(find(ctrl.propiedades['options'], {value: resultOperaction}), 'others');
                                if (vlSelect) {
                                  dataTable.valueSelects[field.nombre_campo + '_' + value['id']] = vlSelect;
                                  selects[field.nombre_campo + '_' + value['id']] = vlSelect;
                                }
                              }
                            }
                          }
                        });
                      });
                    }
                    dataTable.valores.push(value);
                    await this.syncDataTable(value, subForm, selects);
                  });
                  this.dataTable.push(dataTable);
                  await Static.asyncForEach(this.dataTable, async table => {
                    if (table.id_tabla === dataTable.id_tabla) {
                      await Static.asyncForEach(table.valores, async val => {
                        await this.updatedTableFount(val, subForm, table.valueSelects);
                        this.syncDataTablesActually(val, subForm, 'agregar');
                      });
                    }
                  });
                  this.purgeDataTable(this.dataTable);
                  const d: any = this.loadingDataTable(subForm.id_forma);
                  subForm.datos = new LocalDataSource(d);
                  subForm.datos.refresh();
                  this.valid().then(_ => {
                    this.loadFormControlsGeneral(subForm);
                  });
                }
              }
            }
            this.loadingDataSource[subForm.alias] = false;
          } else if (subForm.estilo['fuente']['maestra']) {
            if (!this.loadingDataSource[subForm.alias]) {
              this.loadingDataSource[subForm.alias] = true;
              this.loadDataSourceFromMaster(subForm)
              .then(_ => this.loadingDataSource[subForm.alias] = false)
              .catch(_ => this.loadingDataSource[subForm.alias] = false);
            }
          }
        }
      }
      if (subForm.tabla && !onlyTable) {
        const d: any = this.loadingDataTable(subForm.id_forma);
        subForm.datos = new LocalDataSource(d);
        subForm.datos.refresh();
      }
      resolve(true);
    });
  }

  /**
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @param {ColumnaMaestra[]} structure
   * @param {Array<string>} columns
   * @param {number} [idDependence=0]
   * @returns {EstructuraEspecifica}
   * @memberof RefactorDynamicFormComponent
   */
  loadingEstructureColumns(
    structure: ColumnaMaestra[],
    columns: Array<string>,
    idDependence: number = 0
  ): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const cls: Array<string> = [];
    specificEstructure = {
      maestra: null,
      columnas: [],
      dependencia: []
    };
    columns.forEach(el => {
      cls.push(el);
    });
    for (const field of structure) {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        if (idDependence !== 0 && idDependence !== field.id) {
          continue;
        }
        specificEstructure.maestra = field.id + ' ';
        cls.forEach((col: string, index: number) => {
          const  cols = col.split('_');
          const column = Number(cols[1]);
          if (cols.length === 2) {
            const dependenc = Number(cols[0]);
            if (typeof field.maestra_dependencia === 'object') {
              const columnField = find(field.maestra_dependencia.estructura, {id: column});
                if (dependenc === field.id) {

                if (columnField) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            }
          } else if (cols.length > 2) {
            const cl = cols.slice(1);
            cls[index] = '';
            cl.forEach((el: any, indexCol: number) => {
              cls[index] += el;

              if (indexCol < (cl.length - 1)) {
                cls[index] += '_';
              }

            });
          }
        });
        if (cls.length) {
          const newLevel = this.loadingEstructureColumns(field.maestra_dependencia['estructura'], cls);
          if (newLevel) {
            specificEstructure.dependencia.push(newLevel);
            break;
          }
        }
      }
    }
    if (specificEstructure.maestra && (specificEstructure.columnas.length || specificEstructure.dependencia.length)) {
      return specificEstructure;
    } else {
      return null;
    }
  }

  /**
   * Valida la informacion del componente que este completa
   *
   * @memberof RefactorDynamicFormComponent
   */
  async valid() {
    let validF = true;
    let validT = true;
    for (let indexF = 0; indexF < this.form.sub_formas.length; indexF++) {
      let exist = false;
      let validTable = true;
      if (
        this.form.sub_formas[indexF].tabla &&
        !this.form.sub_formas[indexF].estilo['formulario_pestaña']
      ) {
        for (let indexT = 0; indexT < this.dataTable.length; indexT++) {
          if (this.dataTable[indexT].id_tabla === this.form.sub_formas[indexF].id_forma) {
            exist = true;
            this.validGeneralControl[this.form.sub_formas[indexF].id_forma] = await this.groupFilterGeneral(
              this.form.sub_formas[indexF]
            );
            if (this.validGeneralControl[this.form.sub_formas[indexF].id_forma].length) {
              this.validGeneralControl[this.form.sub_formas[indexF].id_forma].forEach((group: any) => {
                const valuesF = filter(this.dataTable[indexT].valores, group);
                let val = this.validRows(
                  this.form.sub_formas[indexF],
                  this.dataTable[indexT],
                  valuesF
                );
                if (this.form.sub_formas[indexF].pestanas) {
                  const validTabs = this.validateAllTabbedTables(
                    this.form.sub_formas[indexF],
                    this.dataTable[indexT],
                    valuesF,
                    group
                  );
                  if (!validTabs) {
                    val = false;
                  }
                }
                group['complete'] = val;
                if (!val && validTable) {
                  validTable = val;
                }
              });
            } else {
              validTable = this.validRows(
                this.form.sub_formas[indexF],
                this.dataTable[indexT],
                this.dataTable[indexT].valores
              );
              if (this.tabsVisible[this.form.sub_formas[indexF].alias]) {
                this.tabsVisible[this.form.sub_formas[indexF].alias]['complete'] = validTable;
              } else {
                this.tabsVisible[this.form.sub_formas[indexF].alias] = {
                  complete: validTable
                };
              }
              const tabs = filter(
                this.form.sub_formas,
                f => f.estilo['formulario_pestaña'] === this.form.sub_formas[indexF].alias
              );
              if (tabs.length) {
                for (const tab of tabs) {
                  if (
                    this.tabsVisible[this.form.sub_formas[indexF].alias] &&
                    this.tabsVisible[this.form.sub_formas[indexF].alias][tab.alias] &&
                    this.tabsVisible[this.form.sub_formas[indexF].alias][tab.alias]['visible']
                  ) {
                    if (tab.tabla) {
                      validTable = this.validSaveTable(tab.alias);
                    } else {
                      validTable = this.validSavedForm(tab.alias) as boolean;
                    }
                    this.tabsVisible[this.form.sub_formas[indexF].alias][tab.alias]['complete'] = validTable;
                    if (!validTable) {
                      break;
                    }
                  }
                }
              }
            }
          }
        }
        if (!exist) {
          if (this.form.sub_formas[indexF].numero_registros === 0) {
            exist = true;
          }
        }
        if ((exist && validTable) || this.form.sub_formas[indexF].hidde) {
          // if (validT) {
          //   validT = true;
          // }
        } else {
          validT = false;
        }
      }
    }
    if (validT) {
      const forms = filter(this.form.sub_formas, {tabla: false});
      if (
        this.formularios &&
        forms &&
        this.formularios.length >= forms.length
      ) {
        for (const formulario of this.formularios) {
          const form = find(this.form.sub_formas, {alias: formulario.name});
          if (!form.tabla && !form.estilo['formulario_pestaña']) {
            if (
              (formulario.form.status === 'VALID' && formulario.saved) ||
              (formulario.form.status === 'DISABLED' && !this.finishTask) ||
              (form && form['hidde'])
            ) {
              validF = true;
            } else {
              validF = false;
              break;
            }
          }
        }
      } else {
        validF = false;
      }
    } else {
      validF = false;
    }
    if (!this.updateCondictions) {
      this.validForm.emit(validF);
    }
  }

  /**
   * Valida las pestañas que esten completas las pestañas de una tabla con un filtro especifico de campos generales
   *
   * @param {SubForma} subForm
   * @param {TablaDatos} dataTable
   * @param {*} values
   * @param {*} group
   * @returns
   * @memberof RefactorDynamicFormComponent
   */
  validateAllTabbedTables(
    subForm: SubForma,
    dataTable: TablaDatos,
    values: any,
    group: any
  ) {
    let complete = true;
    const tabs = filter(this.form.sub_formas, f => f.estilo['formulario_pestaña'] === subForm.alias);
    if (tabs.length) {
      const tabsValid = {};
      for (const tab of tabs) {
        const dataFilter = {};
        dataFilter[dataTable.labels[tab.estilo['columna_pestaña']]] = tab.estilo['valor_columna_pestaña'];
        const exist = filter(values, dataFilter);
        if (exist.length) {
          let valid: boolean;
          if (tab.tabla) {
            const tbl = find(this.dataTable, {id_tabla: tab.id_forma});
            if (tbl) {
              const groupFilter = Static.copyObjet(group, ['complete', 'tabs'])
              const valuesTab = filter(tbl.valores, groupFilter);
              valid = this.validRows(
                tab,
                tbl,
                valuesTab
              );
            } else {
              if (tab.numero_registros === 0) {
                valid = true;
              } else {
                valid = false;
              }
            }
          } else {
            valid = this.validSavedForm(tab.alias) as boolean;
          }
          tabsValid[tab.alias] = valid;
        }
      }
      group['tabs'] = tabsValid;
      if (Object.keys(tabsValid).length) {
        Object.keys(tabsValid).forEach(key => {
          if (!tabsValid[key]) {
            complete = false;
          }
        });
      }
    }
    return complete;
  }

  /**
   * Valida los registros de las tablas que cumplan todas las condiciones
   *
   * @param {SubForma} subForm
   * @param {TablaDatos} dataTable
   * @param {any[]} values
   * @returns
   * @memberof RefactorDynamicFormComponent
   */
  validRows(subForm: SubForma, dataTable: TablaDatos, values: any[]) {
    let validTable = true;
    let valuesTable: any[] = [];
    if (values.length) {
      if (
        subForm.estilo['condiciones_columnas'] &&
        subForm.estilo['condiciones_columnas'].length
      ) {
        // tslint:disable-next-line: max-line-length
        valuesTable = this.runCondictionsColumnsTable(subForm, 'Ignorar', dataTable, values) as any[];
        // tslint:disable-next-line: max-line-length
        validTable = this.runCondictionsColumnsTable(subForm, 'Requerir', dataTable, valuesTable) as boolean;
      } else {
        valuesTable = values;
      }
    }
    let validMin = false;
    let validMax = false;

    if (valuesTable.length >= subForm.numero_registros) {
      validMin = true;
    }

    if (
      !subForm.estilo ||
      !subForm.estilo['numero_registros_maximos']
    ) {
      validMax = true;
    } else if (subForm.estilo['numero_registros_maximos'] >= valuesTable.length) {
      validMax = true;
    }
    if (validTable) {
      if (validMin && validMax) {
        validTable = true;
      } else {
        validTable = false;
      }
    }
    return validTable;
  }

  /**
   * Ejecuta las condiciones de las columnas indicando la funcion a ejecutar
   *
   * @param {SubForma} form
   * @param {ActtionValidationColum} [action='Requerir']
   * @param {TablaDatos} [table]
   * @param {any[]} [values]
   * @returns
   * @memberof RefactorDynamicFormComponent
   */
  runCondictionsColumnsTable(
    form: SubForma,
    action: ActtionValidationColum = 'Requerir',
    table?: TablaDatos,
    values?: any[]
  ) {
    if (!table) {
      table = find(this.dataTable, {id_tabla: form.id_forma});
    }
    const indexForm = findIndex(this.form.sub_formas, {id_forma: form.id_forma});
    const condictionsAction: CondicionColumna[] = [];
    if (form.estilo['condiciones_columnas'] && form.estilo['condiciones_columnas'].length) {
      const condictionsColumns = form.estilo['condiciones_columnas'] as Array<CondicionColumna>;
      condictionsColumns.forEach(condiction => {
        if (condiction.accion === action) {
          condictionsAction.push(condiction);
        }
      });
    }
    let messageAlert = '';
    if (action === 'Ignorar') {
      let valuesTable: any[] = [];
      let valuesV: any[] = [];
      if (values !== undefined) {
        valuesV = values;
      } else {
        valuesV = table.valores;
      }
      if (valuesV.length) {
        if (condictionsAction.length) {
          valuesV.forEach(value => {
            let validValue = true;
            condictionsAction.forEach(condiction => {
              const column = table.labels[condiction.columna];
              if (condiction.valor === 'Lleno') {
                if (value[column]) {
                  validValue = false;
                  messageAlert = condiction.mensaje;
                }
              } else {
                if (!value[column]) {
                  validValue = false;
                  messageAlert = condiction.mensaje;
                }
              }
            });
            if (validValue) {
              valuesTable.push(value);
            }
          });
        } else {
          valuesTable = valuesV;
        }
      }
      if (indexForm !== -1) {
        if (valuesTable.length < this.form.sub_formas[indexForm].numero_registros) {
          this.form.sub_formas[indexForm].estilo['alertIgnore'] = messageAlert;
        } else {
          this.form.sub_formas[indexForm].estilo['alertIgnore'] = '';
        }
        if (condictionsAction && condictionsAction.length) {
          this.form.sub_formas[indexForm].estilo['validRecords'] = valuesTable.length;
        }
      }
      return valuesTable;
    } else if (action === 'Requerir') {
      let validTable = true;
      if (values.length) {
        if (condictionsAction.length) {
          values.forEach(value => {
            condictionsAction.forEach(condiction => {
              const column = table.labels[condiction.columna];
              if (condiction.valor === 'Lleno') {
                if (!value[column]) {
                  validTable = false;
                  messageAlert = condiction.mensaje;
                }
              } else {
                if (value[column]) {
                  validTable = false;
                  messageAlert = condiction.mensaje;
                }
              }
            });
          });
        }
      }
      if (indexForm !== -1) {
        if (!validTable) {
          this.form.sub_formas[indexForm].estilo['alertRequierement'] = messageAlert;
        } else {
          this.form.sub_formas[indexForm].estilo['alertRequierement'] = '';
        }
      }
      return validTable;
    } else if (action === 'No eliminar registro') {
      if (values.length) {
        if (condictionsAction.length) {
          values.forEach(value => {
            condictionsAction.forEach(condiction => {
              const column = table.labels[condiction.columna];
              if (condiction.valor === 'Lleno') {
                if (value[column]) {
                  value['delete'] = false;
                } else {
                  value['delete'] = true;
                }
              } else {
                if (!value[column]) {
                  value['delete'] = false;
                } else {
                  value['delete'] = true;
                }
              }
            });
          });
        }
      }
    }

  }

  /**
   * Valida el maximo de registros de una tabla
   *
   * @param {SubForma} subForm
   * @returns
   * @memberof RefactorDynamicFormComponent
   */
  validMaxRecords(subForm: SubForma) {
    if (!subForm.estilo || !subForm.estilo['numero_registros_maximos'] || !subForm.datos || !subForm.datos['data']) {
      return true;
    } else if (subForm.estilo.hasOwnProperty('validRecords')) {
      if (subForm.estilo['validRecords'] < subForm.estilo['numero_registros_maximos']) {
        return true;
      } else {
        return false;
      }
    } else {
      if (subForm.estilo['numero_registros_maximos'] > subForm.datos['data'].length) {
        return true;
      } else {
        return false;
      }
    }
  }

  /**
   * Valida la cantidad de registros de una tabla
   *
   * @param {SubForma} subForm
   * @returns
   * @memberof RefactorDynamicFormComponent
   */
  validTableRecords(subForm: SubForma) {
    if (!subForm.datos || !subForm.datos['data']) {
      return {
        'badge-danger': true,
        'badge-success': false
      };
    } else if (subForm.estilo.hasOwnProperty('validRecords')) {
      if (
        (
          subForm.numero_registros &&
          subForm.estilo['validRecords'] < subForm.numero_registros
        ) ||
        (
          subForm.estilo['numero_registros_maximos'] &&
          subForm.estilo['validRecords'] > subForm.estilo['numero_registros_maximos']
        )
      ) {
        return {
          'badge-danger': true,
          'badge-success': false
        };
      } else {
        return {
          'badge-danger': false,
          'badge-success': true
        };
      }
    } else {
      if (
        (
          subForm.numero_registros &&
          subForm.datos['data'].length < subForm.numero_registros
        ) ||
        (
          subForm.estilo['numero_registros_maximos'] &&
          subForm.datos['data'].length > subForm.estilo['numero_registros_maximos']
        )
      ) {
        return {
          'badge-danger': true,
          'badge-success': false
        };
      } else {
        return {
          'badge-danger': false,
          'badge-success': true
        };
      }
    }
  }

  /**
   * Emite el evento con la informacion guardada en alguno de los formularios
   *
   * @param {*} data
   * @param {SubForma} form
   * @param {boolean} [force=false]
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  sended(data: any, form: SubForma, force: boolean = false): Promise<boolean> {
    return new Promise(async (resolve) => {
      if (form.estilo['auto_saved'] && !force) {
        resolve(true);
      } else {
        let response = true;
        const dependence = this.dependenceCondictionsForm(form);
        if (dependence.length) {
          // let formulario = '';
          const forms: SubForma[] = [];
          const rows = {};
          dependence.forEach((validForm, i) => {
            // if (i !== (dependence.length - 1)) {
            //   if (i > 0) {
            //     formulario += ', ';
            //   }
            //   formulario += validForm.formulario.nombre;
            // } else {
            //   if (i > 0) {
            //     formulario += ' y ';
            //   }
            //   formulario += validForm.formulario.nombre;
            // }
            if (validForm.tabla) {
              rows[validForm.formulario.alias] = validForm.valores;
              forms.push(validForm.formulario);
            }
          });
          response = await this.confirm.new({
            labelConfirm: 'Sí',
            labelDecline: 'No',
            question: 'Al seleccionar esta opción se eliminaran los registros ingresados' +
                      ' en la condición anteriormente seleccionada' +
                      ' ¿Realmente desea realizar la acción?'
          });
          if (response) {
            await this.deleteRowTableGeneral(forms, rows);
            const formsDelete = filter(dependence, {tabla: false});
            if (formsDelete.length) {
              formsDelete.forEach(formD => {
                const dataFormD = {};
                Static.asyncForEach(formD.formulario.campos, async field => {
                  dataFormD[field.alias] = null;
                  const indexField = findIndex(
                    this.data,
                    {
                      alias_formulario: formD.formulario.alias,
                      alias: field.alias
                    }
                  );
                  if (indexField !== -1) {
                    this.data.splice(indexField, 1);
                  }
                  formD.formulario.formulario = await this.rdffs.getForm(
                    formD.formulario,
                    this.templatesFomr,
                    this.data
                  );
                });
                this.formSave.emit({
                  data: data,
                  subForm: formD.formulario
                });
              });
            }
          }
        }
        const valid = this.validDataForm(data, form);
        if (form.campos.length && response) {
          const formulario = find(this.formularios, {name: form.alias});
          for (const field of form.campos) {
            const hiddenField = this.getHiddenField(form.formulario, field.nombre_campo);
            if (data[field.nombre_campo] === undefined || hiddenField === 1 || hiddenField === -1) {
              continue;
            }
            if (field.sincronizado) {
              if (this.formAssociationSync && this.formAssociationSync.length) {
                this.formAssociationSync.forEach(formAssociation => {
                  if (formAssociation.id_tarea === this.taskActually.id) {
                    if (formAssociation.forma && formAssociation.forma.length) {
                      formAssociation.forma.forEach(formA => {
                        if (!formA.tabla && formA.campos && formA.campos.length && formA.id_forma !== form.id_forma) {
                          const existField = find(formA.campos, {alias: field.alias});
                          if (existField && existField.tipo_campo.nombre === field.tipo_campo.nombre) {
                            const formSync = find(this.formularios, {name: formA.alias});
                            if (formSync && formSync.form.controls[existField.nombre_campo]) {
                              formSync.form.controls[existField.nombre_campo].setValue(
                                formulario.form.controls[field.nombre_campo].value
                              );
                            }
                          }
                        }
                      });
                    }
                  }
                });
              }
            }
          }
        }
        if (valid && response) {
          for (const formulario of this.formularios) {
            if (formulario.name === form.alias) {
              if (!formulario.saved) {
                formulario.saved = true;
                this.cd.detectChanges();
              }
              const refresh = findIndex(this.formsRefresh, {name: form.alias});
              if (refresh !== -1) {
                this.formsRefresh.splice(refresh, 1);
              }
            } else {
              continue;
            }
          }
          this.formSave.emit({
            data: data,
            subForm: form
          });
          this.valid();
          // this.validateForm();
          this.form.sub_formas.forEach(subForm => {
            if (subForm.estilo['filtros_maestra'] && subForm.estilo['filtros_maestra'].length) {
              this.loadingFormSelects(subForm, null, true);
            }
          });
        }
        resolve(true);
      }
      this.operateTable(form);
    });
  }

  /**
   *Realiza las operaciones de la tabla que tenga alguno de sus campos condicionado por el 
   *formulario que se acaba de guardar
   * @param {SubForma} form
   * @memberof RefactorDynamicFormComponent
   */
   operateTable(form: SubForma){
    let found = false;
    this.form.sub_formas.forEach(subForm=>{
      if(subForm.tabla){
        subForm.campos.forEach(campo=>{
          if(campo.validaciones && campo.validaciones.operaciones && campo.validaciones.operaciones.length){
            campo.validaciones.operaciones.forEach(operacion=>{
              operacion.valores.forEach(val=>{
                if(val.formulario == form.alias && !found){
                  this.dataTable.forEach(dt=>{
                    if(dt.alias == subForm.alias && !found){
                      this.copyDataTable = Static.copyObjet(this.dataTable);
                      this.refreshFountDataTable(subForm.id_forma);
                      found = true;
                    }
                  })
                }
              })
            })
          }
        })
      }
    })
  }

  dependenceCondictionsForm(subForm: SubForma): {
    valid: number,
    formulario: SubForma,
    tabla: boolean,
    valores: any[]
  }[] {
    const dependence: {
      valid: number,
      formulario: SubForma,
      tabla: boolean,
      valores: any[]
    }[] = [];
    if (subForm.estilo['limpiar_condicion'] && this.form.condiciones.length) {
      const condictionsDependence = filter(
        this.form.condiciones,
        {
          formaInicia: this.form.alias,
          formularioInicia: subForm.alias
        }
      );
      if (condictionsDependence.length) {
        condictionsDependence.forEach(condiction => {
          const form = find(this.form.sub_formas, {alias: condiction.formularioCondicionado});
          if (form) {
            const dt = find(this.dataTable, {id_tabla: form.id_forma});
            const exist = find(dependence, dp => dp.formulario.alias === form.alias);
            if (!exist && form['hidde'] && (!form.tabla || dt && dt.valores.length)) {
              dependence.push({
                formulario: form,
                tabla: form.tabla,
                valid: 0,
                valores: dt ? dt.valores : null
              });
            }
          }
        });
      }
    }
    return dependence;
  }

  /**
   * Condicionando si todos los campos tiene la propiedad de modificar en tabla
   * Para ocultar el boton modificar de la tabla
   *
   * @param {SubForma} form
   * @memberof RefactorDynamicFormComponent
   */
  columnsUpdateInTable(form: SubForma) {
    let valid = false;
    // Condicionando si todos los campos tiene la propiedad de modificar en tabla
    if (form.campos) {
      for (let i = 0; i < form.campos.length; i++) {
        if (form.campos[i].propiedades && form.campos[i].propiedades['modificar_tabla']) {
          valid = true;
          break;
        }
      }
      if (valid) {
        if (form.estilo && form.estilo['activar_modificar']) {
          this.updateInTable = false;
        } else {
          this.updateInTable = true;
        }
      } else {
        this.updateInTable = false;
      }
    }
  }

  /**
   * Crea la configuracion de las tablas de la forma a renderizar
   *
   * @param {SubForma} form
   * @returns {*}
   * @memberof RefactorDynamicFormComponent
   */
  creationTable(form: SubForma): any {
    const self = this;
    const columns = {};

    form.campos.sort((a, b) => a.orden - b.orden);
    form.campos.forEach(control => {
      let nameColum = control.label;
      let sizeColum = '';
      if (control.requerido) {
        nameColum += '*';
      }
      if (control.propiedades['tamano_columna']) {
        sizeColum = control.propiedades['tamano_columna'] + '%';
      }
      if (control.propiedades['mostrarTabla'] && !control.propiedades['columna_general']) {
        if (control.propiedades['modificar_tabla'] && !this.finishTask && form.estilo['modificar']) {
          let filterColumn: any;
          let sort: any;
          switch (control.tipo_campo.nombre) {
            case 'textarea':
              filterColumn = {
                inputClass: 'form-control',
              };
              sort = false;
              break;
            case 'checkbox':
              sort = true;
              filterColumn = {
                inputClass: 'form-control',
                type: 'checkbox',
                config: {
                  true: 'true',
                  false: 'false',
                  resetText: 'Todo',
                },
              };
              break;
            case 'ngSelect':
              sort = true;
              filterColumn = {
                inputClass: 'form-control',
                type: 'list',
                config: {
                  selectText: control.label,
                  list: [],
                },
              };
              break;
            default:
              sort = true;
              filterColumn = {
                inputClass: 'form-control',
              };
              break;
          }
          columns[control.nombre_campo] = {
            editable: false,
            addable: false,
            sort: sort,
            width: sizeColum,
            title: nameColum,
            filter: control.propiedades['sin_filtro'] ? false : filterColumn,
            type: 'custom',
            renderComponent: InputTableComponent,
            onComponentInitFunction(instance: InputTableComponent) {
              if (self.tmpControl && self.tmpControl.alias === control.alias) {
                self.controlTableEditComponent(instance, self.tmpControl, form);
                instance.open(
                  self.tmpControl.alias,
                  self.tmpIndexRow
                );
              } else {
                self.controlTableEditComponent(instance, control, form);
              }
            }
          };
        } else {
          switch (control.tipo_campo.nombre) {
            case 'textarea':
              columns[control.nombre_campo] = {
                editable: false,
                addable: false,
                sort: false,
                width: sizeColum,
                title: nameColum,
                filter: control.propiedades['sin_filtro'] ? false : {
                  inputClass: 'form-control',
                }
              };
              break;
            case 'checkbox':
              columns[control.nombre_campo] = {
                title: nameColum,
                sort: false,
                width: sizeColum,
                filter: control.propiedades['sin_filtro'] ? false : {
                  inputClass: 'form-control',
                  type: 'checkbox',
                  config: {
                    true: 'true',
                    false: 'false',
                    resetText: 'Todo',
                  },
                },
                type: 'custom',
                renderComponent: CheckTableComponent,
              };
              break;
            case 'date-time-picker':
              columns[control.nombre_campo] = {
                title: nameColum,
                sort: true,
                width: sizeColum,
                filter: control.propiedades['sin_filtro'] ? false : {
                  inputClass: 'form-control',
                },
                type: 'custom',
              };
              switch (control.propiedades.tipo) {
                case 'calendar':
                    columns[control.nombre_campo]['renderComponent'] = CalendarRefactoryTableDynamicComponent;
                  break;
                case 'timer':
                  columns[control.nombre_campo]['renderComponent'] = TimerRefactoryTableDynamicComponent;
                  break;
                case 'dateTimer':
                  columns[control.nombre_campo]['renderComponent'] = DateTimerRefactoryTableDynamicComponent;
                  break;
                case 'rangeDate':
                  columns[control.nombre_campo]['renderComponent'] = RangeDateRefactoryTableDynamicComponent;
                  break;
                case 'rangeTime':
                  columns[control.nombre_campo]['renderComponent'] = RangeTimerRefactoryTableDynamicComponent;
                  break;
                default:
                  columns[control.nombre_campo]['renderComponent'] = RangeRefactoryTableDynamicComponent;
                  break;
              }
              break;
            case 'coordenadas':
              columns[control.nombre_campo] = {
                title: nameColum,
                sort: true,
                width: sizeColum,
                filter: control.propiedades['sin_filtro'] ? false : {
                  inputClass: 'form-control',
                },
                type: 'custom',
                renderComponent: CoordinateDynamicFormsComponent,
              };
              break;
            case 'ngSelect':
              columns[control.nombre_campo + '_valor'] = {
                editable: false,
                addable: false,
                sort: true,
                width: sizeColum,
                title: nameColum,
                filter: control.propiedades['sin_filtro'] ? false : {
                  inputClass: 'form-control',
                  type: 'list',
                  config: {
                    selectText: control.label,
                    list: [],
                  },
                },
                type: 'custom',
                renderComponent: LabelNgSelectDynamicTableComponent,
                onComponentInitFunction(instance: LabelNgSelectDynamicTableComponent) {
                  instance.columnsLabel = control.propiedades['columnsSelectorModal'] ?
                                            control.propiedades['columnsSelectorModal']
                                          : [];
                  instance.selectionsColumns = self.validCondictionsColumns(control).columns;
                }
              };
              break;
            case 'number':
              columns[control.nombre_campo] = {
                editable: false,
                addable: false,
                sort: true,
                width: sizeColum,
                title: nameColum,
                filter: control.propiedades['sin_filtro'] ? false : {
                  inputClass: 'form-control',
                },
                type: 'custom',
                renderComponent: ThousandsSeparatorNumberFormatComponent,
                onComponentInitFunction(instance: ThousandsSeparatorNumberFormatComponent) {
                  instance.control = control;
                }
              };
              break;
            default:
              if (control.tipo_campo.nombre !== 'label') {
                if (!form.estilo.hasOwnProperty('tipo')) {
                  columns[control.nombre_campo] = {
                    editable: false,
                    addable: false,
                    sort: true,
                    width: sizeColum,
                    title: nameColum,
                    filter: control.propiedades['sin_filtro'] ? false : {
                      inputClass: 'form-control',
                    },
                  };
                } else {
                  columns[control.nombre_campo] = {
                    editable: false,
                    addable: false,
                    sort: false,
                    title: nameColum,
                    filter: false,
                    type: 'custom',
                    width: '40%',
                    renderComponent: RadioButtonsCheckListComponent,
                    onComponentInitFunction(instance: any) {
                      if (
                        form.estilo['opciones_chequeo'] &&
                        form.estilo['opciones_chequeo'].length
                      ) {
                        instance.options = form.estilo['opciones_chequeo'];
                      }
                      instance.save.subscribe((data: any) => {
                        // controla la seleccion del radioButton
                        self.selectCheckList(data, form);
                      });
                    }
                  };
                }
              }
              break;
          }
        }
      }
    });
    if (!form.estilo.hasOwnProperty('tipo')) {
      columns['acciones'] = {
        title: 'Acciones',
        sort: false,
        filter: false,
        type: 'custom',
        renderComponent: ButtonsAccionDynamicFormsTableComponent,
        onComponentInitFunction(instance: any) {
          instance.save.subscribe((data: any) => {
            // controla el evento click del boton
            self.actionTables(data);
          });
        }
      };
    }
    const settings = {
      mode: 'external',
      noDataMessage: 'No hay datos',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: columns
    };

    return settings;

  }

  /**
   * Controla las acciones de los botones en la tabla
   *
   * @param {*} data
   * @memberof RefactorDynamicFormComponent
   */
  async actionTables(data: any) {
    const row = data.data;
    this.actionTableRow = data.action;
    switch (data.action) {
      case 'eliminar':
        this.rowSelect = row;
        const dt = find(this.dataTable, {id_tabla: this.rowSelect.tabla});
        const form = find(this.form.sub_formas, {id_forma: dt.id_tabla});
        if (dt && form) {
          let deleteRow = 1;
          let formularios = '';
          const dependence = await this.validateRecordDependencyToRemove(
            form,
            dt.valores[this.rowSelect.index]['id'],
            false,
            dt.valores[this.rowSelect.index]
          );
          let valueValid = filter(dependence, {valid: -1});
          if (valueValid.length) {
            deleteRow = -1;
          } else {
            valueValid = filter(dependence, {valid: -0});
            if (valueValid.length) {
              deleteRow = 0;
              valueValid.forEach((validForm, i) => {
                if (i < (valueValid.length - 1)) {
                  if (i > 0) {
                    formularios += ', ';
                  }
                  formularios += validForm.formulario;
                } else {
                  if (i > 0) {
                    formularios += ' y ';
                  }
                  formularios += validForm.formulario;
                }
              });
            }
          }
          if (deleteRow === 1) {
            this.question = '¿Desea eliminar el registro?';
            this.confirmAction.open();
          } else if (deleteRow === 0) {
            this.question = 'Si elimina el registro seleccionado se eliminara la información asociada al registro ' +
                            'en la/s tabla/s: ' + formularios +
                            ' ¿Realmente desea eliminar la información?';
            this.confirmAction.open();
          }
        } else {
          delete this.rowSelect;
        }
        break;
      case 'ver':
      case 'modificar':
        this.updateDataTable(row);
        break;
    }
  }

  /**
   * Elimina el registro de la tabla seleccionado
   *
   * @param {boolean} res
   * @param {boolean} [force=false]
   * @memberof RefactorDynamicFormComponent
   */
  async deleteRowTable(res: boolean) {
    if (res) {
      let saveMunicipality;
      let nameForm = '';
      const dt = find(this.dataTable, {id_tabla: this.rowSelect.tabla});
      const form = find(this.form.sub_formas, {id_forma: dt.id_tabla});
      if (dt && form) {
        if (dt.valores[this.rowSelect.index]['id']) {
          const deleteRow = await this.validateRecordDependencyToRemove(
            form,
            dt.valores[this.rowSelect.index]['id'],
            true,
            dt.valores[this.rowSelect.index]
          );
          // if (deleteRow === 1) {
          //   nameForm = form.alias;
          //   await this.updatedTableFount(dt.valores[this.rowSelect.index], form, null, null, 'delete');
          //   await this.syncDataTable(dt.valores[this.rowSelect.index]['id'], form, {}, 'eliminar');
          //   this.syncDataTablesActually(dt.valores[this.rowSelect.index], form, 'eliminar');
          //   saveMunicipality = this.getSaveMunicipality(form, this.rowSelect, 'delete');
          //   dt.valores.splice(this.rowSelect.index, 1);
          //   this.orderIndexVal(this.rowSelect.tabla, true, nameForm, {}, null, saveMunicipality);
          // }
        }
      }
    }
  }

  /**
   * Valida si el registro a eliminar se encuentra en uso en otra tabla o formulario
   *
   * @param {SubForma} subForm
   * @param {*} value
   * @returns
   * @memberof RefactorDynamicFormComponent
   */
  validateRecordDependencyToRemove(
    subForm: SubForma,
    value: any,
    force: boolean = false,
    row?: any,
    onlyTabs: boolean = false
  ): Promise<{valid: number, formulario: string, tabla: boolean}[]> {
    return new Promise(async (resolve) => {
      let valid = 1;
      let formulario = '';
      const forms: SubForma[] = [];
      const rows: any = {};
      const dependence = this.getDependenceTable(subForm, value, forms, rows, row, onlyTabs);
      if (dependence.length) {
        const formInvalidNotTable = filter(dependence, {valid: -1});
        if (formInvalidNotTable.length) {
          formInvalidNotTable.forEach((validForm, i) => {
            if (i !== (formInvalidNotTable.length - 1)) {
              if (i > 0) {
                formulario += ', ';
              }
              formulario += validForm.formulario;
            } else {
              if (i > 0) {
                formulario += ' y ';
              }
              formulario += validForm.formulario ;
            }
          });
          valid = -1;
        }
      }
      if (formulario && valid === -1 && !onlyTabs) {
        this.toastr.warning(
          'El registro a eliminar esta siendo utilizado en el o los formularios: ' + formulario,
          'Acción no permitida', {
            positionClass: 'toast-top-center'
          }
        );
      } else if (force) {
        await this.deleteRowTableGeneral(forms, rows);
        if (row && !onlyTabs) {
          await this.deleteRowTableEspecific(subForm, row);
        }
      }
      resolve(dependence);
    });
  }

  /**
   * Consulta las diferentes dependencias de la eliminacion en cascada de un registro
   *
   * @param {SubForma} subForm
   * @param {*} value
   * @param {SubForma[]} [forms=[]]
   * @param {*} [rows={}]
   * @param {*} [rowD={}]
   * @returns {{valid: number, formulario: string, tabla: boolean}[]}
   * @memberof RefactorDynamicFormComponent
   */
  getDependenceTable(
    subForm: SubForma,
    value: any,
    forms: SubForma[] = [],
    rows: any = {},
    rowD: any = {},
    onlyTabs: boolean = false
  ): {valid: number, formulario: string, tabla: boolean}[] {
    let valid = 1;
    let formulario = '';
    const formsValid: {valid: number, formulario: string, tabla: boolean}[] = [];
    for (const form of this.form.sub_formas) {
      if (form.id_forma !== subForm.id_forma) {
        form.campos.forEach(field => {
          if (
            !onlyTabs &&
            field.propiedades['cargar_tabla'] &&
            field.propiedades['cargar_tabla']['form'] === this.form.alias &&
            field.propiedades['cargar_tabla']['formulario'] === subForm.alias
          ) {
            if (form.tabla) {
              const data = find(this.dataTable, {id_tabla: form.id_forma});
              if (data && data.valores && data.valores.length) {
                const filterValue = {};
                filterValue[field.nombre_campo] = value;
                const exist = filter(data.valores, filterValue);
                if (exist.length) {
                  const existForm = find(forms, {id_forma: form.id_forma});
                  if (!existForm) {
                    forms.push(form);
                  }
                  if (rows[form.alias]) {
                    exist.forEach(row => {
                      const existRow = find(rows[form.alias], row['id']);
                      if (!existRow) {
                        rows[form.alias].push(row);
                        if (valid === 1) {
                          valid = 0;
                        }
                      }
                    });
                  } else {
                    rows[form.alias] = exist;
                    if (valid === 1) {
                      valid = 0;
                    }
                  }
                  exist.forEach(row => {
                    this.getDependenceTable(form, row['id'], forms, rows, row);
                  });
                }
              }
            } else {
              const ValueField = find(this.data, {alias_formulario: form.alias, nombre_campo: field.nombre_campo});
              if (ValueField && ValueField.valor === value) {
                valid = -1;
                formulario = form.nombre;
              }
            }
          } else if (form.estilo['formulario_pestaña'] === subForm.alias) {
            const controlTab = find(subForm.campos, {alias: form.estilo['columna_pestaña']});
            if (controlTab && rowD[controlTab.nombre_campo] === form.estilo['valor_columna_pestaña']) {
              let formularioPrincipal: {
                name: string;
                form: FormGroup;
                saved?: boolean;
              };
              let controlsGeneralPrincipal: Control[];
              const tabFormulario = find(
                this.form.sub_formas,
                {alias: form.estilo['formulario_pestaña']}
              );
              if (tabFormulario) {
                controlsGeneralPrincipal = filter(
                  tabFormulario.campos,
                  ctrl => ctrl.propiedades['columna_general']
                );
                formularioPrincipal = find(this.formularios, {name: tabFormulario.alias});
              }
              if (form.tabla) {
                const data = find(this.dataTable, {id_tabla: form.id_forma});
                if (data && data.valores && data.valores.length) {
                  const filterValue = {};
                  if (controlsGeneralPrincipal && controlsGeneralPrincipal.length) {
                    controlsGeneralPrincipal.forEach(ctrl => {
                      filterValue[ctrl.nombre_campo] = rowD[ctrl.nombre_campo];
                    });
                  }
                  // ------------------------------------------------------------------------------
                  let exist: any;
                  if (Object.keys(filterValue).length) {
                    exist = filter(data.valores, filterValue);
                  } else {
                    exist = data.valores;
                  }
                  if (exist.length) {
                    const existForm = find(forms, {id_forma: form.id_forma});
                    if (!existForm) {
                      forms.push(form);
                    }
                    if (rows[form.alias]) {
                      exist.forEach((row: any) => {
                        const existRow = find(rows[form.alias], row['id']);
                        if (!existRow) {
                          rows[form.alias].push(row);
                          if (valid === 1) {
                            valid = 0;
                          }
                        }
                      });
                    } else {
                      rows[form.alias] = exist;
                      if (valid === 1) {
                        valid = 0;
                      }
                    }
                    exist.forEach((row: any) => {
                      this.getDependenceTable(form, row['id'], forms, rows, row);
                    });
                  }
                }
              } else {
                const ValueField = find(this.data, {alias_formulario: form.alias, nombre_campo: field.nombre_campo});
                if (ValueField && ValueField.valor === value) {
                  valid = -1;
                  formulario = form.nombre;
                }
              }
            }
          }
          if (!formulario) {
            formulario = form.nombre;
          }
          const exist = findIndex(formsValid, {formulario: formulario});
          if (exist === -1) {
            formsValid.push({
              valid: valid,
              formulario: formulario,
              tabla: form.tabla
            });
          } else {
            if (formsValid[exist].valid === 1 && valid !== -1) {
              formsValid[exist].valid = valid;
            }
          }
          valid = 1;
          formulario = '';
        });
      }
    }
    return formsValid;
  }

  /**
   * Elimina un grupo de registros en especiico
   *
   * @param {SubForma[]} forms
   * @param {*} rows
   * @returns {Promise<number>}
   * @memberof RefactorDynamicFormComponent
   */
  deleteRowTableGeneral(forms: SubForma[], rows: any): Promise<number> {
    return new Promise(async (resolve) => {
      let resultDelete = 0;
      if (forms.length) {
        this.loadingProcess = true;
        this.messaggeLoading = 'Eliminando registros asociados...';
        await Static.asyncForEach(forms, async form => {
          if (rows[form.alias] && rows[form.alias].length) {
            await Static.asyncForEach(rows[form.alias], async (row: any) => {
              if (resultDelete !== -1) {
                resultDelete = await this.deleteRowTableEspecific(form, row);
              }
            });
          }
        }).then(_ => {
          this.loadingProcess = false;
          this.messaggeLoading = '';
        }).catch(error => {
          console.error(error);
          this.loadingProcess = false;
          this.messaggeLoading = '';
          this.toastr.error(
            'Ha ocurrido un error inesperado.',
            'Error de operación',
            {
              positionClass: 'toast-top-center'
            }
          );
        });
      }
      resolve(resultDelete);
    });
  }

  /**
   * Elimina un registro de una tabla en especifico
   *
   * @private
   * @param {SubForma} form
   * @param {*} row
   * @returns {Promise<number>}
   * @memberof RefactorDynamicFormComponent
   */
  private deleteRowTableEspecific(form: SubForma, row: any): Promise<number> {
    return new Promise(async (resolve) => {
      try {
        let saveMunicipality;
        let nameForm = '';
        const dt = find(this.dataTable, {id_tabla: form.id_forma});
        const dtI = findIndex(this.dataTable, {id_tabla: form.id_forma});
        if (dt && form) {
          if (dt.valores[row.index] && dt.valores[row.index]['id']) {
            nameForm = form.alias;
            await this.updatedTableFount(dt.valores[row.index], form, null, null, 'delete');
            await this.syncDataTable(dt.valores[row.index]['id'], form, {}, 'eliminar');
            this.syncDataTablesActually(dt.valores[row.index], form, 'eliminar');
            saveMunicipality = this.getSaveMunicipality(form, row, 'delete');
            dt.valores.splice(row.index, 1);
          }
          if (!dt.valores.length) {
            if (this.dataTable.length > 1) {
              this.dataTable.splice(dtI, 1);
            }
          }
          this.orderIndexVal(form.id_forma, true, nameForm, {}, null, saveMunicipality);
        }
        resolve(1);
      } catch (error) {
        console.error(error);
        resolve(0);
      }
    });
  }

  /**
   * Ordena los regitros de la tabla indicada
   *
   * @param {number} idTable
   * @param {boolean} [save=true]
   * @param {string} [aliasForm]
   * @param {*} [data]
   * @param {string} [aliasChange]
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  orderIndexVal(
    idTable: number,
    save: boolean = true,
    aliasForm?: string,
    data?: any,
    aliasChange?: string,
    saveMunicipality?: any
  ): Promise<boolean> {
    return new Promise(async (resolve) => {
      this.dataTable.forEach(dt => {
        if (dt.id_tabla === idTable) {
          dt.valores.forEach((val, index) => {
            val.index = index;
          });
        }
      });
      if (save) {
        this.purgeDataTable(this.dataTable, saveMunicipality);
        this.rowSelect = null;
      }
      await this.valid();
      this.form.sub_formas.forEach(subForm => {
        if (subForm.id_forma === idTable) {
          if (!subForm.estilo['registro_unico']) {
            if (!subForm.datos) {
              subForm.datos = new LocalDataSource(this.loadingDataTable(idTable));
              // subForm.datos.refresh();
            } else {
              subForm.datos.load(this.loadingDataTable(idTable));
            }
          }
        }
      });
      if (aliasForm) {
        if (this.update) {
          if (aliasChange) {
            await this.validateForm(true, {change: data, controlChanged: aliasChange}, aliasForm, true);
          } else {
            await this.validateForm(true, {change: data}, aliasForm, true);
          }
        } else {
          await this.validateForm(true, data, aliasForm, true);
        }
      } else {
        await this.validateForm();
      }
      await this.refreshForm(false, idTable);
      const subForm = find(this.form.sub_formas, {id_forma: idTable});
      if (subForm.estilo['formulario_pestaña']) {
        const subFormPestana = find(this.form.sub_formas, {alias: subForm.estilo['formulario_pestaña']});
        if (subFormPestana) {
          await this.refreshForm(false, subFormPestana.id_forma);
        }
      }
      resolve(true);
    });
  }

  /**
   * Purga los registros de las tablas eliminando los metadatos
   *
   * @param {TablaDatos[]} table
   * @memberof RefactorDynamicFormComponent
   */
  purgeDataTable(table: TablaDatos[], saveMunicipality?: any) {
    const tableData: TablaDatos[] = Static.copyObjet(table);
    const data: TablaDatos[] = [];
    if (tableData.length) {
      let tmpDataTable: TablaDatos;
      tableData.forEach((dataT, index) => {
        tmpDataTable = {
          id_tabla: dataT.id_tabla,
          nombre: dataT.nombre,
          alias: dataT.alias,
          labels: dataT.labels,
          valueSelects: dataT.valueSelects,
          valores: [],
        };
        dataT.valores.forEach(val => {
          const valor = {};
          Object.keys(val).forEach(ref => {
            valor[ref] = val[ref];
          });
          tmpDataTable.valores.push(valor);
        });

        // Insertar los campos que no son operados y se borraron
        if(this.copyDataTable && this.copyDataTable.length){
          this.copyDataTable.forEach((cdt, dtindex)=>{
            dataT.valores.forEach((val, i)=>{
              cdt.valores.forEach(cdtval=>{
                Object.keys(cdtval).forEach(cdtvalkey=>{
                  if(cdt.alias == dataT.alias){
                    if(cdtval.id == val.id){
                      if(!(Object.prototype.hasOwnProperty.call(val, cdtvalkey))){
                        tmpDataTable.valores[i][cdtvalkey] = cdtval[cdtvalkey];
                        this.dataTable[dtindex].valores[i][cdtvalkey] = cdtval[cdtvalkey];
                      }
                    }
                  }
                })
              })
            })
          })
        }

        data.push(tmpDataTable);
      });
      data.forEach(tableD => {
        tableD.valores.forEach(val => {
          delete val['index'];
          delete val['tabla'];
          delete val['finish'];
          delete val['update'];
          delete val['delete'];
          delete val['block'];
          delete val['ocultar'];
        });
      });
    }
    this.saveDataTable.emit({
      tables: data,
      saveMunicipality: saveMunicipality
    });
    if(this.copyDataTable && this.copyDataTable.length){
      this.copyDataTable.length = 0;
    }
  }

  /**
   * Carga el formulario para agregar un registro a la tabla indicada
   *
   * @param {SubForma} form
   * @memberof RefactorDynamicFormComponent
   */
  async addDataTable(form: SubForma) {
    if (!form.estilo['registro_unico']) {
      this.formSelect = form;
      this.showForms[this.formSelect.alias] = false;
      this.formSelect.formulario = await this.rdffs.getForm(this.formSelect, this.templatesFomr, [], false);
      this.formSelectOnly = {};
      this.onlyOpenForm = {};
      const controlsGeneral = filter(form.campos, ctrl => ctrl.propiedades['columna_general']);
      if (!controlsGeneral.length) {
        this.temporalFormGeneral[form.alias] = {};
      }
      this.updateForm = {};
      if (form.estilo && form.estilo['formulario_modal']) {
        this.openModalForm();
      } else {
        this.addDataForm = true;
        setTimeout(() => {
            this.scrollForm('header-form-table');
            this.showForms[this.formSelect.alias] = true;
            if (!(this.cd as ViewRef).destroyed) {
              this.cd.detectChanges();
            }
          }
        );
      }
      this.update = false;
    } else {
      const formulario = findIndex(this.formularios, {name: form.alias});
      if (formulario !== -1) {
        Object.keys(this.formularios[formulario].form.controls).forEach(key => {
          if (!this.temporalFormGeneral[form.alias][key]) {
            this.formularios[formulario].form.controls[key].setValue(null, {
              onlySelf: false,
              emitEvent: false,
              emitModelToViewChange: true,
              emitViewToModelChange: true
            });
          } else {
            this.formularios[formulario].form.controls[key].setValue(
              this.temporalFormGeneral[form.alias][key], {
              onlySelf: false,
              emitEvent: false,
              emitModelToViewChange: true,
              emitViewToModelChange: true
            });
          }
        });
      }
      this.formSelectOnly[form.alias] = form;
      this.showForms[this.formSelectOnly[form.alias].alias] = false;
      this.formSelectOnly[form.alias].formulario = await this.rdffs.getForm(
        this.formSelectOnly[form.alias],
        this.templatesFomr,
        [],
        true
      );
      this.onlyOpenForm[form.alias] = true;
      this.updateForm[form.alias] = false;
    }
  }

  /**
   * Carga el formulario con la informacion del registro seleccioando para actualizar
   *
   * @param {*} data
   * @memberof RefactorDynamicFormComponent
   */
  async updateDataTable(data: any) {
    const form = find(this.form.sub_formas, {id_forma: data.tabla});
    if (form) {
      if (!form.estilo['registro_unico']) {
        this.formSelect = form;
        this.formSelectOnly = {};
        this.onlyOpenForm = {};
        const controlsGeneral = filter(form.campos, ctrl => ctrl.propiedades['columna_general']);
        if (!controlsGeneral.length) {
          this.temporalFormGeneral[form.alias] = {};
        }
        this.updateForm = {};
      } else {
        this.formSelectOnly[form.alias] = form;
      }
      const formulario = findIndex(this.formularios, {name: form.alias});
      if (formulario !== -1) {
        this.formularios.splice(formulario, 1);
      }
      if (form) {
        this.showForms[form.alias] = false;
        // let existNgSelect = false;
        await this.asyncForEach(form.campos, async (control: Control) => {
          if (control.tipo_campo.nombre === 'ngSelect' && !control.propiedades['columna_general']) {
            if (control.propiedades['tipoSelector'] !== 'EnModal') {
              // existNgSelect = true;
              await this.refresControlForm(form, control, data, true);
            } else {
              this.updatedControlColumns(control, form);
              const idrecord = data[control.nombre_campo];
              if (idrecord) {
                await this.refresControlForm(
                  form,
                  control,
                  data,
                  true,
                  false,
                  false,
                  false,
                  '(' + String(idrecord) + ')'
                );
              }
              control.propiedades['loadData'] = (idrecord?: any) => {
                return new Promise(async (resolve) => {
                  const formGr = find(this.formularios, {name: form.alias});
                  if (formGr) {
                    let ctrl: any;
                    if (idrecord) {
                      ctrl = await this.refresControlForm(
                        form,
                        control,
                        formGr.form.value,
                        false,
                        false,
                        true,
                        false,
                        '(' + String(idrecord) + ')'
                      );
                    } else {
                      ctrl = await this.refresControlForm(
                        form,
                        control,
                        formGr.form.value,
                        false,
                        false,
                        true,
                      );
                    }
                    resolve({
                      data: ctrl.propiedades['dataSelectorModal']
                    });
                  }
                  resolve([]);
                });
              };
            }
          }
        });
        // if (!existNgSelect) {
          form.formulario = await this.rdffs.getForm(form, this.templatesFomr, data, true);
        // }
        this.indexSelectUpdate = data.index;
        if (!form.estilo['registro_unico']) {
          if (form.estilo && form.estilo['formulario_modal']) {
            this.openModalForm();
          } else {
            this.addDataForm = true;
          }
          this.update = true;
        } else {
          this.updateForm[form.alias] = true;
          this.onlyOpenForm[form.alias] = true;
        }
      }
      if (!form.estilo['registro_unico']) {
        setTimeout(() => {
            this.scrollForm('header-form-table');
            this.showForms[form.alias] = true;
            if (!(this.cd as ViewRef).destroyed) {
              this.cd.detectChanges();
            }

          }
        );
      }
    } else {
      log.debug('Formulario de tabla no encontrado. id del formulario: ' + data.tabla ? data.tabla : null, data);
    }
  }

  /**
   * Guarda o atualiza el registro ingresado en el formulario
   *
   * @param {*} data
   * @param {SubForma} form
   * @param {string} [aliasChange]
   * @memberof RefactorDynamicFormComponent
   */
  async sendedTable(data: any, form: SubForma, aliasChange?: string) {
    const valid = this.validDataForm(data, form);
    if (valid) {
      let response = true;
      const next = this.validateUniqueRecords(data, form);
      if ((this.update || this.updateForm[form.alias]) && next) {
        const dt = find(this.dataTable, {id_tabla: form.id_forma});
        const exist = find(dt.valores, data);
        if (!exist) {
          const dependence = await this.validateRecordDependencyToRemove(
            form,
            dt.valores[this.indexSelectUpdate]['id'],
            false,
            dt.valores[this.indexSelectUpdate],
            true
          );
          if (dependence.length) {
            let formulario = '';
            const formInvalidNotTable = filter(dependence, {valid: 0});
            if (formInvalidNotTable.length) {
              formInvalidNotTable.forEach((validForm, i) => {
                if (i !== (formInvalidNotTable.length - 1)) {
                  if (i > 0) {
                    formulario += ', ';
                  }
                  formulario += validForm.formulario;
                } else {
                  if (i > 0) {
                    formulario += ' y ';
                  }
                  formulario += validForm.formulario ;
                }
              });
              response = await this.confirm.new({
                labelConfirm: 'Sí',
                labelDecline: 'No',
                question: 'Si modifica el registro seleccionado se eliminara la información asociada al registro ' +
                          'en la/s pestaña/s: ' + formulario +
                          ' ¿Realmente desea modificar la información?'
              });
              if (response) {
                await this.validateRecordDependencyToRemove(
                  form,
                  dt.valores[this.indexSelectUpdate]['id'],
                  true,
                  dt.valores[this.indexSelectUpdate],
                  true
                );
              }
            }
          }
        }
      }
      if (next && response) {
        const formSelect: SubForma = this.formSelect ?
                                      this.formSelect
                                    : this.formSelectOnly[form.alias] ?
                                      this.formSelectOnly[form.alias]
                                    : null;
        let saveMunicipality: any;
        const shortid = require('shortid');
        if (this.task) {
          let table: TablaDatos;
          let oldData: any;
          const labels: Object = new Object();
          const selects: Object = new Object();
          const dataT: any = {};
          if (!this.update && !this.updateForm[form.alias]) {
            dataT['id'] = shortid.generate();
          }
          formSelect.campos.sort((a, b) => a.orden - b.orden).forEach(field => {
            labels[field.alias] = field.nombre_campo;
            if (field.tipo_campo.nombre === 'ngSelect' && (!this.update && !this.updateForm[form.alias])) {
              let label = null;
              if (field.propiedades['options']) {
                label = result(find(field.propiedades['options'], {value: data[field.nombre_campo]}), 'others');
              }
              selects[field.nombre_campo + '_' + dataT['id']] = label;
            }
          });
          if (!this.update && !this.updateForm[form.alias]) {
            let add = true;

            if (this.dataTable.length > 0) {
              const index = findIndex(this.dataTable, {id_tabla: formSelect.id_forma});
              if (index !== -1) {
                dataT['index'] = this.dataTable[index].valores.length + 1;
                dataT['tabla'] = this.dataTable[index].id_tabla;
                formSelect.campos.forEach(el => {
                  if (el.tipo_campo.nombre === 'coordenadas') {
                    dataT[el.nombre_campo] = {
                      latitud: data[el.nombre_campo + '_latitud'],
                      longitud: data[el.nombre_campo + '_longitud'],
                      altura: data[el.nombre_campo + '_altura']
                    };
                  } else if (el.tipo_campo.nombre === 'date') {
                    const date = new Date(data[el.nombre_campo]);
                    dataT[el.nombre_campo] = new Date(date.toLocaleString('en-CO'));
                  } else {
                    dataT[el.nombre_campo] = data[el.nombre_campo];
                  }
                  if (el.tipo_campo.nombre === 'ngSelect') {
                    let label = null;
                    if (el.propiedades['options']) {
                      label = result(find(el.propiedades['options'], {value: data[el.nombre_campo]}), 'others');
                    }
                    this.dataTable[index].valueSelects[el.nombre_campo + '_' + dataT['id']] = label;
                  }
                });
                this.addGeneralFieldsDataTable(form, dataT);
                this.dataTable[index].valores.push(dataT);
                saveMunicipality = this.getSaveMunicipality(form, data);
                add = false;
                if (dataT) {
                  await this.syncDataTable(dataT, form, selects);
                }
              }
            }
            if (add) {
              dataT['index'] = 1;
              dataT['tabla'] = formSelect.id_forma;
              formSelect.campos.forEach(el => {
                if (el.tipo_campo.nombre === 'coordenadas') {
                  dataT[el.nombre_campo] = {
                    latitud: data[el.nombre_campo + '_latitud'],
                    longitud: data[el.nombre_campo + '_longitud'],
                    altura: data[el.nombre_campo + '_altura']
                  };
                } else {
                  dataT[el.nombre_campo] = data[el.nombre_campo];
                }
              });
              this.addGeneralFieldsDataTable(form, dataT);
              table = {
                id_tabla: formSelect.id_forma,
                nombre: formSelect.nombre,
                alias: formSelect.alias,
                labels: labels,
                valueSelects: selects,
                valores: [dataT]
              };
              this.dataTable.push(table);
              saveMunicipality = this.getSaveMunicipality(form, data);
              if (dataT) {
                await this.syncDataTable(dataT, form, selects);
              }
            }
          } else {
            const indexDataT = findIndex(this.dataTable, {id_tabla: formSelect.id_forma});
            if (indexDataT !== -1) {
              const indexval = findIndex(this.dataTable[indexDataT].valores, {index: this.indexSelectUpdate});
              if (indexval !== -1) {
                dataT['id'] = this.dataTable[indexDataT].valores[indexval]['id'];
                dataT['index'] = this.indexSelectUpdate;
                dataT['tabla'] = formSelect.id_forma;
                formSelect.campos.forEach(el => {
                  if (el.tipo_campo.nombre === 'coordenadas') {
                    dataT[el.nombre_campo] = {
                      latitud: data[el.nombre_campo + '_latitud'],
                      longitud: data[el.nombre_campo + '_longitud'],
                      altura: data[el.nombre_campo + '_altura']
                    };
                  } else {
                    dataT[el.nombre_campo] = data[el.nombre_campo];
                  }
                  if (el.tipo_campo.nombre === 'ngSelect') {
                    let label = null;
                    if (el.propiedades['options']) {
                      label = result(find(el.propiedades['options'], {value: data[el.nombre_campo]}), 'others');
                    } else {
                      label = data[el.nombre_campo + '_valor'];
                    }
                    this.dataTable[indexDataT].valueSelects[el.nombre_campo + '_' + dataT['id']] = label;
                    selects[el.nombre_campo + '_' + dataT['id']] = label;
                  }
                });
                oldData = Static.copyObjet(this.dataTable[indexDataT].valores[indexval]);
                this.addGeneralFieldsDataTable(form, dataT);
                this.dataTable[indexDataT].valores[indexval] = dataT;
                if (dataT) {
                  await this.syncDataTable(dataT, form, selects, 'modificar');
                }
              }
            }
          }
          await this.updatedTableFount(
            dataT,
            form,
            selects,
            oldData,
            (this.update || this.updateForm[form.alias]) ? 'updated' : 'add'
          );
          this.syncDataTablesActually(
            dataT,
            form,
            (this.update || this.updateForm[form.alias]) ? 'modificar' : 'agregar'
          );
        }
        const subForm = find(this.form.sub_formas, {id_forma: formSelect.id_forma});
        if (aliasChange) {
          await this.orderIndexVal(
            formSelect.id_forma,
            true,
            formSelect.alias,
            data,
            aliasChange,
            saveMunicipality
          );
        } else {
          await this.orderIndexVal(formSelect.id_forma, true, formSelect.alias, data, null, saveMunicipality);
        }
        if (!subForm.estilo['registro_unico']) {
          this.closeAddDataTable();
        } else {
          if (!this.updateForm[subForm.alias]) {
            this.updateForm[subForm.alias] = true;
          }
        }
        await this.valid();
        if (subForm) {
          this.tabEdit = subForm.alias;
          await this.refreshForm(false, formSelect.id_forma);
          if (subForm.estilo['formulario_pestaña']) {
            const subFormPestana = find(this.form.sub_formas, {alias: subForm.estilo['formulario_pestaña']});
            if (subFormPestana) {
              await this.refreshForm(false, subFormPestana.id_forma);
            }
          }
        }
        if (subForm.estilo['registro_unico']) {
          this.loadFormOnly(subForm.alias, data);
        }
        if (subForm && subForm.estilo['filtros_maestra'] && subForm.estilo['filtros_maestra'].length) {
          this.loadingFormSelects(subForm, null, true);
        }
      } else if (!next) {
        this.toastr.warning(
          'El registro ya se encuentra agregado',
          'Accion no permitida',
          {
            positionClass: 'toast-top-center'
          }
        );
      } else {
        if (!form.estilo['registro_unico']) {
          this.closeAddDataTable();
        } else {
          if (!this.updateForm[form.alias]) {
            this.updateForm[form.alias] = true;
          }
        }
      }
    }
  }

  /**
   * Agrega los campos generales a la data a registrar en la tabla
   *
   * @param {SubForma} form
   * @param {*} data
   * @memberof RefactorDynamicFormComponent
   */
  addGeneralFieldsDataTable(form: SubForma, data: any) {
    if (form.estilo['formulario_pestaña']) {
      let valuesGeneral = {};
      if (
        this.temporalFormGeneral[form.estilo['formulario_pestaña']] &&
        Object.keys(this.temporalFormGeneral[form.estilo['formulario_pestaña']]).length
      ) {
        valuesGeneral = this.temporalFormGeneral[form.estilo['formulario_pestaña']];
      } else {
        const formularioGeneral = find(this.formularios, {name: form.estilo['formulario_pestaña']});
        if (
          formularioGeneral &&
          formularioGeneral.form &&
          formularioGeneral.form.valid
        ) {
          valuesGeneral = formularioGeneral.form.value;
        }
      }
      if (Object.keys(valuesGeneral).length) {
        Object.keys(valuesGeneral).forEach(key => {
          data[key] = valuesGeneral[key];
        });
      }
    }
  }

  /**
   * Da el valor del formulario guardado
   *
   * @param {string} alias
   * @param {*} data
   * @memberof RefactorDynamicFormComponent
   */
  loadFormOnly(alias: string, data: any) {
    if (
      this.formSelectOnly[alias] &&
      this.formSelectOnly[alias].formulario &&
      this.formSelectOnly[alias].formulario.length
    ) {
      this.formSelectOnly[alias].formulario.forEach((field: BaseControl<any>) => {
        if (field.controlType === 'container') {
          this.updatedField(field['controls'], data);
        } else {
          field.value = data[field.key];
        }
      });
    }
  }

  /**
   * Setea el valor de un campo
   *
   * @param {BaseControl<any>[]} form
   * @param {*} data
   * @memberof RefactorDynamicFormComponent
   */
  updatedField(form: BaseControl<any>[], data: any) {
    if (form.length) {
      form.forEach(field => {
        if (field.controlType === 'container') {
          this.updatedField(field['controls'], data);
        } else {
          field.value = data[field.key];
        }
      });
    }
  }

  /**
   * Retorna el objeto a enviar al guardar el formulario de la tabla para guardar o eliminar el municipio
   * para la jurisdiccion del tramite
   *
   * @param {SubForma} form
   * @param {*} data
   * @param {('add' | 'delete')} [action='add']
   * @returns {*}
   * @memberof RefactorDynamicFormComponent
   */
  getSaveMunicipality(form: SubForma, data: any, action: 'add' | 'delete' = 'add'): any {
    const fieldMunicipality = find(form.campos, field => field.propiedades.hasOwnProperty('guardar_municipio'));
    if (fieldMunicipality) {
      let saveMunicipality;
      switch (action) {
        case 'delete':
          if (data.index === 0) {
            saveMunicipality = {eliminar: true};
          } else {
            if (fieldMunicipality.tipo_campo.nombre === 'ngSelect') {
              const table = find(this.dataTable, {id_tabla: form.id_forma});
              if (table) {
                saveMunicipality = {id_registro: table.valores[data.index - 1][fieldMunicipality.nombre_campo]};
                if (fieldMunicipality.lista_maestra[0].nombre !== Const.NAME_MASTER_TABLE_MUNICIPALITY) {
                  saveMunicipality['columna'] = fieldMunicipality.propiedades['guardar_municipio'] + ' ';
                }
              }
            }
          }
          break;
        default:
          if (fieldMunicipality.tipo_campo.nombre === 'ngSelect') {
            saveMunicipality = {id_registro: data[fieldMunicipality.nombre_campo]};
            if (fieldMunicipality.lista_maestra[0].nombre !== Const.NAME_MASTER_TABLE_MUNICIPALITY) {
              saveMunicipality['columna'] = fieldMunicipality.propiedades['guardar_municipio'] + ' ';
            }
          }
          break;
      }
      return saveMunicipality;
    } else {
      return null;
    }
  }

  /**
   * Se encarga de actualizar las tablas que su fuente de datos depende de una tabla especificada
   *
   * @param {*} dataT
   * @param {SubForma} form
   * @param {*} selects
   * @param {*} [oldData]
   * @param {('add' | 'updated' | 'delete')} [action='add']
   * @memberof RefactorDynamicFormComponent
   */
  updatedTableFount(
    dataT: any,
    form: SubForma,
    selects: any,
    oldData?: any,
    action: 'add' | 'updated' | 'delete' = 'add'
  ): Promise<boolean> {
    return new Promise(async (resolve, _reject) => {
      const tablesD = this.getDependentTablesByLoad(form);
      if (tablesD.length) {
        let fieldsUpdates = {};
        if (action === 'updated') {
          fieldsUpdates = this.getModifiedFields(dataT, oldData, form);
        }
        await Static.asyncForEach(tablesD, async tbl => {
          await this.updateRegisterTableDependentsLoad(
            form,
            tbl,
            dataT,
            fieldsUpdates,
            action,
            selects
          );
        });
      }
      resolve(true);
    });
  }

  /**
   * Función que se encargue de obtener las tablas que tienen fuente de datos
   * de una tabla en especifico.
   *
   * @param {SubForma} table
   * @returns {SubForma[]}
   * @memberof RefactorDynamicFormComponent
   */
  getDependentTablesByLoad(table: SubForma): SubForma[] {
    const subForms = filter(
      this.form.sub_formas,
      subForm => {
        if (
          subForm.estilo.hasOwnProperty('fuente') &&
          Object.keys(subForm.estilo['fuente']).length &&
          (
            subForm.estilo['fuente'].hasOwnProperty('form') &&
            subForm.estilo['fuente']['form'] === this.form.alias
          ) &&
          subForm.estilo['fuente']['formulario'] === table.alias
        ) {
          return subForm;
        }
      }
    );
    return subForms;
  }

  /**
   * Retorna los nombres de campos que se modifican al momento de realizar la modificación del registro de una tabla
   *
   * @param {*} dataT
   * @param {*} oldData
   * @param {SubForma} form
   * @returns {{ [alias: string]: string }}
   * @memberof RefactorDynamicFormComponent
   */
  getModifiedFields(dataT: any, oldData: any, form: SubForma): { [alias: string]: string } {
    const fields: { [alias: string]: string } = {};
    if (Object.keys(dataT).length) {
      Object.keys(dataT).forEach(key => {
        if (dataT[key] !== oldData[key]) {
          const field = find(form.campos, {nombre_campo: key});
          if (field) {
            fields[field.alias] = key;
          }
        }
      });
    }
    return fields;
  }

  /**
   * Aagregar, actualiza o eliminar un registro en especifico de una tabla en especifico
   *
   * @param {SubForma} tableCurrent
   * @param {SubForma} tableDependence
   * @param {*} data
   * @param {*} aliasUpdate
   * @param {('add' | 'updated' | 'delete')} [action='add']
   * @param {*} [selects]
   * @memberof RefactorDynamicFormComponent
   */
  updateRegisterTableDependentsLoad(
    tableCurrent: SubForma,
    tableDependence: SubForma,
    data: any,
    aliasUpdate: any,
    action: 'add' | 'updated' | 'delete' = 'add',
    selects?: any
  ): Promise<boolean> {
    return new Promise(async (resolve, _reject) => {
      const indexDataTable = findIndex(this.dataTable, {alias: tableDependence.alias});
      const allFields: {
        form: string;
        control: string;
      }[] = [];
      const formRefresh: string[] = [];
      let dependenceFields: {
        form: string;
        control: string;
      }[] = [];
      switch (action) {
        case 'updated':
          if (indexDataTable !== -1) {
            const indexValue = findIndex(this.dataTable[indexDataTable].valores, {id: data['id']});
            if (indexValue !== -1) {
              if (aliasUpdate && Object.keys(aliasUpdate).length) {
                const oldData = Static.copyObjet(this.dataTable[indexDataTable].valores[indexValue]);
                await Static.asyncForEach(Object.keys(aliasUpdate), async key => {
                  // tslint:disable-next-line: max-line-length
                  this.dataTable[indexDataTable].valores[indexValue][this.dataTable[indexDataTable].labels[key]] = data[aliasUpdate[key]];
                  const fields = this.dependenciOperations(tableDependence.alias, key);
                  if (selects && Object.keys(selects).length) {
                    if (
                      selects[aliasUpdate[key] + '_' + data['id']] &&
                      // tslint:disable-next-line: max-line-length
                      this.dataTable[indexDataTable].valueSelects[this.dataTable[indexDataTable].labels[key] + '_' + data['id']]
                    ) {
                      // tslint:disable-next-line: max-line-length
                      this.dataTable[indexDataTable].valueSelects[this.dataTable[indexDataTable].labels[key] + '_' + data['id']] = selects[aliasUpdate[key] + '_' + data['id']];
                    }
                  }
                  fields.forEach(field => {
                    const existF = findIndex(allFields, {form: field.form, control: field.control});
                    if (existF === -1) {
                      allFields.push(field);
                    }
                  });
                  await Static.asyncForEach(tableDependence.campos, async field => {
                    if (
                      find(fields, {form: tableDependence.alias, control: field.alias}) &&
                      // tslint:disable-next-line: max-line-length
                      // !this.dataTable[indexDataTable].valores[indexValue][this.dataTable[indexDataTable].labels[field.nombre_campo]] &&
                      field.validaciones.operaciones.length
                    ) {
                      await Static.asyncForEach(field.validaciones.operaciones, async opr => {
                        // tslint:disable-next-line: max-line-length
                        if (!this.dataTable[indexDataTable].valores[indexValue][this.dataTable[indexDataTable].labels[field.nombre_campo]]) {
                          const resultOperaction = await this.executeOperation(
                            tableDependence,
                            field,
                            opr,
                            this.dataTable[indexDataTable].valores[indexValue],
                            this.dataTable[indexDataTable].valueSelects
                          );
                          if (resultOperaction) {
                            // tslint:disable-next-line: max-line-length
                            this.dataTable[indexDataTable].valores[indexValue][this.dataTable[indexDataTable].labels[field.alias]] = resultOperaction;
                            if (field.tipo_campo.nombre === 'ngSelect') {
                              const ctrl = await this.refresControlForm(
                                tableDependence,
                                field,
                                this.dataTable[indexDataTable].valores[indexValue] as any,
                                false,
                                false,
                                true
                              );
                              const vlSelect = result(find(ctrl.propiedades['options'], {value: resultOperaction}), 'others');
                              if (vlSelect) {
                                this.dataTable[indexDataTable].valueSelects[field.nombre_campo + '_' + this.dataTable[indexDataTable].valores[indexValue]['id']] = vlSelect;
                              }
                            }
                          }
                        }
                      });
                    }
                  });
                });
                await this.updatedTableFount(
                  this.dataTable[indexDataTable].valores[indexValue],
                  tableDependence,
                  this.dataTable[indexDataTable].valueSelects,
                  oldData,
                  action
                );
                await this.syncDataTable(
                  this.dataTable[indexDataTable].valores[indexValue],
                  tableDependence,
                  this.dataTable[indexDataTable].valueSelects,
                  'modificar'
                );
                this.syncDataTablesActually(
                  this.dataTable[indexDataTable].valores[indexValue],
                  tableDependence,
                  'modificar'
                );
                this.loadTable(tableDependence);
                dependenceFields = filter(allFields, field => field.form !== tableDependence.alias);
                if (dependenceFields.length) {
                  await Static.asyncForEach(dependenceFields, async field => {
                    if (formRefresh.indexOf(field.form) === -1) {
                      formRefresh.push(field.form);
                      // const field = dependenceFields[0];
                      const form = find(this.formularios, {name: field.form});
                      if (form) {
                        const subFormDependence = find(this.form.sub_formas, {alias: field.form});
                        if (subFormDependence) {
                          await this.refreshFormormulario(subFormDependence.id_forma, subFormDependence.alias);
                        }
                      }
                    }
                  });
                }
              }
            }
          }
          break;
        case 'delete':
          if (indexDataTable !== -1) {
            const indexValue = findIndex(this.dataTable[indexDataTable].valores, {id: data['id']});
            if (indexValue !== -1) {
              await Static.asyncForEach(tableDependence.campos, async field => {
                const fields = this.dependenciOperations(tableDependence.alias, field.alias);
                if (fields.length) {
                  fields.forEach(fieldD => {
                    const existF = findIndex(allFields, {form: fieldD.form, control: fieldD.control});
                    if (existF === -1) {
                      allFields.push(fieldD);
                    }
                  });
                }
              });
              await this.updatedTableFount(
                this.dataTable[indexDataTable].valores[indexValue],
                tableDependence,
                null,
                null,
                'delete'
              );
              await this.syncDataTable(
                this.dataTable[indexDataTable].valores[indexValue]['id'],
                tableDependence,
                {},
                'eliminar'
              );
              this.syncDataTablesActually(
                this.dataTable[indexDataTable].valores[indexValue],
                tableDependence,
                'eliminar'
              );
              this.dataTable[indexDataTable].valores.splice(indexValue, 1);
              this.loadTable(tableDependence);
              dependenceFields = filter(allFields, field => field.form !== tableDependence.alias);
              if (dependenceFields.length) {
                await Static.asyncForEach(dependenceFields, async field => {
                  if (formRefresh.indexOf(field.form) === -1) {
                    formRefresh.push(field.form);
                    // const field = dependenceFields[0];
                    const form = find(this.formularios, {name: field.form});
                    if (form) {
                      const subFormDependence = find(this.form.sub_formas, {alias: field.form});
                      if (subFormDependence) {
                        await this.refreshFormormulario(subFormDependence.id_forma, subFormDependence.alias);
                      }
                    }
                  }
                });
              }
            }
          }
          break;
        default:
          const dataNew = {
            id: data['id']
          };
          const valueSelects = {};
          tableDependence.campos.forEach(field => {
            const fieldLoad = find(tableCurrent.campos, {alias: field.alias});
            if (fieldLoad) {
              dataNew[field.nombre_campo] = data[fieldLoad.nombre_campo];
              if (selects && Object.keys(selects).length) {
                if (selects[fieldLoad.nombre_campo + '_' + data['id']]) {
                  // tslint:disable-next-line: max-line-length
                  valueSelects[field.nombre_campo + '_' + data['id']] = selects[fieldLoad.nombre_campo + '_' + data['id']];
                }
              }
            }
          });
          await Static.asyncForEach(tableDependence.campos, async field => {
            const fields = this.dependenciOperations(tableDependence.alias, field.alias);
            if (fields.length) {
              fields.forEach(fieldD => {
                const existF = findIndex(allFields, {form: fieldD.form, control: fieldD.control});
                if (existF === -1) {
                  allFields.push(fieldD);
                }
              });
            }
            if (!dataNew[field.nombre_campo] && field.validaciones.operaciones.length) {
              await Static.asyncForEach(field.validaciones.operaciones, async opr => {
                if (!dataNew[field.nombre_campo]) {
                  const resultOperaction = await this.executeOperation(
                    tableDependence,
                    field,
                    opr,
                    dataNew,
                    valueSelects
                  );
                  if (resultOperaction) {
                    dataNew[field.nombre_campo] = resultOperaction;
                    if (field.tipo_campo.nombre === 'ngSelect') {
                      const ctrl = await this.refresControlForm(
                        tableDependence,
                        field,
                        dataNew as any,
                        false,
                        false,
                        true
                      );
                      const vlSelect = result(find(ctrl.propiedades['options'], {value: resultOperaction}), 'others');
                      if (vlSelect) {
                        valueSelects[field.nombre_campo + '_' + dataNew['id']] = vlSelect;
                      }
                    }
                  }
                }
              });
            }
          });
          if (indexDataTable !== -1) {
            this.dataTable[indexDataTable].valores.push(dataNew);
            if (valueSelects && Object.keys(valueSelects).length) {
              Object.keys(valueSelects).forEach(key => {
                this.dataTable[indexDataTable].valueSelects[key] = valueSelects[key];
              });
            }
          } else {
            const dataTable: TablaDatos = ({
              alias: tableDependence.alias,
              nombre: tableDependence.nombre,
              id_tabla: tableDependence.id_forma,
              labels: {},
              valores: [
                dataNew
              ],
              valueSelects: valueSelects,
            });
            tableDependence.campos.forEach(field => {
              dataTable.labels[field.alias] = field.nombre_campo;
            });
            this.dataTable.push(dataTable);
          }
          await this.updatedTableFount(
            dataNew,
            tableDependence,
            valueSelects,
            null,
            action
          );
          await this.syncDataTable(
            dataNew,
            tableDependence,
            valueSelects,
            'agregar'
          );
          this.syncDataTablesActually(
            dataNew,
            tableDependence,
            'agregar'
          );
          this.loadTable(tableDependence);
          dependenceFields = filter(allFields, field => field.form !== tableDependence.alias);
          if (dependenceFields.length) {
            await Static.asyncForEach(dependenceFields, async field => {
              if (formRefresh.indexOf(field.form) === -1) {
                formRefresh.push(field.form);
                // const field = dependenceFields[0];
                const form = find(this.formularios, {name: field.form});
                if (form) {
                  const subFormDependence = find(this.form.sub_formas, {alias: field.form});
                  if (subFormDependence) {
                    await this.refreshFormormulario(subFormDependence.id_forma, subFormDependence.alias);
                  }
                }
              }
            });
          }
          break;
      }
      resolve(true);
    });
  }

  /**
   * Actuaiza los datos de una tabla luego de actualizar la fuente de datos
   *
   * @param {SubForma} tableDependence
   * @memberof RefactorDynamicFormComponent
   */
  loadTable(tableDependence: SubForma) {
    const d: any = this.loadingDataTable(tableDependence.id_forma, true);
    tableDependence.datos = new LocalDataSource(d);
    tableDependence.datos.refresh();
  }

  /**
   * Cerrar formulario para agregar registro en tabla de forma
   *
   * @param {string} [alias]
   * @memberof RefactorDynamicFormComponent
   */
  closeAddDataTable(alias?: string) {
    let indexFormulario = -1;
    if (this.formSelect) {
      indexFormulario = findIndex(this.formularios, {name: this.formSelect.alias});
    } else {
      indexFormulario = findIndex(this.formularios, {name: alias});
    }
    if (indexFormulario !== -1) {
      const form = find(this.form.sub_formas, {alias: this.formularios[indexFormulario].name});
      const controlsGeneral = filter(form.campos, ctrl => ctrl.propiedades['columna_general']);
      if (form && (form.estilo['registro_unico'] || controlsGeneral.length)) {
        Object.keys(this.formularios[indexFormulario].form.controls).forEach(key => {
          if (!this.temporalFormGeneral[form.alias][key]) {
            this.formularios[indexFormulario].form.controls[key].setValue(null, {
              onlySelf: false,
              emitEvent: false,
              emitModelToViewChange: true,
              emitViewToModelChange: true
            });
            this.formularios[indexFormulario].form.removeControl(key);
          } else {
            this.formularios[indexFormulario].form.controls[key].setValue(
              this.temporalFormGeneral[form.alias][key], {
              onlySelf: false,
              emitEvent: false,
              emitModelToViewChange: true,
              emitViewToModelChange: true
            });
          }
        });
      } else {
        this.formularios.splice(indexFormulario, 1);
      }
    }
    this.dataForm.forEach((formulario, index) => {
      if (this.formSelect && formulario.name === this.formSelect.alias) {
        this.dataForm.splice(index, 1);
      } else if (this.formSelectOnly[alias] && formulario.name === this.formSelectOnly[alias].alias) {
        this.dataForm.splice(index, 1);
      }
    });
    if (this.formSelect && this.formSelect.estilo && this.formSelect.estilo['formulario_modal']) {
      this.closeModalForm();
    } else {
      this.addDataForm = false;
    }
    if (this.formSelect) {
      // this.loadFormControlsGeneral(this.formSelect);
      if (this.formSelect.estilo['formulario_pestaña']) {
        this.tableScroll = this.formSelect.estilo['formulario_pestaña'];
      } else {
        this.tableScroll = this.formSelect.alias;
      }
      delete this.formSelect;
    } else if (alias) {
      if (this.formSelectOnly[alias] && this.formSelectOnly[alias].estilo['formulario_pestaña']) {
        this.tableScroll = this.formSelectOnly[alias].estilo['formulario_pestaña'];
      } else {
        this.tableScroll = alias;
      }
      delete this.showForms[alias];
      delete this.formSelectOnly[alias];
    }
    if (!alias) {
      this.update = false;
      if (this.tableUpdate) {
        this.tableUpdate = false;
      }
      this.actionTableRow = '';
    } else {
      this.updateForm[alias] = false;
      this.onlyOpenForm[alias] = false;
    }
    setTimeout(() => {
       this.scrollForm(this.tableScroll);
       this.tableScroll = '';
      }
    );
  }

  /**
   * Retorna los datos de la tabla indicada
   *
   * @param {number} idForm
   * @param {boolean} [updateIndex=false]
   * @param {boolean} [validTabs=true]
   * @returns {*}
   * @memberof RefactorDynamicFormComponent
   */
  loadingDataTable(idForm: number, updateIndex: boolean = false, validTabs: boolean = true): any {
    let tbl: TablaDatos;
    const valor: Array<any> = [];
    const subForm = find(this.form.sub_formas, {id_forma: idForm});
    this.columnsUpdateInTable(subForm);
    if (this.dataTable) {
      tbl = find(this.dataTable, {id_tabla: idForm});
      if (tbl) {
        tbl.valores.forEach((val, i) => {
          if (updateIndex) {
            val.index = i;
          }
          let valid = false;
          if (subForm && subForm.estilo['tipo'] === 'TablaMaestra') {
            if (
              subForm.estilo['registros_especificos'] &&
              subForm.estilo['registros_especificos'].length
            ) {
              const indexRow = subForm.estilo['registros_especificos'].indexOf(val['id_registro']);
              if (indexRow !== -1) {
                valid = true;
              } else {
                if (!val['ocultar']) {
                  valid = true;
                }
              }
            } else {
              valid = true;
            }
          } else {
            valid = true;
          }
          if (valid) {
            if (!val['ocultar']) {
              valor.push(val);
            }
          }
        });
      }
      if (valor && valor.length) {
        valor.forEach(val => {
          Object.keys(val).forEach(el => {
            if (tbl.valueSelects[el + '_' + val.id]) {
              val[el + '_valor'] = tbl.valueSelects[el + '_' + val.id];
            }
          });
        });
      }
    }
    if (valor) {
      for (let index = 0; index < valor.length; index++) {
        valor[index]['finish'] = this.finishTask;
        if (subForm) {
          if (subForm.estilo['modificar'] && this.updateInTable === false) {
            valor[index]['update'] = subForm.estilo['modificar'];
          } else {
            valor[index]['update'] = false;
          }
          if (subForm.estilo['eliminar']) {
            valor[index]['delete'] = subForm.estilo['eliminar'];
          } else {
            valor[index]['delete'] = false;
          }
        }
        if (!valor[index]['index']) {
          valor[index]['index'] = index;
        }
        if (!valor[index]['tabla']) {
          valor[index]['tabla'] = idForm;
        }
      }
    }
    this.loadOptionsColumnSelect(subForm);
    if (
      tbl &&
      subForm.estilo['condiciones_columnas'] &&
      subForm.estilo['condiciones_columnas'].length
    ) {
      this.runCondictionsColumnsTable(subForm, 'No eliminar registro', tbl, valor);
    }
    const controlsGeneral = filter(subForm.campos, ctrl => ctrl.propiedades['columna_general']);
    if (validTabs && tbl && !controlsGeneral.length) {
      this.validTabsVisible(subForm, tbl, tbl.valores);
    }
    return valor;
  }

  /**
   * Valida las pestañas visibles segun los valores de la tabla principal
   *
   * @param {SubForma} subForm
   * @param {TablaDatos} dataTable
   * @param {*} values
   * @memberof RefactorDynamicFormComponent
   */
  validTabsVisible(subForm: SubForma, dataTable: TablaDatos, values: any) {
    const tabs = filter(this.form.sub_formas, f => f.estilo['formulario_pestaña'] === subForm.alias);
      if (tabs.length && dataTable) {
        const visible = {};
        tabs.forEach(tab => {
          const dataFilter = {};
          dataFilter[dataTable.labels[tab.estilo['columna_pestaña']]] = tab.estilo['valor_columna_pestaña'];
          const exist = filter(values, dataFilter);
          const v = {};
          if (exist.length) {
            v['visible'] = true;
          } else {
            v['visible'] = false;
          }
          visible[tab.alias] = v;
        });
        this.tabsVisible[subForm.alias] = visible;
        // if (!(this.cd as ViewRef).destroyed) {
        //   this.cd.detectChanges();
        // }
      }
  }

  /**
   * Abre el modal de mapoteca con las cordenadas ingresadas
   *
   * @param {*} data
   * @memberof RefactorDynamicFormComponent
   */
  openMapoteca (data: any) {
    let coordinates = '';
    const nombreCampo: string = data[0];
    const form: FormGroup = data[1];

    const latitud = String(form.controls[nombreCampo + '_latitud'].value);
    const longitud = String(form.controls[nombreCampo + '_longitud'].value);
    const altura = String(form.controls[nombreCampo + '_altura'].value);

    if (latitud && longitud) {
      coordinates = '?tokenCITA=0&geometria=POINT(';
      coordinates += latitud + ' ' + longitud;
      if (altura) {
        // coordinates += ' ' + altura;
      }
      coordinates += ')';
    }

    this.urlViewMapoteca = this.urlMapoteca + coordinates;

    this.modalRefMapoteca = this.modalService.show(this.mapoteca, { class: 'modal-lg'});
  }

  /**
   * Cierra la modal de mapoteca
   *
   * @memberof RefactorDynamicFormComponent
   */
  closeMapoteca () {
    this.urlViewMapoteca = '';
    this.modalRefMapoteca.hide();
  }

  /**
   * Ejecuta las condiciones generales de la forma para los formularios
   *
   * @param {boolean} [allValidactions=true]
   * @param {*} [data]
   * @param {string} [nameForm]
   * @param {boolean} [changeUser=false]
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  validateForm(
    allValidactions: boolean = true,
    data?: any,
    nameForm?: string,
    changeUser: boolean = false
  ): Promise<boolean> {
    return new Promise(async (resolve, _reject) => {
      if (this.form.condiciones && !this.updateCondictions && this.formularios.length) {
        let indexDataForm = -1;
        if (nameForm) {
          // Encapsula enl nombre de la forma donde se ejecuto el cambio
          this.nameFormChange = nameForm;
          const indexForm = findIndex(this.formularios, {name: nameForm});
          if (indexForm !== -1) {
            if (this.formularios[indexForm].saved) {
              this.formularios[indexForm].saved = false;
              if (!(this.cd as ViewRef).destroyed) {
                this.cd.detectChanges();
              }
              this.valid();
            }
          }
          // Define si ya e encuentra encapsulado el formulario
          let exist = false;
          if (this.dataForm.length) {
            indexDataForm = findIndex(this.dataForm, {name: nameForm});
            // Se valida que en los formularios encapsulados se encuentre
            // el formulario en el que se realizo la modificacion
            if (indexDataForm !== -1) {
              // Se recorre cada campo para detectar en cual se realizo el cambio y registrarlo
              // a el formulario encapsulado
              this.dataForm[indexDataForm].data = data;
              this.dataForm[indexDataForm].nameChange = null;
              if (data.controlChanged) {
                const subForm = find(this.form.sub_formas, {alias: this.nameFormChange});
                if (subForm) {
                  const field = find(subForm.campos, {nombre_campo: data.controlChanged});
                  if (field) {
                    this.dataForm[indexDataForm].nameChange = field.alias;
                  }
                }
              } else if (
                data.change &&
                Object.keys(data.change).length &&
                this.dataForm[indexDataForm].data.change &&
                Object.keys(this.dataForm[indexDataForm].data.change).length
              ) {
                for (const nameField of Object.keys(data.change)) {
                  if (data.change[nameField] !== this.dataForm[indexDataForm].data.change[nameField]) {
                    let field: Control;
                    for (const subForm of this.form.sub_formas) {
                      field = find(subForm.campos, {nombre_campo: nameField});
                      if (field) {
                        break;
                      }
                    }
                    if (field) {
                      this.dataForm[indexDataForm].nameChange = field.alias;
                      break;
                    }
                  }
                }
              }
              exist = true;
            }
          }
          // De no estar encapsulado el formulario se encapsula
          if (!exist) {
            if (data.controlChanged) {
              const subForm = find(this.form.sub_formas, {alias: this.nameFormChange});
              if (subForm) {
                const field = find(subForm.campos, {nombre_campo: data.controlChanged});
                if (field) {
                  this.dataForm.push({
                    name: nameForm,
                    data: data,
                    nameChange: field.alias
                  });
                } else {
                  this.dataForm.push({
                    name: nameForm,
                    data: data
                  });
                }
              } else {
                this.dataForm.push({
                  name: nameForm,
                  data: data
                });
              }
            } else {
              this.dataForm.push({
                name: nameForm,
                data: data
              });
            }
          }
        }
        this.updateCondictions = true;
        let valBlock = true;
        let valUnlock = true;
        let valView = true;
        let valHide = true;
        let assignValue = true;
        let valReading = true;
        let valWriting = true;
        let firstBlock = true;
        let firstUnlock = true;
        let firstView = true;
        let firstHide = true;
        let firstReading = true;
        let firstWriting = true;
        let firstAssignValue = true;
        let operactorNext = 'O';
        for (const condiction of this.form.condiciones) {
          let date = false;
          let comply = false;
          let dependence: FormGroup;
          let condictional: FormGroup;
          let existFieldValidactions = false;
          let formularioCondictional: SubForma;
          let fieldInit: Control;
          let fieldCondictional: Control;
          let formulariosInit: SubForma;
          let associationForm: TareaAsociacion;
          let existCondiction = false;
          let valor: any;
          const moment = require('moment');
          if (!Number(condiction.valor)) {
            if (condiction.valor &&  moment(new Date(String(condiction.valor))).isValid()) {
              date = true;
            } else if (condiction.fechaActual) {
              condiction.valor = new Date();
              date = true;
            } else {
              date = false;
            }
          } else {
            date = false;
          }
          if (condiction.formaInicia === this.form.alias) {
            formulariosInit = find(this.form.sub_formas, {alias: condiction.formularioInicia});
          } else {
            if (this.taskActually && this.taskActually.tarea_asociacion && this.taskActually.tarea_asociacion.length) {
              this.taskActually.tarea_asociacion.forEach(association => {
                if (association.alias === condiction.formaInicia) {
                  associationForm = association;
                }
              });
            }
          }
            if (formulariosInit && !formulariosInit.tabla) {
              fieldInit = find(formulariosInit.campos, {alias: condiction.campoInicia});
              if (fieldInit) {
                dependence = result(find(this.formularios, {name: formulariosInit.alias}), 'form');
                if (dependence) {
                  if (fieldInit.tipo_campo.nombre === 'number' && fieldInit.propiedades['separadorMiles']) {
                    valor = Number(Static.numberFormatWithoutThousandsSeparator(
                      dependence.controls[fieldInit.nombre_campo].value,
                      fieldInit.propiedades['separadorMiles'],
                      fieldInit.propiedades['separadorDecimales']
                    ));
                    existCondiction = true;
                  } else if (dependence.controls[fieldInit.nombre_campo]) {
                    existCondiction = true;
                    valor = dependence.controls[fieldInit.nombre_campo].value;
                  }
                }
              }
            } else if (associationForm) {
              if (associationForm.datos && associationForm.datos.length) {
                associationForm.datos.forEach(dataV => {
                  if (
                    dataV.alias_formulario === condiction.formularioInicia &&
                    dataV.alias === condiction.campoInicia
                  ) {
                    existCondiction = true;
                    valor = dataV.valor;
                  }
                });
              }
            }
            if (!valor) {
              existCondiction = true;
              valor = null;
            }
            if (existCondiction) {
              formularioCondictional = find(this.form.sub_formas, {alias: condiction.formularioCondicionado});
              if (formularioCondictional) {
                condictional = result(find(this.formularios, {name: formularioCondictional.alias}), 'form');
                if (condiction.campoCondicionado) {
                  fieldCondictional = find(
                    formularioCondictional.campos,
                    {alias: condiction.campoCondicionado}
                  );
                  if (fieldCondictional) {
                    if (condictional) {
                      existFieldValidactions = true;
                    }
                  }
                } else {
                  if (condictional || formularioCondictional.tabla) {
                    existFieldValidactions = true;
                  }
                }
              }
            }
            if (existFieldValidactions) {
              if (condiction.siEs === 'Vacio' || valor) {
                switch (condiction.siEs) {
                  case 'Vacio':
                    if (
                      !valor ||
                      valor === ''
                    ) {
                      comply = true;
                    } else {
                      comply = false;
                    }
                    break;
                  case 'Diferente':
                    if (!date) {
                      if (String(valor).toLowerCase() !== String(condiction.valor).toLowerCase()) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    } else {
                      let dtValorControl: Date = null;
                      if (fieldInit && fieldInit.tipo_campo.nombre === 'date-time-picker') {
                        let valorCondiction: string = null;
                        let valorControl: string = null;
                        const dtValor: Date = new Date(condiction.valor);
                        switch (fieldInit.propiedades && fieldInit.propiedades['tipo']) {
                          case 'calendar':
                            valorCondiction = dtValor.toLocaleDateString();
                            dtValorControl = new Date(valor);
                            if (moment(dtValorControl).isValid()) {
                              valorControl = dtValorControl.toLocaleDateString();
                            }
                            break;
                          case 'timer':
                            dtValor.setSeconds(0, 0);
                            valorCondiction = dtValor.toLocaleTimeString();
                            dtValorControl = new Date(valor);
                            if (moment(dtValorControl).isValid()) {
                              dtValorControl.setSeconds(0, 0);
                              valorControl = dtValorControl.toLocaleTimeString();
                            }
                            break;
                          default:
                            dtValor.setSeconds(0, 0);
                            valorCondiction = dtValor.toLocaleDateString();
                            valorCondiction += ' ' + dtValor.toLocaleTimeString();
                            dtValorControl = new Date(valor);
                            if (moment(dtValorControl).isValid()) {
                              dtValorControl.setSeconds(0, 0);
                              valorControl = dtValorControl.toLocaleDateString();
                              valorControl += ' ' + dtValorControl.toLocaleTimeString();
                            }
                            break;
                        }
                        if (valorControl !== valorCondiction) {
                          comply = true;
                        } else {
                          comply = false;
                        }
                      } else {
                        dtValorControl = new Date(valor);
                        // tslint:disable-next-line:max-line-length
                        if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() !== new Date(condiction.valor).toLocaleDateString()) {
                          comply = true;
                        } else {
                          comply = false;
                        }
                      }
                    }
                    break;
                  case 'Mayor a':
                    if (!date) {
                      if (Number(valor) > Number(condiction.valor)) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    } else {
                      let dtValorControl: Date = null;
                      let valorCondiction: Date = null;
                      valorCondiction = new Date(condiction.valor);
                      dtValorControl = new Date(valor);
                      if (fieldInit && fieldInit.tipo_campo.nombre === 'date-time-picker') {
                        switch (fieldInit.propiedades && fieldInit.propiedades['tipo']) {
                          case 'calendar':
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                                dtValorControl.setHours(0, 0, 0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setHours(0, 0, 0, 0);
                            }
                            break;
                          case 'timer':
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                              dtValorControl.setDate(new Date().getDate());
                              dtValorControl.setMonth(new Date().getMonth());
                              dtValorControl.setFullYear(new Date().getFullYear());
                              dtValorControl.setSeconds(0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setDate(new Date().getDate());
                              valorCondiction.setMonth(new Date().getMonth());
                              valorCondiction.setFullYear(new Date().getFullYear());
                              valorCondiction.setSeconds(0, 0);
                            }
                            break;
                          default:
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                              dtValorControl.setSeconds(0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setSeconds(0, 0);
                            }
                            break;
                        }
                      } else {
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                            dtValorControl.setHours(0, 0, 0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setHours(0, 0, 0, 0);
                        }
                      }
                      // Operacion
                      if (
                        (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                        (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                        dtValorControl > valorCondiction
                      ) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    }
                    break;
                  case 'Mayor o igual a':
                    if (!date) {
                      if (Number(valor) >= Number(condiction.valor)) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    } else {
                      let dtValorControl: Date = null;
                      let valorCondiction: Date = null;
                      valorCondiction = new Date(condiction.valor);
                      dtValorControl = new Date(valor);
                      if (fieldInit && fieldInit.tipo_campo.nombre === 'date-time-picker') {
                        switch (fieldInit.propiedades && fieldInit.propiedades['tipo']) {
                          case 'calendar':
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                                dtValorControl.setHours(0, 0, 0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setHours(0, 0, 0, 0);
                            }
                            break;
                          case 'timer':
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                              dtValorControl.setDate(new Date().getDate());
                              dtValorControl.setMonth(new Date().getMonth());
                              dtValorControl.setFullYear(new Date().getFullYear());
                              dtValorControl.setSeconds(0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setDate(new Date().getDate());
                              valorCondiction.setMonth(new Date().getMonth());
                              valorCondiction.setFullYear(new Date().getFullYear());
                              valorCondiction.setSeconds(0, 0);
                            }
                            break;
                          default:
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                              dtValorControl.setSeconds(0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setSeconds(0, 0);
                            }
                            break;
                        }
                      } else {
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                            dtValorControl.setHours(0, 0, 0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setHours(0, 0, 0, 0);
                        }
                      }
                      // Operacion
                      if (
                        (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                        (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                        dtValorControl >= valorCondiction
                      ) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    }
                    break;
                  case 'Menor a':
                    if (!date) {
                      if (Number(valor) < Number(condiction.valor)) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    } else {
                      let dtValorControl: Date = null;
                      let valorCondiction: Date = null;
                      valorCondiction = new Date(condiction.valor);
                      dtValorControl = new Date(valor);
                      if (fieldInit && fieldInit.tipo_campo.nombre === 'date-time-picker') {
                        switch (fieldInit.propiedades && fieldInit.propiedades['tipo']) {
                          case 'calendar':
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                                dtValorControl.setHours(0, 0, 0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setHours(0, 0, 0, 0);
                            }
                            break;
                          case 'timer':
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                              dtValorControl.setDate(new Date().getDate());
                              dtValorControl.setMonth(new Date().getMonth());
                              dtValorControl.setFullYear(new Date().getFullYear());
                              dtValorControl.setSeconds(0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setDate(new Date().getDate());
                              valorCondiction.setMonth(new Date().getMonth());
                              valorCondiction.setFullYear(new Date().getFullYear());
                              valorCondiction.setSeconds(0, 0);
                            }
                            break;
                          default:
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                              dtValorControl.setSeconds(0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setSeconds(0, 0);
                            }
                            break;
                        }
                      } else {
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                            dtValorControl.setHours(0, 0, 0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setHours(0, 0, 0, 0);
                        }
                      }
                      // Operacion
                      if (
                        (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                        (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                        dtValorControl < valorCondiction
                      ) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    }
                    break;
                  case 'Menor o igual a':
                    if (!date) {
                      if (Number(valor) <= Number(condiction.valor)) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    } else {
                      let dtValorControl: Date = null;
                      let valorCondiction: Date = null;
                      valorCondiction = new Date(condiction.valor);
                      dtValorControl = new Date(valor);
                      if (fieldInit && fieldInit.tipo_campo.nombre === 'date-time-picker') {
                        switch (fieldInit.propiedades && fieldInit.propiedades['tipo']) {
                          case 'calendar':
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                                dtValorControl.setHours(0, 0, 0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setHours(0, 0, 0, 0);
                            }
                            break;
                          case 'timer':
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                              dtValorControl.setDate(new Date().getDate());
                              dtValorControl.setMonth(new Date().getMonth());
                              dtValorControl.setFullYear(new Date().getFullYear());
                              dtValorControl.setSeconds(0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setDate(new Date().getDate());
                              valorCondiction.setMonth(new Date().getMonth());
                              valorCondiction.setFullYear(new Date().getFullYear());
                              valorCondiction.setSeconds(0, 0);
                            }
                            break;
                          default:
                            if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                              dtValorControl.setSeconds(0, 0);
                            }
                            if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                              valorCondiction.setSeconds(0, 0);
                            }
                            break;
                        }
                      } else {
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                            dtValorControl.setHours(0, 0, 0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setHours(0, 0, 0, 0);
                        }
                      }
                      // Operacion
                      if (
                        (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                        (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                        dtValorControl <= valorCondiction
                      ) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    }
                    break;
                  default:
                    if (!date) {
                      if (String(valor).toLowerCase() === String(condiction.valor).toLowerCase()) {
                        comply = true;
                      } else {
                        comply = false;
                      }
                    } else {
                      let dtValorControl: Date = null;
                      if (fieldInit && fieldInit.tipo_campo.nombre === 'date-time-picker') {
                        let valorCondiction: string = null;
                        let valorControl: string = null;
                        const dtValor: Date = new Date(condiction.valor);
                        switch (fieldInit.propiedades && fieldInit.propiedades['tipo']) {
                          case 'calendar':
                            valorCondiction = dtValor.toLocaleDateString();
                            dtValorControl = new Date(valor);
                            if (moment(dtValorControl).isValid()) {
                              valorControl = dtValorControl.toLocaleDateString();
                            }
                            break;
                          case 'timer':
                            dtValor.setSeconds(0, 0);
                            valorCondiction = dtValor.toLocaleTimeString();
                            dtValorControl = new Date(valor);
                            if (moment(dtValorControl).isValid()) {
                              dtValorControl.setSeconds(0, 0);
                              valorControl = dtValorControl.toLocaleTimeString();
                            }
                            break;
                          default:
                            dtValor.setSeconds(0, 0);
                            valorCondiction = dtValor.toLocaleDateString();
                            valorCondiction += ' ' + dtValor.toLocaleTimeString();
                            dtValorControl = new Date(valor);
                            if (moment(dtValorControl).isValid()) {
                              dtValorControl.setSeconds(0, 0);
                              valorControl = dtValorControl.toLocaleDateString();
                              valorControl += ' ' + dtValorControl.toLocaleTimeString();
                            }
                            break;
                        }
                        if (valorControl === valorCondiction) {
                          comply = true;
                        } else {
                          comply = false;
                        }
                      } else {
                        dtValorControl = new Date(valor);
                        // tslint:disable-next-line:max-line-length
                        if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() === new Date(condiction.valor).toLocaleDateString()) {
                          comply = true;
                        } else {
                          comply = false;
                        }
                      }
                    }
                    break;
                }
              }
              switch (condiction.accion) {
                case 'Desbloquear':
                  if (!firstUnlock) {
                    if (!operactorNext || operactorNext === 'O') {
                      if (valUnlock || comply) {
                        valUnlock = true;
                      } else {
                        valUnlock = false;
                      }
                    } else {
                      if (valUnlock && comply) {
                        valUnlock = true;
                      } else {
                        valUnlock = false;
                      }
                    }
                    operactorNext = condiction.operadorCondicion;
                  } else {
                    firstUnlock = false;
                    firstBlock = true;
                    firstView = true;
                    firstHide = true;
                    firstReading = true;
                    firstWriting = true;
                    firstAssignValue = true;
                    valUnlock = comply;
                    operactorNext = condiction.operadorCondicion;
                  }
                  if (!this.finishTask) {
                    this.form.sub_formas.forEach(form => {
                        if (form.alias === condiction.formularioCondicionado && condictional) {
                          if (!condiction.campoCondicionado) {
                            if (valUnlock) {
                              condictional.enable();
                            } else {
                              condictional.disable();
                              condictional.reset();
                            }
                          } else {
                            form.campos.forEach(field => {
                              if (field.alias === condiction.campoCondicionado && field.tipo_campo.nombre !== 'label') {
                                if (valUnlock) {
                                  condictional.controls[fieldCondictional.nombre_campo].enable();
                                } else {
                                  condictional.controls[fieldCondictional.nombre_campo].disable();
                                  if (fieldCondictional.propiedades['default']) {
                                    // tslint:disable-next-line: max-line-length
                                    condictional.controls[fieldCondictional.nombre_campo].setValue(fieldCondictional.propiedades['default']);
                                  } else {
                                    condictional.controls[fieldCondictional.nombre_campo].reset();
                                  }
                                }
                              }
                            });
                          }
                        }
                    });
                  }
                  break;
                case 'Lectura':
                if (!firstReading) {
                  if (!operactorNext || operactorNext === 'O') {
                    if (valReading || comply) {
                      valReading = true;
                    } else {
                      valReading = false;
                    }
                  } else {
                    if (valReading && comply) {
                      valReading = true;
                    } else {
                      valReading = false;
                    }
                  }
                  operactorNext = condiction.operadorCondicion;
                } else {
                  firstReading = false;
                  firstView = true;
                  firstBlock = true;
                  firstUnlock = true;
                  firstHide = true;
                  firstWriting = true;
                  firstAssignValue = true;
                  valReading = comply;
                  operactorNext = condiction.operadorCondicion;
                }
                this.form.sub_formas.forEach(form => {
                  if (form.alias === condiction.formularioCondicionado) {
                    if (condiction.campoCondicionado) {
                      form.campos.forEach(field => {
                        if (field.alias === condiction.campoCondicionado && field.tipo_campo.nombre !== 'label') {
                          if (valReading) {
                            this.readonlyField(form.formulario, fieldCondictional.nombre_campo, true);
                          } else {
                            this.readonlyField(form.formulario, fieldCondictional.nombre_campo, false);
                          }
                        }
                      });
                    }
                  }
                });
                break;
                case 'Escritura':
                  if (!firstWriting) {
                    if (!operactorNext || operactorNext === 'O') {
                      if (valWriting || comply) {
                        valWriting = true;
                      } else {
                        valWriting = false;
                      }
                    } else {
                      if (valWriting && comply) {
                        valWriting = true;
                      } else {
                        valWriting = false;
                      }
                    }
                    operactorNext = condiction.operadorCondicion;
                  } else {
                    firstWriting = false;
                    firstHide = true;
                    firstBlock = true;
                    firstUnlock = true;
                    firstView = true;
                    firstReading = true;
                    firstAssignValue = true;
                    valWriting = comply;
                    operactorNext = condiction.operadorCondicion;
                  }
                  this.form.sub_formas.forEach(form => {
                    if (form.alias === condiction.formularioCondicionado) {
                      if (condiction.campoCondicionado) {
                        form.campos.forEach(field => {
                          if (field.alias === condiction.campoCondicionado && field.tipo_campo.nombre !== 'label') {
                            if (valWriting) {
                              this.readonlyField(form.formulario, fieldCondictional.nombre_campo, false);
                            } else {
                              this.readonlyField(form.formulario, fieldCondictional.nombre_campo, true);
                            }
                          }
                        });
                      }
                    }
                  });
                  break;
                case 'Mostrar':
                  if (!firstView) {
                    if (!operactorNext || operactorNext === 'O') {
                      if (valView || comply) {
                        valView = true;
                      } else {
                        valView = false;
                      }
                    } else {
                      if (valView && comply) {
                        valView = true;
                      } else {
                        valView = false;
                      }
                    }
                    operactorNext = condiction.operadorCondicion;
                  } else {
                    firstView = false;
                    firstBlock = true;
                    firstUnlock = true;
                    firstHide = true;
                    firstReading = true;
                    firstWriting = true;
                    firstAssignValue = true;
                    valView = comply;
                    operactorNext = condiction.operadorCondicion;
                  }
                  this.form.sub_formas.forEach(form => {
                    if (form.alias === condiction.formularioCondicionado) {
                      if (!condiction.campoCondicionado) {
                        if (valView) {
                          form['hidde'] = false;
                        } else {
                          form['hidde'] = true;
                        }
                      } else {
                        form.campos.forEach(field => {
                          if (field.alias === condiction.campoCondicionado) {
                            if (valView) {
                              this.hiddenField(form.formulario, fieldCondictional.nombre_campo, false);
                              if (field.tipo_campo.nombre !== 'label') {
                                condictional.controls[fieldCondictional.nombre_campo].enable();
                              }
                            } else {
                              this.hiddenField(form.formulario, fieldCondictional.nombre_campo, true);
                              if (field.tipo_campo.nombre !== 'label') {
                                condictional.controls[fieldCondictional.nombre_campo].disable();
                                if (fieldCondictional.propiedades['default']) {
                                  // tslint:disable-next-line: max-line-length
                                  condictional.controls[fieldCondictional.nombre_campo].setValue(fieldCondictional.propiedades['default']);
                                } else {
                                  condictional.controls[fieldCondictional.nombre_campo].reset();
                                }
                              }
                            }
                          }
                        });
                      }
                    }
                  });
                  break;
                case 'Ocultar':
                  if (!firstHide) {
                    if (!operactorNext || operactorNext === 'O') {
                      if (valHide || comply) {
                        valHide = true;
                      } else {
                        valHide = false;
                      }
                    } else {
                      if (valHide && comply) {
                        valHide = true;
                      } else {
                        valHide = false;
                      }
                    }
                    operactorNext = condiction.operadorCondicion;
                  } else {
                    firstHide = false;
                    firstBlock = true;
                    firstUnlock = true;
                    firstView = true;
                    firstReading = true;
                    firstWriting = true;
                    firstAssignValue = true;
                    valHide = comply;
                    operactorNext = condiction.operadorCondicion;
                  }
                  this.form.sub_formas.forEach(form => {
                    if (form.alias === condiction.formularioCondicionado) {
                      if (!condiction.campoCondicionado) {
                        if (valHide) {
                          form['hidde'] = true;
                        } else {
                          form['hidde'] = false;
                        }
                      } else {
                        form.campos.forEach(field => {
                          if (field.alias === condiction.campoCondicionado) {
                            if (valHide) {
                              this.hiddenField(form.formulario, fieldCondictional.nombre_campo, true);
                              if (field.tipo_campo.nombre !== 'label') {
                                condictional.controls[fieldCondictional.nombre_campo].disable();
                                condictional.controls[fieldCondictional.nombre_campo].reset();
                              }
                            } else {
                              this.hiddenField(form.formulario, fieldCondictional.nombre_campo, false);
                              if (field.tipo_campo.nombre !== 'label') {
                                condictional.controls[fieldCondictional.nombre_campo].enable();
                              }
                            }
                          }
                        });
                      }
                    }
                  });
                  break;
                case 'Asignar valor':
                  if (!firstAssignValue) {
                    if (!assignValue) {
                      assignValue = comply;
                    } else {
                      break;
                    }
                  } else {
                    firstAssignValue = false;
                    firstUnlock = true;
                    firstBlock = true;
                    firstView = true;
                    firstHide = true;
                    firstReading = true;
                    firstWriting = true;
                    assignValue = comply;
                  }
                  if (!this.finishTask && assignValue) {
                    const form = find(this.form.sub_formas, {alias: condiction.formularioCondicionado});
                    if (form) {
                      const field = find(
                        form.campos,
                        f => f.alias === condiction.campoCondicionado && f.tipo_campo.nombre !== 'label'
                      );
                      if (field) {
                        if (condiction.fechaActualAsignar) {
                          condictional.controls[fieldCondictional.nombre_campo].setValue(new Date());
                        } else {
                          condictional.controls[fieldCondictional.nombre_campo].setValue(condiction.valorAsignar);
                        }
                      }
                    }
                  }
                  break;
                default:
                  if (!firstBlock) {
                    if (!operactorNext || operactorNext === 'O') {
                      if (valBlock || comply) {
                        valBlock = true;
                      } else {
                        valBlock = false;
                      }
                    } else {
                      if (valBlock && comply) {
                        valBlock = true;
                      } else {
                        valBlock = false;
                      }
                    }
                    operactorNext = condiction.operadorCondicion;
                  } else {
                    firstBlock = false;
                    firstUnlock = true;
                    firstView = true;
                    firstHide = true;
                    firstReading = true;
                    firstWriting = true;
                    firstAssignValue = true;
                    valBlock = comply;
                    operactorNext = condiction.operadorCondicion;
                  }
                  if (!this.finishTask) {
                    this.form.sub_formas.forEach(form => {
                      if (form.alias === condiction.formularioCondicionado && condictional) {
                        if (!condiction.campoCondicionado) {
                          if (valBlock) {
                            condictional.disable();
                            condictional.reset();
                          } else {
                            condictional.enable();
                          }
                        } else {
                          form.campos.forEach(field => {
                            if (field.alias === condiction.campoCondicionado && field.tipo_campo.nombre !== 'label') {
                              if (valBlock) {
                                condictional.controls[fieldCondictional.nombre_campo].disable();
                                condictional.controls[fieldCondictional.nombre_campo].reset();
                              } else {
                                if (fieldCondictional.propiedades['default']) {
                                  // tslint:disable-next-line: max-line-length
                                  condictional.controls[fieldCondictional.nombre_campo].setValue(fieldCondictional.propiedades['default']);
                                } else {
                                  condictional.controls[fieldCondictional.nombre_campo].reset();
                                }
                              }
                            }
                          });
                        }
                      }
                    });
                  }
                  break;
              }
              this.cd.detectChanges();
            }

        }
        if (allValidactions) {
          await this.refreshForm(false, -1, null, false, true, false);
          await this.operationsValues(changeUser);
          // .then(async _res => {
            this.updateCondictions = false;
            if (this.nameFormChange) {
              this.nameFormChange = '';
            }
            if (indexDataForm !== -1 && this.dataForm && this.dataForm.length) {
              delete this.dataForm[indexDataForm].nameChange;
            }
            await this.validateForm(false, data, nameForm, changeUser);
            resolve(true);
          // });
        } else {
          if (!this.finishTask && this.autoSave) {
            await this.autoSaveForm();
          }
          // if (this.applyAutosavedFormularios) {
            await this.autoSaveFormulario();
            this.runChange();
          // }
          resolve(true);
        }
        this.updateCondictions = false;
        this.valid();
      } else {
        resolve(true);
      }
    });
  }

  /**
   * Acumula los formularios renderizados al iniciar
   * Ejecuta las validaciones al terminar de acumular todos los formularios
   *
   * @param {FormGroup} form
   * @param {string} name
   * @param {boolean} [validate=false]
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  accumulateForm(form: FormGroup, name: string, validate: boolean = false): Promise<boolean> {
    return new Promise(async (resolve) => {
      let valid = false;
      let exist = false;
      const subForm = find(this.form.sub_formas, {alias: name});
      if (this.formularios.length) {
        const indexFormulario = findIndex(this.formularios, {name: name});
        if (indexFormulario !== -1) {
          this.formularios[indexFormulario].form = form;
          exist = true;
        }
      }

      if (form.status === 'VALID' || form.status === 'DISABLED') {
        if (subForm) {
          if (!subForm.tabla) {
            const formularioForm = find(this.formularios, {name: name});
            if (formularioForm) {
              if (!this.finishTask) {
                const savedComplete = filter(this.data, {alias_formulario: subForm.alias});
                if (savedComplete && savedComplete.length) {
                  for (const field of subForm.campos) {
                    const saved = find(this.data, {alias: field.alias});
                    if (saved) {
                      if (
                        formularioForm &&
                        formularioForm.form &&
                        formularioForm.form.controls &&
                        formularioForm.form.controls[field.nombre_campo] !== undefined
                      ) {
                        if (!formularioForm.form.controls[field.nombre_campo].disabled) {
                          if (field.tipo_campo && field.tipo_campo.nombre === 'label') {
                            valid = true;
                          } else if (field.tipo_campo && field.tipo_campo.nombre === 'date-time-picker') {
                            let date;
                            if (formularioForm.form.controls[field.nombre_campo].value) {
                              date = new Date(
                                formularioForm.form.controls[field.nombre_campo].value
                              ).toLocaleString('en-CO');
                            }
                            if (
                              date === saved.valor ||
                              (
                                !formularioForm.form.controls[field.nombre_campo].value &&
                                !saved.valor
                              )
                            ) {
                              valid = true;
                            } else {
                              valid = false;
                              break;
                            }
                          } else if (field.tipo_campo && field.tipo_campo.nombre !== 'checkbox') {
                            if (
                              formularioForm.form.controls[field.nombre_campo].value === saved.valor ||
                              (
                                !formularioForm.form.controls[field.nombre_campo].value &&
                                !saved.valor
                              )
                            ) {
                              valid = true;
                            } else {
                              valid = false;
                              break;
                            }
                          } else {
                            let value = false;
                            if (
                              formularioForm.form.controls[field.nombre_campo].value === null ||
                              formularioForm.form.controls[field.nombre_campo].value === undefined
                            ) {
                              value = false;
                            } else {
                              value = formularioForm.form.controls[field.nombre_campo].value;
                            }
                            if (value === saved.valor) {
                              valid = true;
                            } else {
                              valid = false;
                              break;
                            }
                          }
                        }
                      } else {
                        valid = true;
                      }
                    } else {
                      valid = true;
                    }
                  }
                } else {
                  valid = false;
                }
              } else {
                const fieldsReq = filter(subForm.campos, {requerido: true});
                if (fieldsReq && fieldsReq.length) {
                  for (const field of fieldsReq) {
                    if (formularioForm.form.controls[field.nombre_campo].value) {
                      valid = true;
                      break;
                    }
                  }
                } else {
                  valid = true;
                }
              }
            } else {
              const savedComplete = filter(this.data, {alias_formulario: subForm.alias});
              if (savedComplete && savedComplete.length) {
                valid = true;
              } else {
                valid = false;
              }
            }
          } else {
            if ((this.update || this.updateForm[name]) && (this.formSelect || this.formSelectOnly[name])) {
              valid = true;
            }
          }
        }
      }
      if (!exist) {
        this.formularios.push({
          name: name,
          form: form,
          saved: valid
        });
      } else {
        const indexForm = findIndex(this.formularios, {name: name});
        if (indexForm !== -1) {
          const refresh = findIndex(this.formsRefresh, {name: name});
          if (refresh === -1) {
            this.formularios[indexForm].form = form;
            if (this.formularios[indexForm].saved !== valid) {
              this.formularios[indexForm].saved = valid;
              this.cd.detectChanges();
            }
          } else {
            if (subForm.estilo['registro_unico']) {
              if (this.formularios[indexForm].saved !== valid) {
                this.formularios[indexForm].saved = valid;
                this.cd.detectChanges();
              }
            }
          }
        }
      }
      this.controlChanged(subForm, name);
      if (this.numberForms === this.formularios.length || validate) {
        if (!validate) {
          // this.valid();
          await this.validateForm();
        } else {
          if (!this.addDataForm && this.nameFormChange !== name) {
            await this.validateForm(true, {change: form.value}, name, true);
          }
        }

      }
      resolve(true);
    });
  }

  /**
   * Controla los cambios del formulario para ejecutar los cambios del selector
   * en caso de ser necesario
   *
   * @param {*} data
   * @param {FormGroup} form
   * @param {string} name
   * @memberof RefactorDynamicFormComponent
   */
  async controlChanged(subForm: SubForma, name: string) {
    if (this.formularios.length) {
      const indexForm = findIndex(this.formularios, {name: name});
      if (indexForm !== -1) {
        Object.keys(this.formularios[indexForm].form.controls).forEach(nameControl => {
          this.formularios[indexForm].form.controls[nameControl].valueChanges.subscribe(async data => {
            const ixf = findIndex(this.formularios, {name: name});
            const changeExist = findIndex(
              this.changeQueue,
              cq => cq.nameControl === nameControl && cq.subForm.alias === subForm.alias
            );
            if (changeExist !== -1) {
              this.changeQueue[changeExist].data = data;
            } else {
              this.changeQueue.push({
                subForm: subForm,
                nameControl: nameControl,
                ixf: ixf,
                data: data
              });
            }
          });
        });
      }
    }
  }

  /**
   * Ejecuta los cambios de los campos en cola
   *
   * @memberof RefactorDynamicFormComponent
   */
  async runChange() {
    if (this.changeQueue.length) {
      const quantity = this.changeQueue.length;
      let count = 1;
      while (count <= quantity) {
        await this.updateFilter(
          this.changeQueue[0].subForm,
          this.changeQueue[0].ixf,
          this.changeQueue[0].nameControl,
          this.changeQueue[0].data
        );
        this.changeQueue.splice(0, 1);
        count++;
      }
      // await Static.asyncForEach(this.changeQueue, async (cq, i) => {
      // });
    }
  }

  /**
   * Ejecuta los cambios en los filtros de un control dependientes de otro
   *
   * @param {SubForma} subForm
   * @param {number} ixf
   * @param {string} nameControl
   * @param {*} [data]
   * @return {*}  {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  updateFilter(subForm: SubForma, ixf: number, nameControl: string, data?: any): Promise<boolean> {
    return new Promise(async (resolve, _reject) => {
      const d = this.getDataForm(this.formularios[ixf].form, subForm);
      const control = find(
        subForm.campos,
        ctrl => ctrl.nombre_campo === nameControl
      );
      if (control) {
        if (!this.temporalFormGeneral[subForm.alias]) {
          this.temporalFormGeneral[subForm.alias] = {};
        }
        if (data) {
          this.temporalFormGeneral[subForm.alias][control.nombre_campo] = Static.copyObjet(data);
        }
        const fieldsDependence = this.selectDependencia(subForm.campos, control.alias);
        if (fieldsDependence && fieldsDependence.length) {
          await this.asyncForEach(fieldsDependence, async (controlD: Control) => {
            if (controlD.tipo_campo.nombre === 'ngSelect') {
              if (!controlD.propiedades['columna_general']) {
                if (controlD.propiedades['tipoSelector'] !== 'EnModal') {
                  await this.refresControlForm(subForm, controlD, d);
                } else {
                  this.updatedControlColumns(controlD, subForm);
                  this.gns.set<any>({
                    source: 'multipleProperties',
                    destiny: controlD.alias + '-' + controlD.nombre_campo,
                    action: 'loadingData',
                    eventTriggered: 'change',
                    data: <any> {data: []}
                  }, true);
                }
              } else {
                const ctrl = await this.refresControlForm(
                  subForm,
                  controlD,
                  d,
                  false,
                  false,
                  true
                );
                controlD.propiedades['options'] = ctrl.propiedades['options'];
                if (
                  ctrl.propiedades &&
                  ctrl.propiedades['options'] &&
                  ctrl.propiedades['options'].length
                ) {
                  const filterData = {};
                  // tslint:disable-next-line: max-line-length
                  filterData[controlD.nombre_campo] = this.formularios[ixf].form.value[controlD.nombre_campo];
                  const exist = filter(ctrl.propiedades['options'], filterData);
                  if (!exist) {
                    if (this.formularios[ixf].form.controls[controlD.nombre_campo]) {
                      this.formularios[ixf].form.controls[controlD.nombre_campo].setValue(null, {
                        onlySelf: false,
                        emitEvent: false,
                        emitModelToViewChange: true,
                        emitViewToModelChange: true
                      });
                    }
                  }
                } else {
                  if (this.formularios[ixf].form.controls[controlD.nombre_campo]) {
                    this.formularios[ixf].form.controls[controlD.nombre_campo].setValue(null, {
                      onlySelf: false,
                      emitEvent: false,
                      emitModelToViewChange: true,
                      emitViewToModelChange: true
                    });
                  }
                }
                if (subForm['controles_generales'] && subForm['controles_generales'].length) {
                  this.loadFormControlsGeneral(subForm);
                }
              }
            }
          });
        }
      }
      this.updateFilters = false;
      resolve(true);
    });
  }

  /**
   * Posiciona el scroll a la caja deseada
   *
   * @param {string} positionScroll
   * @memberof RefactorDynamicFormComponent
   */
  scrollForm(positionScroll: string) {
    if (positionScroll) {
      this.sts.scrollTo({
        target: positionScroll,
        offset: -300
      } as ScrollToConfigOptions);
    }
  }

  /**
   * Retorna si un formulario especificado esta o no esta guardado
   *
   * @param {string} aliasForm
   * @returns {boolean}
   * @memberof RefactorDynamicFormComponent
   */
  validSavedForm(
    aliasForm: string,
    type: 'boolean'| 'button' | 'header' | 'check-form' = 'boolean'
  ): boolean | Object {
    const form = find(this.formularios, {name: aliasForm});
    if (form) {
      if (type === 'button') {
        return {'btn-success': form.saved, 'btn-danger': !form.saved};
      } else if (type === 'header') {
        return {'form-complete': form.saved, 'form-incomplete': !form.saved};
      } else if (type === 'check-form') {
        return {'fa-check-square-o': form.saved, 'fa-square-o': !form.saved};
      } else {
        return form.saved;
      }
    } else {
      if (type === 'button') {
        return {'btn-success': false, 'btn-danger': true};
      } else if (type === 'header') {
        return {'form-complete': false, 'form-incomplete': true};
      } else if (type === 'check-form') {
        return {'fa-check-square-o': false, 'fa-square-o': true};
      } else {
        return false;
      }
    }
  }

  /**
   * Valida el estado del formulario indicado y retorna la clase a aplicar correspondiente al estado estado
   *
   * @param {string} alias
   * @param {boolean} table
   * @returns
   * @memberof RefactorDynamicFormComponent
   */
  validHeaderCards(alias: string, table: boolean) {
    if (!table) {
      return this.validSavedForm(alias, 'header');
    } else {
      let valid = true;
      const form = find(this.form.sub_formas, {alias: alias});
      if (
        form &&
        this.validGeneralControl[form.id_forma] &&
        this.validGeneralControl[form.id_forma].length
      ) {
        const complete = find(this.validGeneralControl[form.id_forma], {complete: false});
        if (complete) {
          valid = false;
        } else {
          valid = true;
        }
      } else {
        valid = this.validSaveTable(alias);
      }
      if (valid) {
        return {'form-complete': true, 'form-incomplete': false};
      } else {
        return {'form-complete': false, 'form-incomplete': true};
      }
    }
  }

  /**
   * Valida el estado de una tabla indocada por su alias
   *
   * @param {string} aliasForm
   * @returns {boolean}
   * @memberof RefactorDynamicFormComponent
   */
  validSaveTable(aliasForm: string): boolean {
    const subForm = find(this.form.sub_formas, {alias: aliasForm});
    if (subForm) {
      let exist = false;
      let validTable = true;
      if (subForm) {
        const dataT = find(this.dataTable, {id_tabla: subForm.id_forma});
        if (dataT) {
          let valuesTable: any[] = [];
          if (dataT.valores.length) {
            if (
              subForm.estilo['condiciones_columnas'] &&
              subForm.estilo['condiciones_columnas'].length
            ) {
              // tslint:disable-next-line: max-line-length
              valuesTable = this.runCondictionsColumnsTable(subForm, 'Ignorar', dataT) as any[];
              // tslint:disable-next-line: max-line-length
              validTable = this.runCondictionsColumnsTable(subForm, 'Requerir', dataT, valuesTable) as boolean;
            } else {
              valuesTable = dataT.valores;
            }
          } else if (subForm.estilo.hasOwnProperty('validRecords')) {
            subForm.estilo['validRecords'] = dataT.valores;
          }
          let validMin = false;
          let validMax = false;

          if (valuesTable.length >= subForm.numero_registros) {
            validMin = true;
          }

          if (
            !subForm.estilo ||
            !subForm.estilo['numero_registros_maximos']
          ) {
            validMax = true;
          } else if (subForm.estilo['numero_registros_maximos'] >= valuesTable.length) {
            validMax = true;
          }

          if (validMin && validMax) {
            exist = true;
          } else {
            exist = false;
          }
        }
        if (!exist) {
          if (subForm.numero_registros === 0) {
            exist = true;
          }
        }
        if ((exist && validTable) || subForm.hidde) {
          let valid = true;
          if (this.tabsVisible[subForm.alias]) {
            this.tabsVisible[subForm.alias]['complete'] = valid;
          } else {
            this.tabsVisible[subForm.alias] = {
              complete: valid
            };
          }
          const tabs = filter(this.form.sub_formas, f => f.estilo['formulario_pestaña'] === subForm.alias);
          if (tabs.length) {
            for (const tab of tabs) {
              if (
                this.tabsVisible[subForm.alias] &&
                this.tabsVisible[subForm.alias][tab.alias] &&
                this.tabsVisible[subForm.alias][tab.alias]['visible']
              ) {
                if (tab.tabla) {
                  valid = this.validSaveTable(tab.alias);
                } else {
                  valid = this.validSavedForm(tab.alias) as boolean;
                }
                this.tabsVisible[subForm.alias][tab.alias]['complete'] = valid;
                if (!valid) {
                  break;
                }
              }
            }
          }
          return valid;
        } else {
          if (this.tabsVisible[subForm.alias]) {
            this.tabsVisible[subForm.alias]['complete'] = false;
          } else {
            this.tabsVisible[subForm.alias] = {
              complete: false
            };
          }
          return false;
        }
      }
    }
  }

  /**
   * Busca y retorna todos los campos que dependen de un campo de forma escalada
   *
   * @private
   * @param {Control[]} fields
   * @param {string} nameControl
   * @returns {Control[]}
   * @memberof RefactorDynamicFormComponent
   */
  private selectDependencia(fields: Control[], nameControl: string): Control[] {
    const fieldsDependenci: Control[] = [];
    fields.forEach(field => {
      if (field.validaciones && field.validaciones.filtros && field.validaciones.filtros.length) {
        const controlContent = find(field.validaciones.filtros, {field: nameControl});
        if (controlContent) {
          fieldsDependenci.push(field);
          const fieldsD = this.selectDependencia(fields, field.alias);
          if (fieldsD && fieldsD.length) {
            fieldsD.forEach(f => {
              fieldsDependenci.push(f);
            });
          }
        }
      }
      if (
        field.validaciones &&
        field.validaciones.condiciones_columnas &&
        field.validaciones.condiciones_columnas.length
      ) {
        const controlExist = find(field.validaciones.condiciones_columnas, {campo: nameControl});
        if (controlExist) {
          const exist = find(fieldsDependenci, {id: field.id});
          if (!exist) {
            fieldsDependenci.push(field);
          }
        }
      }
    });
    return fieldsDependenci;
  }

  /**
   * Ejecuta las operaciones de los campos
   *
   * @private
   * @returns {Promise<any>}
   * @memberof RefactorDynamicFormComponent
   */
  private async operationsValues(changeUser: boolean = false): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        let fields: Array<{form: string, control: string}> = [];
        if (changeUser) {
          fields = this.dependenciOperations();
        }
        for (const subForma of this.form.sub_formas) {
          if (subForma.campos.length && !subForma.hidde) {
            const controlModificate: Array<string> = [];
            subForma.campos.sort((a, b) => a.orden - b.orden);
            for (const control of subForma.campos) {
              let applyOperations = true;
              if (changeUser) {
                let apply = find(fields, {form: subForma.alias, control: control.alias});
                if (!apply) {
                  apply = find(fields, {form: subForma.alias});
                  if (!apply) {
                    applyOperations = false;
                  }
             }
              }
              if (applyOperations) {
                const formAcumulate = find(this.formularios, {name: subForma.alias});
                const indexFormAcumulate = findIndex(this.formularios, {name: subForma.alias});
                let subFormGroup: FormGroup;
                if (formAcumulate) {
                  if (
                    (
                      formAcumulate.saved ||
                      (
                        !formAcumulate.saved &&
                        formAcumulate.form.status === 'DISABLED'
                      )
                    ) &&
                    !subForma.estilo['auto_saved']
                  ) {
                    if (changeUser) {
                      subFormGroup = formAcumulate.form;
                    } else {
                      continue;
                    }
                  } else {
                    subFormGroup = formAcumulate.form;
                  }
                }
                if (control.validaciones.operaciones.length && subFormGroup) {
                  for (const opr of control.validaciones.operaciones) {
                    let resultOperaction = await this.executeOperation(
                      subForma,
                      control,
                      opr,
                      // indexFormAcumulate,
                      // subFormGroup
                    );
                    if (resultOperaction !== null) {
                      // if (subFormGroup.controls[control.nombre_campo].value !== resultOperaction) {
                      //   controlModificate.push(control.alias);
                      // }
                      if (subFormGroup.controls[control.nombre_campo]) {
                        // Contiene el formulario donde se realiza el cambio
                        const form = find(this.dataForm, {name: this.nameFormChange});
                        // Contiene el formulario actual donde se esta realizando las operaciones
                        const formActual = find(this.dataForm, {name: subForma.alias});
                        if (form && formActual) {
                          controlModificate.push(form.nameChange);
                          if (form.nameChange) {
                            let modificate = true;
                            // Esta validacion se realiza para el caso de que los campos por el cual
                            // se realizen las condiciones sufran un cambio obligue a que se ejecute la operacion
                            if (!opr.ejecutar_siempre) {
                              opr.valores.forEach((value) => {
                                let exist = controlModificate.indexOf(value.campo);
                                controlModificate.push(control.alias);
                                if (exist !== -1) {
                                  modificate = false;
                                } else if (changeUser) {
                                  exist = findIndex(fields, {form: subForma.alias, control: value.campo});
                                  if (exist !== -1) {
                                    modificate = false;
                                  }
                                }
                              });
                            } else {
                              modificate = false;
                            }
                            /* Si el cambio se esta realizando en el campo actual
                             * toma este valor y no el de la operacion
                             **/
                            if (changeUser) {
                              if (form.nameChange === control.alias || modificate) {
                                if (formActual.data && formActual.data.change) {
                                  resultOperaction = formActual.data.change[control.nombre_campo];
                                }
                              }
                            }
                          }
                          // Setea el resultado de la operacion en el campo para el formulario actual
                          if (formActual.data.change) {
                            formActual.data.change[control.nombre_campo] = resultOperaction;
                          } else {
                            formActual.data[control.nombre_campo] = resultOperaction;
                          }
                        }
                        if (
                          (
                            control.tipo_campo.nombre !== 'number' &&
                            resultOperaction !== subFormGroup.controls[control.nombre_campo].value
                          ) ||
                          (
                            control.tipo_campo.nombre === 'number' &&
                            (
                              (
                                typeof subFormGroup.controls[control.nombre_campo].value === 'string' &&
                                resultOperaction !== Number(
                                                      Static.numberFormatWithoutThousandsSeparator(
                                                        subFormGroup.controls[control.nombre_campo].value,
                                                        control.propiedades['separadorMiles'],
                                                        control.propiedades['separadorDecimales']
                                                      )
                                                    )
                              ) ||
                              (
                                typeof subFormGroup.controls[control.nombre_campo].value === 'number' &&
                                resultOperaction !== subFormGroup.controls[control.nombre_campo].value
                              )
                            )
                          ) ||
                          (
                            resultOperaction && !subFormGroup.controls[control.nombre_campo].value
                          )
                        ) {
                          subFormGroup.controls[control.nombre_campo].setValue(resultOperaction);
                          // tslint:disable-next-line:max-line-length
                          this.formularios[indexFormAcumulate].form.controls[control.nombre_campo].setValue(resultOperaction);
                          subFormGroup.controls[control.nombre_campo].markAsDirty();
                          this.formularios[indexFormAcumulate].form.controls[control.nombre_campo].markAsDirty();
                          if (this.formularios[indexFormAcumulate].saved) {
                            this.formularios[indexFormAcumulate].saved = false;
                          }
                        }
                      }
                      break;
                    } else {
                      if (control.tipo_campo.nombre === 'number') {
                        const form = find(this.dataForm, {name: this.nameFormChange});
                        if (
                          form &&
                          subFormGroup &&
                          subFormGroup.controls[control.nombre_campo] &&
                          Number(subFormGroup.controls[control.nombre_campo].value) !== 0 &&
                          form.nameChange !== control.alias
                        ) {
                          subFormGroup.controls[control.nombre_campo].setValue(0);
                          this.formularios[indexFormAcumulate].saved = false;
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            continue;
          }
          this.cd.detectChanges();
        }
        resolve(true);
      } catch (error) {
        this.toastr.error('Lo sentimos encontramos errores en alguna de las operaciones de los formularios',
                          'Error gramatical');
        log.debug(error);
        reject(false);
      }
    });
  }

  /**
   * Retorna los controles dependientes de operaciones y condiciones de un control
   *
   * @private
   * @param {string} [form]
   * @param {string} [field]
   * @param {Array<{form: string, control: string}>} [fields=[]]
   * @returns {Array<{form: string, control: string}>}
   * @memberof RefactorDynamicFormComponent
   */
  private dependenciOperations(
    form?: string,
    field?: string,
    fields: Array<{form: string, control: string}> = []
  ): Array<{form: string, control: string}> {
    let formChange: {
      name: string;
      data: any;
      nameChange?: string;
    };
    let valid = true;
    let control: string;
    let formS: string;
    if (field) {
      fields.push({
        form: form,
        control: field
      });
      control = field;
      formS = form;
    } else {
      formChange = find(this.dataForm, {name: this.nameFormChange});
      if (
        formChange &&
        formChange.nameChange
      ) {
        fields.push({
          form: formChange.name,
          control: formChange.nameChange
        });
        control = formChange.nameChange;
        formS = formChange.name;
      } else {
        valid = false;
      }
    }
    if (valid) {
      const formStructure = find(this.form.sub_formas, {alias: formS});
      const controlStructure = find(formStructure.campos, {alias: control});
      this.form.sub_formas.forEach(subForm => {
        subForm.campos.forEach(ctrl => {
          let fieldValid = '';
          if (ctrl.validaciones && ctrl.validaciones.operaciones && ctrl.validaciones.operaciones.length) {
            for (const operation of ctrl.validaciones.operaciones) {
              if (operation.valores && operation.valores.length) {
                const valuesIn = filter(
                  operation.valores,
                  val => val.forma && val.forma === this.form.alias && val.formulario === formS && val.campo === control
                );
                if (valuesIn.length) {
                  fieldValid = ctrl.alias;
                  break;
                }
              }
            }
          }

          if (!fieldValid) {
            if (
              subForm.alias === formS &&
              ctrl.validaciones &&
              ctrl.validaciones.condiciones &&
              ctrl.validaciones.condiciones.length
            ) {
              const condictionExist = find(
                ctrl.validaciones.condiciones,
                {campoDepende: controlStructure.nombre_campo}
              );
              if (condictionExist) {
                fieldValid = ctrl.alias;
              }
            }
          }

          if (fieldValid) {
            const exist = find(fields, {form: subForm.alias, control: fieldValid});
            if (!exist) {
              fields.push({
                form: subForm.alias,
                control: fieldValid
              });
              this.dependenciOperations(subForm.alias, fieldValid, fields);
            }
          }
        });
      });
      if (this.form.condiciones && this.form.condiciones.length) {
        const condictionsDependence = filter(
          this.form.condiciones,
          {formularioInicia: formS, campoInicia: control, formaInicia: this.form.alias}
        );
        if (condictionsDependence.length) {
          condictionsDependence.forEach(condiction => {
            const exist = find(
              fields,
              {form: condiction.formularioCondicionado, control: condiction.campoCondicionado}
            );
            if (!exist) {
              fields.push({
                form: condiction.formularioCondicionado,
                control: condiction.campoCondicionado
              });
              this.dependenciOperations(condiction.formularioCondicionado, condiction.campoCondicionado, fields);
            }
          });
        }
      }
    } else if (!form && !field) {
      if (formChange) {
        const subForm = find(this.form.sub_formas, {alias: this.nameFormChange});
        if (subForm) {
          subForm.campos.forEach(ctrl => {
            this.dependenciOperations(subForm.alias, ctrl.alias, fields);
          });
        }
      }
    }
    return fields;
  }

  /**
   * Ejecuta la operacion de un campo de un formulario de la forma dinamica
   *
   * @private
   * @param {SubForma} subForma
   * @param {Control} control
   * @param {OperacionesControl} opr
   * @param {*} [valuesForm]
   * @param {*} [valuesSelects]
   * @param {number} [indexFormAcumulate]
   * @param {FormGroup} [subFormGroup]
   * @returns {Promise<any>}
   * @memberof RefactorDynamicFormComponent
   */
  private executeOperation(
    subForma: SubForma,
    control: Control,
    opr: OperacionesControl,
    valuesForm?: any,
    valuesSelects?: any,
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        // Llamada a la libreria para ejecutar los calculos de las operaciones
        const calc = require('calculatorjs');
        const reservedWords: Array<string> = [
          'oDia(',
          'oMes(',
          'oAño(',
          'oHora(',
          'oMinuto(',
          'oMesNombre(',
          'fechaActual(',
        ];
        let resultOperaction = null;
        let charOperation = opr.operacion.trim();
        const values = {};
        const checkExist = {};
        charOperation = charOperation.replace(/\s/g, '');
        if (opr.valores.length) {
          for (const value of opr.valores) {
            if (!values[value.referencia.trim()]) {
              if (value.forma) {
                if (this.form.alias === value.forma) {
                  let formValues: any = {};
                  if (valuesForm && subForma.alias === value.formulario) {
                    formValues = valuesForm;
                  } else {
                    const formGroup: FormGroup = result(
                        find(this.formularios, {name: value.formulario}), 'form'
                    );
                    if (formGroup) {
                      formValues = formGroup.value;
                    } else {
                      const valuesData = filter(this.data, {alias_formulario: value.formulario});
                      if (valuesData.length) {
                        valuesData.forEach(vl => {
                          formValues[vl.nombre_campo] = vl.valor;
                        })
                      }
                    }
                  }
                  const formulario = find(this.form.sub_formas, {alias: value.formulario});
                  let field = find(formulario.campos, {alias: value.campo});
                  // tslint:disable-next-line:max-line-length
                  if (
                    (formValues && formValues.hasOwnProperty(field.nombre_campo)) &&
                    ((formulario && !formulario.tabla) || value.formulario === subForma.alias)
                  ) {
                    if (!field) {
                      const validCoor = value.campo.split(':');
                      if (validCoor.length && validCoor.length > 1) {
                        const aField = validCoor[validCoor.length - 1].split('_');
                        let namefield = '';
                        aField.forEach((el, index) => {
                          if (index < (aField.length - 1)) {
                            namefield = el;
                          }
                        });
                        field = find(formulario.campos, {alias: namefield});
                      }
                    }
                    if (
                      field &&
                      (formValues[field.nombre_campo] ||
                        field.tipo_campo.nombre === 'coordenadas')
                    ) {
                      if (field.tipo_campo.nombre === 'checkbox') {
                        if (checkExist[value.referencia.trim()]) {
                          continue;
                        }
                        if (formValues[field.nombre_campo]) {
                          if (control.tipo_campo.nombre === 'checkbox') {
                            values[value.referencia.trim()] = true;
                          } else {
                            values[value.referencia.trim()] = 'Sí';
                          }
                        } else {
                          if (control.tipo_campo.nombre === 'checkbox') {
                            values[value.referencia.trim()] = false;
                          } else {
                            values[value.referencia.trim()] = 'No';
                          }
                        }
                        if (formValues[field.nombre_campo] !== null) {
                          checkExist[value.referencia.trim()] = true;
                        }
                      } else if (field.tipo_campo.nombre === 'ngSelect') {
                        if (formValues[field.nombre_campo]) {
                          if (control.tipo_campo.nombre === 'ngSelect') {
                            values[value.referencia.trim()] = formValues[field.nombre_campo];
                          } else {
                            if (field.propiedades['options']) {
                              const val = result(
                                find(field.propiedades['options'],
                                    {value: formValues[field.nombre_campo]}
                                ),
                                'key'
                              );
                              if (val) {
                                values[value.referencia.trim()] = val;
                              } else {
                                // tslint:disable-next-line:max-line-length
                                values[value.referencia.trim()] = formValues[field.nombre_campo];
                              }
                            } else if (valuesSelects) {
                              // tslint:disable-next-line: max-line-length
                              values[value.referencia.trim()] = valuesSelects[field.nombre_campo + '_' + formValues['id']];
                            } else {
                              values[value.referencia.trim()] = formValues[field.nombre_campo];
                            }
                          }
                        } else {
                          values[value.referencia.trim()] = false;
                        }
                      } else if (field.tipo_campo.nombre === 'coordenadas') {
                        const tmpNameFiel = value.campo.split(':');
                        const nameFieldCoor = tmpNameFiel[tmpNameFiel.length - 1].split('_');
                        const nameField = field.nombre_campo + '_' + nameFieldCoor[nameFieldCoor.length - 1];
                        if (
                          formValues[nameField]
                        ) {
                          values[value.referencia.trim()] =
                          formValues[
                            field.nombre_campo + '_' + nameFieldCoor[nameFieldCoor.length - 1]
                          ];
                        } else {
                          values[value.referencia.trim()] = false;
                        }
                      } else if (field.tipo_campo.nombre === 'date-time-picker') {
                        let ref = '';
                        let method = '';
                        let existMethod = false;
                        for (let i = 0; i < value.referencia.length; i++) {
                          let next = true;
                          if (i === (value.referencia.length - 1)) {
                            if (value.referencia.charAt(i) === ')') {
                              next = false;
                            }
                          }
                          if (next) {
                            const search = reservedWords.indexOf(method);
                            if (search === -1) {
                              if (!existMethod) {
                                method += value.referencia.charAt(i);
                              } else {
                                ref += value.referencia.charAt(i);
                              }
                            } else {
                              existMethod = true;
                              ref += value.referencia.charAt(i);
                            }
                          }
                        }
                        if (!existMethod) {
                          ref = method;
                        }
                        if (formValues[field.nombre_campo]) {
                          let date: Date;
                          let dateTwo: Date;
                          switch (field.propiedades['tipo']) {
                            case 'calendar':
                              date = new Date(formValues[field.nombre_campo]);
                              if (!existMethod) {
                                values[ref.trim()] = date.toLocaleDateString();
                              } else {
                                switch (method) {
                                  case 'oDia(':
                                    values[ref.trim()] = date.getDate().toString();
                                    break;
                                  case 'oMes(':
                                    const month = date.getMonth() + 1;
                                    values[ref.trim()] = month.toString();
                                    break;
                                  case 'oMesNombre(':
                                    values[ref.trim()] = this.getStringMonth(date.getMonth());
                                    break;
                                  case 'oAño(':
                                    values[ref.trim()] = date.getFullYear().toString();
                                    break;
                                  default:
                                    values[ref.trim()] = false;
                                    break;
                                }
                              }
                              break;
                            case 'timer':
                              date = new Date(formValues[field.nombre_campo]);
                              if (!existMethod) {
                                values[ref.trim()] = date.toLocaleTimeString();
                              } else {
                                switch (method) {
                                  case 'oHora(':
                                    values[ref.trim()] = date.getHours().toString();
                                    break;
                                  case 'oMinuto(':
                                    values[ref.trim()] = date.getMinutes().toString();
                                    break;
                                  default:
                                    values[ref.trim()] = false;
                                    break;
                                }
                              }
                              break;
                            case 'dateTimer':
                              date = new Date(formValues[field.nombre_campo]);
                              if (!existMethod) {
                                values[ref.trim()] = date.toLocaleDateString() + ' ' +
                                              date.toLocaleTimeString();
                              } else {
                                switch (method) {
                                  case 'oDia(':
                                    values[ref.trim()] = date.getDate().toString();
                                    break;
                                  case 'oMes(':
                                    const month = date.getMonth() + 1;
                                    values[ref.trim()] = month.toString();
                                    break;
                                  case 'oMesNombre(':
                                    values[ref.trim()] = this.getStringMonth(date.getMonth());
                                    break;
                                  case 'oAño(':
                                    values[ref.trim()] = date.getFullYear().toString();
                                    break;
                                  case 'oHora(':
                                    values[ref.trim()] = date.getHours().toString();
                                    break;
                                  case 'oMinuto(':
                                    values[ref.trim()] = date.getMinutes().toString();
                                    break;
                                  default:
                                    values[ref.trim()] = false;
                                    break;
                                }
                              }
                              break;
                            case 'rangeDate':
                              date = new Date(formValues[field.nombre_campo][0]);
                              dateTwo = new Date(formValues[field.nombre_campo][1]);
                              values[value.referencia.trim()] = date.toLocaleDateString() + ' - ';
                              values[value.referencia.trim()] += dateTwo.toLocaleDateString();
                              break;
                            case 'rangeTime':
                              date = new Date(formValues[field.nombre_campo][0]);
                              dateTwo = new Date(formValues[field.nombre_campo][1]);
                              values[value.referencia.trim()] = date.toLocaleTimeString() + ' - ';
                              values[value.referencia.trim()] += dateTwo.toLocaleTimeString();
                              break;
                            case 'range':
                              date = new Date(formValues[field.nombre_campo][0]);
                              dateTwo = new Date(formValues[field.nombre_campo][1]);
                              values[value.referencia.trim()] = date.toLocaleDateString() + ' ' +
                                                        date.toLocaleTimeString() + ' - ';
                              values[value.referencia.trim()] += dateTwo.toLocaleDateString() + ' ' +
                                                        dateTwo.toLocaleTimeString();
                              break;
                          }
                        } else {
                          values[ref.trim()] = false;
                        }
                      } else {
                        if (formValues[field.nombre_campo]) {
                          if (field.propiedades['separadorMiles'] && typeof formValues[field.nombre_campo] === 'string') {
                            values[value.referencia.trim()] = Static.numberFormatWithoutThousandsSeparator(
                              formValues[field.nombre_campo],
                              field.propiedades['separadorMiles'],
                              field.propiedades['separadorDecimales']
                            );
                          } else {
                            values[value.referencia.trim()] = formValues[field.nombre_campo];
                          }
                        } else {
                          values[value.referencia.trim()] = false;
                        }
                      }
                    } else {
                      values[value.referencia.trim()] = false;
                    }
                  } else if (formulario && formulario.tabla) {
                    const data = find(this.dataTable, {alias: value.formulario});
                    if (data) {
                      if (control.tipo_campo.nombre === 'number') {
                        let valor = 0;
                        data.valores.forEach(valueTable => {
                          if (typeof valueTable[data.labels[value.campo]] === 'string') {
                            valor += Number(Static.numberFormatWithoutThousandsSeparator(
                              valueTable[data.labels[value.campo]],
                              field.propiedades['separadorMiles'],
                              field.propiedades['separadorDecimales']
                            ));
                          } else {
                            valor += valueTable[data.labels[value.campo]];
                          }
                        });
                        values[value.referencia.trim()] = valor;
                      } else {
                        values[value.referencia.trim()] = false;
                      }
                    }
                  }
                } else {
                  if (this.task) {
                    if (this.taskActually.tarea_asociacion) {
                      const association = find(this.taskActually.tarea_asociacion, {alias: value.forma});
                      if (association) {
                        let val = find(association.datos,
                          {
                            alias_formulario: value.formulario,
                            alias: value.campo
                          }
                        );
                        if (!val) {
                          const tmp = value.campo.split(':');
                          const nameA = tmp[tmp.length - 1].split('_');
                          let name = '';
                          nameA.forEach((el, index) => {
                            if (index < (nameA.length - 1) || index === 0) {
                              name = el;
                            }
                          });
                          val = find(association.datos, {alias_formulario: value.formulario, alias: name});
                        }
                        if (val && val.tipo === 'coordenadas') {
                          const tmpNameFiel = value.campo.split(':');
                          const nameFieldCoor = tmpNameFiel[tmpNameFiel.length - 1].split('_');
                          const nameField = nameFieldCoor[nameFieldCoor.length - 1];

                          if (val.valor[nameField]) {
                            values[value.referencia.trim()] = val.valor[nameField];
                          } else {
                            values[value.referencia.trim()] = false;
                          }

                        } else if (val && val.tipo === 'checkbox') {
                          if (checkExist[value.referencia.trim()]) {
                            continue;
                          }
                          if (val.valor) {
                            if (control.tipo_campo.nombre === 'checkbox') {
                              values[value.referencia.trim()] = true;
                            } else {
                              values[value.referencia.trim()] = 'Sí';
                            }
                          } else {
                            if (control.tipo_campo.nombre === 'checkbox') {
                              values[value.referencia.trim()] = false;
                            } else {
                              values[value.referencia.trim()] = 'No';
                            }
                          }
                          if (val.valor !== null) {
                            checkExist[value.referencia.trim()] = true;
                          }
                        } else if (val && val.tipo === 'ngSelect') {
                          if (val.valueSelects) {
                            if (control.tipo_campo.nombre === 'ngSelect') {
                              values[value.referencia.trim()] = val.valor;
                            } else {
                              values[value.referencia.trim()] = val.valueSelects;
                            }
                          } else {
                            values[value.referencia.trim()] = false;
                          }
                        }  else if (val && val.tipo === 'date-time-picker') {
                          let date: Date;
                          let dateTwo: Date;
                          let method = '';
                          let ref = '';
                          let existMethod = false;
                          for (let i = 0; i < value.referencia.length; i++) {
                            let next = true;
                            if (i === (value.referencia.length - 1)) {
                              if (value.referencia.charAt(i) === ')') {
                                next = false;
                              }
                            }
                            if (next) {
                              const search = reservedWords.indexOf(method);
                              if (search === -1) {
                                if (!existMethod) {
                                  method += value.referencia.charAt(i);
                                } else {
                                  ref += value.referencia.charAt(i);
                                }
                              } else {
                                existMethod = true;
                                ref += value.referencia.charAt(i);
                              }
                            }
                          }
                          if (!existMethod) {
                            ref = method;
                          }
                          switch (val.clasificacion) {
                            case 'calendar':
                              date = new Date(val.valor);
                              if (!existMethod) {
                                values[ref.trim()] = date.toLocaleDateString();
                              } else {
                                switch (method) {
                                  case 'oDia(':
                                    values[ref.trim()] = date.getDate().toString();
                                    break;
                                  case 'oMes(':
                                    const month = date.getMonth() + 1;
                                    values[ref.trim()] = month.toString();
                                    break;
                                  case 'oMesNombre(':
                                    values[ref.trim()] = this.getStringMonth(date.getMonth());
                                    break;
                                  case 'oAño(':
                                    values[ref.trim()] = date.getFullYear().toString();
                                    break;
                                  default:
                                    values[ref.trim()] = false;
                                    break;
                                }
                              }
                              break;
                            case 'timer':
                              date = new Date(val.valor);
                              if (!existMethod) {
                                values[ref.trim()] = date.toLocaleTimeString();
                              } else {
                                switch (method) {
                                  case 'oHora(':
                                    values[ref.trim()] = date.getHours().toString();
                                    break;
                                  case 'oMinuto(':
                                    values[ref.trim()] = date.getMinutes().toString();
                                    break;
                                  default:
                                    values[ref.trim()] = false;
                                    break;
                                }
                              }
                              break;
                            case 'dateTimer':
                              date = new Date(val.valor);
                              if (!existMethod) {
                                values[ref.trim()] = date.toLocaleDateString() + ' ' +
                                              date.toLocaleTimeString();
                              } else {
                                switch (method) {
                                  case 'oDia(':
                                    values[ref.trim()] = date.getDate().toString();
                                    break;
                                  case 'oMes(':
                                    const month = date.getMonth() + 1;
                                    values[ref.trim()] = month.toString();
                                    break;
                                  case 'oMesNombre(':
                                    values[ref.trim()] = this.getStringMonth(date.getMonth());
                                    break;
                                  case 'oAño(':
                                    values[ref.trim()] = date.getFullYear().toString();
                                    break;
                                  case 'oHora(':
                                    values[ref.trim()] = date.getHours().toString();
                                    break;
                                  case 'oMinuto(':
                                    values[ref.trim()] = date.getMinutes().toString();
                                    break;
                                  default:
                                    values[ref.trim()] = false;
                                    break;
                                }
                              }
                              break;
                            case 'rangeDate':
                              date = new Date(val.valor[0]);
                              dateTwo = new Date(val.valor[1]);
                              values[ref.trim()] = date.toLocaleDateString() + ' - ';
                              values[ref.trim()] += dateTwo.toLocaleDateString();
                              break;
                            case 'rangeTime':
                              date = new Date(val.valor[0]);
                              dateTwo = new Date(val.valor[1]);
                              values[ref.trim()] = date.toLocaleTimeString() + ' - ';
                              values[ref.trim()] += dateTwo.toLocaleTimeString();
                              break;
                            case 'range':
                              date = new Date(val.valor[0]);
                              dateTwo = new Date(val.valor[1]);
                              values[ref.trim()] = date.toLocaleDateString() + ' ' +
                                            date.toLocaleTimeString() + ' - ';
                              values[ref.trim()] += dateTwo.toLocaleDateString() + ' ' +
                                            dateTwo.toLocaleTimeString();
                              break;
                          }
                        } else if (val) {
                          values[value.referencia.trim()] = val.valor;
                        } else {
                          const data = find(this.dataTableAll, {alias: value.formulario});
                          if (data) {
                            if (control.tipo_campo.nombre === 'number') {
                              let valor = 0;
                              data.valores.forEach(valueTable => {
                                if (Number(valueTable[data.labels[value.campo]])) {
                                  valor += Number(valueTable[data.labels[value.campo]]);
                                }
                              });
                              values[value.referencia.trim()] = valor;
                            } else {
                              values[value.referencia.trim()] = false;
                            }
                          } else {
                            let correctRef = '';
                            for (let i = 0; i < value.referencia.length; i++) {
                              let next = true;
                              if (i === (value.referencia.length - 1)) {
                                if (value.referencia.charAt(i) === ')') {
                                  next = false;
                                }
                              }
                              if (next) {
                                const search = reservedWords.indexOf(correctRef);
                                if (search === -1) {
                                    correctRef += value.referencia.charAt(i);
                                } else {
                                  correctRef = '';
                                }
                              }
                            }
                            values[correctRef.trim()] = false;
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                let methodExist = false;
                let method = '';
                let ref = '';
                for (let i = 0; i < value.valor.length; i++) {
                  if (!methodExist) {
                    method += value.valor.charAt(i);
                    const search = reservedWords.indexOf(method);
                    if (search !== -1) {
                      methodExist = true;
                    }
                  } else {
                    ref += value.valor.charAt(i);
                  }
                  if (value.valor.charAt((i + 1)) === ')') {
                    break;
                  }
                }
                if (!methodExist) {
                  values[value.referencia.trim()] = value.valor;
                } else {
                  if (!ref || control.tipo_campo.nombre === 'date-time-picker') {
                    values[value.referencia.trim()] = new Date();
                  } else {
                    const moment = require('moment');
                    const date = moment().format(ref);
                    values[value.referencia.trim()] = date;
                  }
                }
              }
            } else {
              continue;
            }
          }
          if (control.tipo_campo.nombre === 'number') {
            const operactionFinally = this.replaceValuesOperaction(charOperation, values);
            if (operactionFinally && this.validOperaction(operactionFinally)) {
              resultOperaction = calc(operactionFinally);
              if (resultOperaction && control.propiedades['cantidadDecimales']) {
                if (control.propiedades['roundFloorDecimal']) {
                  resultOperaction = Static.decimalAdjust(
                    'floor',
                    resultOperaction,
                    (Number(control.propiedades['cantidadDecimales']) * -1)
                  );
                } else if (control.propiedades['roundCeilDecimal']) {
                  resultOperaction = Static.decimalAdjust(
                    'ceil',
                    resultOperaction,
                    (Number(control.propiedades['cantidadDecimales']) * -1)
                  );
                } else {
                  resultOperaction = Static.decimalAdjust(
                    'round',
                    resultOperaction,
                    (Number(control.propiedades['cantidadDecimales']) * -1)
                  );
                }
              }
              if (resultOperaction) {
                if (control.propiedades['round']) {
                  resultOperaction = Math.round(resultOperaction);
                } else if (control.propiedades['roundFloor']) {
                  resultOperaction = Math.floor(resultOperaction);
                } else if (control.propiedades['roundCeil']) {
                  resultOperaction = Math.ceil(resultOperaction);
                } else if (control.propiedades['enteros']) {
                  resultOperaction = Math.round(resultOperaction);
                }
              }
            }
          } else if (
            control.tipo_campo.nombre === 'text' ||
            control.tipo_campo.nombre === 'textarea'
          ) {
            // tslint:disable-next-line:max-line-length
            resultOperaction = this.operactionText(opr.operacion.trim(), values, subForma.alias, control.alias);
          } else if (control.tipo_campo.nombre === 'date-time-picker') {
            resultOperaction = this.operationDate(charOperation, values);
            if (resultOperaction && resultOperaction.hasOwnProperty('quantityDays')) {
              if (resultOperaction && resultOperaction['date']) {
                if (
                  this.currentDateFormsControls[control.nombre_campo] &&
                  resultOperaction['date'] === this.currentDateFormsControls[control.nombre_campo].date &&
                  resultOperaction['quantityDays'] ===
                    this.currentDateFormsControls[control.nombre_campo].quantityDays
                ) {
                  resultOperaction = this.currentDateFormsControls[control.nombre_campo].dateResult;
                }
                if (
                  typeof resultOperaction === 'object' &&
                  resultOperaction['quantityDays'] &&
                  resultOperaction['date']
                ) {
                  const history: CalculateDatesWorkingDays = {
                    date: resultOperaction['date'],
                    quantityDays: resultOperaction['quantityDays'],
                    operaction: resultOperaction['operaction'],
                    dateResult: null
                  };
                  this.currentDateFormsControls[control.nombre_campo] = history;
                  const moment = require('moment');
                  const dateFormat = moment(resultOperaction['date'], ['DD/MM/YYYY', 'DD/MM/YYYY hh:mm:ss']);
                  if (resultOperaction['quantityDays']) {
                    // const controlsValues = {};
                    // Object.keys(subFormGroup.value).forEach(key => {
                    //   controlsValues[key] = new FormControl(subFormGroup.value[key]);
                    // });
                    // const form: FormGroup = new FormGroup(controlsValues);
                    if (resultOperaction['operaction'] === 'sumar') {
                      resultOperaction = await this.rdfds.getCalculateSumWorkingDays(
                        dateFormat, resultOperaction['quantityDays']
                      );
                    } else {
                      resultOperaction = await this.rdfds.getCalculateSubtractWorkingDays(
                        dateFormat, resultOperaction['quantityDays']
                      );
                    }
                    // Object.keys(form.value).forEach(key => {
                    //   subFormGroup.controls[key].setValue(form.value[key]);
                    //   // tslint:disable-next-line:max-line-length
                    //   this.formularios[indexFormAcumulate].form.controls[key].setValue(form.value[key]);
                    // });
                    this.currentDateFormsControls[control.nombre_campo].dateResult = resultOperaction;
                  } else {
                    resultOperaction = '';
                    this.currentDateFormsControls[control.nombre_campo].dateResult = null;
                  }
                } else if (typeof resultOperaction === 'object') {
                  resultOperaction = null;
                }
              } else {
                resultOperaction = null;
              }
            }
          } else if (
            control.tipo_campo.nombre === 'ngSelect' ||
            control.tipo_campo.nombre === 'email'
          ) {
            if (values['valor']) {
              resultOperaction = values['valor'];
            }
          } else if (control.tipo_campo.nombre === 'checkbox') {
            resultOperaction = values['valor'];
          }
        }
        resolve(resultOperaction);
      } catch (error) {
        this.toastr.error('Lo sentimos encontramos errores en alguna de las operaciones de los formularios',
                          'Error gramatical');
        reject(false);
      }
    });
  }

  /**
   * Remplaza las referencias de la operacion de entrada y retorna una operacion valida
   *
   * @private
   * @param {string} charOperation
   * @param {{}} values
   * @returns {string}
   * @memberof RefactorDynamicFormComponent
   */
  private replaceValuesOperaction(charOperation: string, values: {}): string {
    try {
      const moment = require('moment');
      const reservedSymbol: Array<any> = ['+', '-', '/', '*', '(', ')'];
      const reservedOperactions: Array<any> = [
        'diferenciaDias',
        'diferenciaMeses',
        'diferenciaAños'
      ];
      let operaction = '';
      let tmpVariable = '';
      let paramMethod = '';
      let method = false;
      for (let i = 0; i < charOperation.length; i++) {
        const searchM = reservedOperactions.indexOf(tmpVariable);
        if (searchM === -1 && !method) {
          const search = reservedSymbol.indexOf(charOperation.charAt(i));
          if (search === -1) {
            tmpVariable += charOperation.charAt(i);
          } else {
            if (values[tmpVariable]) {
              operaction += values[tmpVariable] + charOperation.charAt(i);
            } else if (values[tmpVariable] === false) {
              operaction = '';
              tmpVariable = '';
              break;
            } else {
              operaction += tmpVariable + charOperation.charAt(i);
            }
            tmpVariable = '';
          }
        } else {
          method = true;
          if (charOperation.charAt(i) !== ')') {
            if (charOperation.charAt(i) !== '(') {
              paramMethod += charOperation.charAt(i);
            }
          } else {
            const params = paramMethod.split(',');
            let value = 0;
            if (params.length === 2) {
              if (values[params[0]] && values[params[1]]) {
                const init = values[params[0]].split('/');
                const end = values[params[1]].split('/');
                if (init.length === 3 && end.length === 3) {
                  const dateInit = moment(init, ['DD/MM/YYYY', 'DD/MM/YYYY hh:mm:ss']);
                  const dateEnd = moment(end, ['DD/MM/YYYY', 'DD/MM/YYYY hh:mm:ss']);
                  switch (tmpVariable) {
                    case 'diferenciaDias':
                      value = dateEnd.diff(dateInit, 'days');
                      break;
                    case 'diferenciaMeses':
                      value = dateEnd.diff(dateInit, 'months');
                      break;
                    case 'diferenciaAños':
                      value = dateEnd.diff(dateInit, 'years');
                      break;
                  }
                }
              }
            }
            operaction += value;
            tmpVariable = '';
            method = false;
          }
        }
      }
      if (tmpVariable) {
        if (values[tmpVariable]) {
          operaction += values[tmpVariable];
        } else if (values[tmpVariable] === false) {
          operaction = '';
        } else {
          operaction += tmpVariable;
        }
        tmpVariable = '';
      }
      return operaction;
    } catch (error) {
      this.toastr.error('Lo sentimos encontramos errores en alguna de las operaciones de los formularios',
                        'Error gramatical');
    }
  }

  /**
   * Realiza las operaciones en los campos de tipo text y textarea
   *
   * @private
   * @param {string} charOperation
   * @param {{}} values
   * @param {string} nameForm
   * @param {string} nameControl
   * @returns {string}
   * @memberof RefactorDynamicFormComponent
   */
  private operactionText(charOperation: string, values: {}, nameForm: string, nameControl: string ): string {
    const reservedSymbol: Array<any> = ['{', '}'];
    let operaction = '';
    let tmpVariable = '';
    let functionRun = '';
    let aplicFunction = false;
    let openRef = false;
    for (let i = 0; i < charOperation.length; i++) {
      if (charOperation.charAt(i) !== '[' && !aplicFunction) {
        const search = reservedSymbol.indexOf(charOperation.charAt(i));
        if (search === -1) {
          if (openRef) {
            tmpVariable += charOperation.charAt(i);
            if (i === (charOperation.length - 1)) {
              operaction += tmpVariable;
            }
          } else {
            operaction += charOperation.charAt(i);
          }
        } else {
          if (!openRef && charOperation.charAt(i) === '{') {
            openRef = true;
          } else {
            if (values[tmpVariable]) {
              operaction += values[tmpVariable];
            } else if (!values[tmpVariable]) {
              operaction += '';
            } else {
              operaction += tmpVariable;
            }
            tmpVariable = '';
            if (openRef && charOperation.charAt(i) === '}') {
              openRef = false;
            }
          }
        }
      } else {
        aplicFunction = true;
        if (charOperation.charAt(i) !== ']') {
          if (charOperation.charAt(i) !== '[') {
            functionRun += charOperation.charAt(i);
          }
        } else {
          operaction += tmpVariable;
          tmpVariable = '';
          const functionSplit = functionRun.split('(');
          if (functionSplit.length >= 2) {
            const functionName = functionSplit[0];
            let tmpConcat = '';
            let functionConcat = '';
            functionSplit.forEach((el, index) => {
              if (index > 0) {
                tmpConcat += el;
              }
            });
            for (let l = 0; l < tmpConcat.length; l++) {
              if (l === (tmpConcat.length - 1)) {
                if (tmpConcat.charAt(l) !== ')') {
                  functionConcat += tmpConcat.charAt(l);
                }
              } else {
                functionConcat += tmpConcat.charAt(l);
              }
            }
            switch (functionName) {
              case 'concatenacionTabla':
                operaction += this.concatOperaction(nameForm, nameControl, functionConcat, values);
                break;
            }
          }
          functionRun = '';
          aplicFunction = false;
        }
      }
    }
    return operaction ? operaction : null;
  }

  /**
   * Ejecuta la operacion de concatenar las columnas de las tablas dinamicas
   *
   * @param {string} nameForm
   * @param {string} nameControl
   * @param {string} functionConcat
   * @param {*} values
   * @returns {string}
   * @memberof RefactorDynamicFormComponent
   */
  concatOperaction(nameForm: string, nameControl: string, functionConcat: string, values: any): string {
    const reservedSymbol: Array<any> = ['{', '}'];
    const refCaracter: Array<string> = [];
    const ref: Array<ValoresOperacionesControl> = [];
    let tmpRef = '';
    let concation = '';
    for (let i = 0; i < functionConcat.length; i++) {
      const search = reservedSymbol.indexOf(functionConcat.charAt(i));
      if (search === -1) {
        tmpRef += functionConcat.charAt(i);
      } else {
        refCaracter.push(tmpRef);
        tmpRef = '';
      }
    }
    for (const subForma of this.form.sub_formas) {
      if (subForma.alias === nameForm) {
        for (const control of subForma.campos) {
          if (control.alias === nameControl) {
            if (control.validaciones.operaciones.length) {
              for (const opr of control.validaciones.operaciones) {
                if (opr.operacion.trim().includes(functionConcat)) {
                  let form = '';
                  for (const value of opr.valores) {
                    const indexRef = refCaracter.indexOf(value.referencia);
                    if (indexRef !== -1) {
                      if (form === '' || form === value.formulario) {
                        ref.push(value);
                        form = value.formulario;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    if (ref.length) {
      let data = find(this.dataTable, {alias: ref[0].formulario});
      if (!data) {
        data = find(this.dataTableAll, {alias: ref[0].formulario});
      }

      if (data) {
        data.valores.forEach((val, index) => {
          let tmp = functionConcat;
          ref.forEach(r => {
            let value = '';
            if (data.valueSelects[data.labels[r.campo] + '_' + val['id']]) {
              value = data.valueSelects[data.labels[r.campo] + '_' + val['id']];
            } else {
              value = val[data.labels[r.campo]];
            }
            tmp = tmp.replace('{' + r.referencia + '}', value);
          });
          if (index === 0) {
            concation += tmp;
          } else {
            concation += ', ' + tmp;
          }
        });
      }
    }
    return concation;
  }

  /**
   * Ejecuta las operacionesde los campos tipo fecha
   *
   * @param {string} charOperation
   * @param {{}} values
   * @returns {(Date | SearchWorkingDays)}
   * @memberof RefactorDynamicFormComponent
   */
  operationDate(charOperation: string, values: {}): Date | SearchWorkingDays {
    try {
      const moment = require('moment');
      const calc = require('calculatorjs');
      const reservedOperactions: Array<any> = [
        'sumarDias(',
        'sumaDiasHabiles(',
        'sumarMeses(',
        'sumarAños(',
        'sumarHoras(',
        'sumarMinutos(',
        'restarDias(',
        'restaDiasHabiles(',
        'restarMeses(',
        'restarAños(',
        'restarHoras(',
        'restarMinutos(',
        'fecha(',
        'hora(',
      ];
      let operaction = '';
      let tmpVariable = '';
      let finalDate = '';
      let method = '';
      let isValid = false;

      for (let i = 0; i < charOperation.length; i++) {
        tmpVariable += charOperation.charAt(i);
        const search = reservedOperactions.indexOf(tmpVariable);
        if (search !== -1) {
          // if (i <= 11) {
            isValid = true;
          // }
        }
      }

      if (isValid) {
        const methodParameters = charOperation.split('(');
        if (methodParameters.length >= 2) {
          method = methodParameters[0];
          let parameters = '';
          methodParameters.forEach((el, index) => {
            if (index > 0) {
              parameters += el;
            }
          });
          if (parameters) {
            for (let i = 0; i < parameters.length; i++) {
              if (i === (parameters.length - 1)) {
                if (parameters.charAt(i) === ')') {
                  break;
                } else {
                  operaction += parameters.charAt(i);
                }
              } else {
                operaction += parameters.charAt(i);
              }
            }
            const param = operaction.split(',');
            const date = values[param[0]];
            if (param && param.length === 2) {
              const operationReplace = this.replaceValuesOperaction(param[1], values);
              if (operationReplace && this.validOperaction(operationReplace) && date) {
                const value = calc(operationReplace);
                const dateV = date.split('/');
                if (dateV.length === 3) {
                  const newDate = moment(date, ['DD/MM/YYYY', 'DD/MM/YYYY hh:mm:ss']);
                  switch (method) {
                    case 'sumarDias':
                      newDate.add(value, 'd');
                      break;
                    case 'sumaDiasHabiles':
                      const dateS: SearchWorkingDays = {
                        date: date,
                        quantityDays: value,
                        operaction: 'sumar',
                      };
                      return dateS;
                    case 'sumarMeses':
                      newDate.add(value, 'M');
                      break;
                    case 'sumarAños':
                      newDate.add(value, 'y');
                      break;
                    case 'sumarHoras':
                      newDate.add(value, 'h');
                      break;
                    case 'sumarMinutos':
                      newDate.add(value, 'm');
                      break;
                    case 'restarDias':
                      newDate.subtract(value, 'd');
                      break;
                    case 'restaDiasHabiles':
                      const dateR: SearchWorkingDays = {
                        date: date,
                        quantityDays: value,
                        operaction: 'restar',
                      };
                      return dateR;
                    case 'restarMeses':
                      newDate.subtract(value, 'M');
                      break;
                    case 'restarAños':
                      newDate.subtract(value, 'y');
                      break;
                    case 'restarHoras':
                      newDate.subtract(value, 'h');
                      break;
                    case 'restarMinutos':
                      newDate.subtract(value, 'm');
                      break;
                  }
                  finalDate = newDate;
                }
              } else {
                if (method === 'sumaDiasHabiles') {
                  const dateR: SearchWorkingDays = {
                    date: date,
                    quantityDays: null,
                    operaction: 'sumar',
                  };
                  return dateR;
                } else if ( method === 'restaDiasHabiles') {
                  const dateR: SearchWorkingDays = {
                    date: date,
                    quantityDays: null,
                    operaction: 'restar',
                  };
                  return dateR;
                }
              }
            } else if (param && param.length === 1 && date) {
              switch (method) {
                case 'fecha':
                  const dateV = date.split('/');
                  if (dateV.length === 3) {
                    finalDate = moment(date, ['DD/MM/YYYY', 'DD/MM/YYYY hh:mm:ss']);
                  }
                  break;
                case 'hora':
                  const timeV = date.split(':');
                  if (timeV.length === 3) {
                    finalDate = moment(date, ['hh:mm:ss']);
                  }
                  break;
              }
            }
          }
        }
      }
      if (method !== 'sumaDiasHabiles' && method !== 'restaDiasHabiles') {
        if (finalDate) {
          return new Date(finalDate);
        } else {
          if (values[charOperation]) {
            return values[charOperation];
          } else {
            return null;
          }
        }
      }
    } catch (error) {
      this.toastr.error('Lo sentimos encontramos errores en alguna de las operaciones de los formularios',
                        'Error gramatical');
    }
  }

  /**
   * Refesca el formulario indicado
   * Refresca los selects
   * Refresca las operaciones cuando el formulario esta gusradado pero estos cambios no se guardan
   *
   * @param {number} idForm
   * @param {string} aliasForm
   * @memberof RefactorDynamicFormComponent
   */
  async refreshFormormulario(idForm: number, aliasForm: string) {
    let formR: FormGroup;
    const subForm = find(this.form.sub_formas, {alias: aliasForm});
    for (const form of this.formularios) {
      if (form.name === aliasForm) {
        if (form.saved) {
          form.saved = false;
          this.cd.detectChanges();
        }
        formR = form.form;
        await this.validateForm();
        break;
      }
    }
    let data: Array<Datos>;
    if (subForm) {
      data = this.getDataForm(formR, subForm);
      await this.asyncForEach(subForm.campos, async (control: Control) => {
        if (control.tipo_campo.nombre === 'ngSelect') {
          const master = findLastIndex(this.acomulateColumns, {name: control.nombre_campo});
          if (master !== -1) {
            this.acomulateColumns.splice(master, 1);
          }
          if (subForm.tabla) {
            if (control.propiedades['tipoSelector'] !== 'EnModal') {
              await this.refresControlForm(subForm, control, data);
            } else {
              this.updatedControlColumns(control, subForm);
              control.propiedades['loadData'] = (idrecord?: any) => {
                return new Promise(async (resolve) => {
                  const formGr = find(this.formularios, {name: subForm.alias});
                  if (formGr) {
                    let ctrl: any;
                    if (idrecord) {
                      ctrl = await this.refresControlForm(
                        subForm,
                        control,
                        formGr.form.value,
                        false,
                        false,
                        true,
                        false,
                        '(' + String(idrecord) + ')'
                      );
                    } else {
                      ctrl = await this.refresControlForm(
                        subForm,
                        control,
                        formGr.form.value,
                        false,
                        false,
                        true,
                      );
                    }
                    resolve({
                      data: ctrl.propiedades['dataSelectorModal']
                    });
                  }
                  resolve([]);
                });
              };
            }
          }
        } else if (control.tipo_campo.nombre === 'date-time-picker') {
          delete this.currentDateFormsControls[control.nombre_campo];
        }
      });
    }
    if (data.length) {
      this.refreshForm(false, idForm, data);
    }

    const refresh = findIndex(this.formsRefresh, {name: aliasForm});
    if (refresh === -1) {
      this.formsRefresh.push({
        name: aliasForm
      });
    }

  }

  /**
   * Refresca la fuente de datos del la tabla indicada
   * Nota: El refrescar consiste en dejar en estado inicial los registros de la tabla
   *
   * @param {number} idForm
   * @memberof RefactorDynamicFormComponent
   */
  async refreshFountDataTable(idForm: number) {
    const subForm = find(this.form.sub_formas, {id_forma: idForm});
    if (this.dataTable.length) {
      const dataT = find(this.dataTable, {id_tabla: idForm});
      const index = findIndex(this.dataTable, {id_tabla: idForm});
      if (dataT) {
        await Static.asyncForEach(dataT.valores, async val => {
          await this.updatedTableFount(val, subForm, null, null, 'delete');
          await this.syncDataTable(val, subForm, {}, 'eliminar');
          this.syncDataTablesActually(val, subForm, 'eliminar');
        });
        this.dataTable.splice(index, 1);
      }
    }
    this.refreshForm(false, idForm);
  }

  /**
   * Retorna la data de un formulario en especifico con lo actualmente ingresado en el formulario
   *
   * @param {FormGroup} formData
   * @param {SubForma} subForm
   * @returns {Array<Datos>}
   * @memberof RefactorDynamicFormComponent
   */
  getDataForm(formData: FormGroup, subForm: SubForma): Array<Datos> {
    const data: Array<Datos> = [];
    subForm.campos.forEach(field => {
      let value: any;
      if (
        formData && formData.controls &&
        field.tipo_campo.nombre !== 'checkbox' &&
        field.tipo_campo.nombre !== 'coordenadas'
      ) {
        if (formData.controls[field.nombre_campo]) {
          value = formData.controls[field.nombre_campo].value;
        }
      }
      if (field.tipo_campo.nombre === 'checkbox') {
        value = false;
        if (formData && formData.controls && formData.controls[field.nombre_campo]) {
          if (formData.controls[field.nombre_campo].value) {
            value = formData.controls[field.nombre_campo].value;
          }
        }
        if (formData && formData.controls.hasOwnProperty(field.nombre_campo)) {
          data.push({
            id: field.id,
            nombre_campo: field.nombre_campo,
            alias_formulario: subForm.alias,
            alias: field.alias,
            nombre: field.label,
            valor: value,
            tipo: field.tipo_campo.nombre,
          });
        }
      } else if (field.tipo_campo.nombre === 'date-time-picker') {
        data.push({
          id: field.id,
          nombre_campo: field.nombre_campo,
          alias_formulario: subForm.alias,
          alias: field.alias,
          nombre: field.label,
          valor: value,
          tipo: field.tipo_campo.nombre,
          clasificacion: field.propiedades['tipo'],
        });
      } else if (field.tipo_campo.nombre === 'ngSelect') {
        data.push({
          id: field.id,
          nombre_campo: field.nombre_campo,
          alias_formulario: subForm.alias,
          alias: field.alias,
          nombre: field.label,
          valor: value,
          tipo: field.tipo_campo.nombre,
        });
      } else if (field.tipo_campo.nombre === 'coordenadas') {
        if (
          formData && formData.controls &&
          formData.controls.hasOwnProperty(field.nombre_campo + '_latitud') &&
          formData.controls[field.nombre_campo + '_latitud']
        ) {
          const latitud = formData.controls[field.nombre_campo + '_latitud'].value;
          const longitud = formData.controls[field.nombre_campo + '_longitud'].value;
          const altura = formData.controls[field.nombre_campo + '_altura'].value;
          const coodinate = {
            latitud: latitud ? latitud : '',
            longitud: longitud ? longitud : '',
            altura: altura ? altura : ''
          };
          data.push({
            id: field.id,
            nombre_campo: field.nombre_campo,
            alias_formulario: subForm.alias,
            alias: field.alias,
            nombre: field.label,
            valor: coodinate,
            tipo: field.tipo_campo.nombre,
          });
        }
      } else if (formData && formData.controls[field.nombre_campo]) {
        data.push({
          id: field.id,
          nombre_campo: field.nombre_campo,
          alias_formulario: subForm.alias,
          alias: field.alias,
          nombre: field.label,
          valor: value,
          tipo: field.tipo_campo.nombre,
        });
      }
    });
    return data;
  }

  /**
   * Valida que en la operacion sea correcta
   *
   * @private
   * @param {string} charOperation
   * @returns {boolean}
   * @memberof RefactorDynamicFormComponent
   */
  private validOperaction(charOperation: string): boolean {
    const letters: Array<any> = [
      'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
      'n', 'ñ', 'o', 'p', 'q', 'r', 's', 'u', 'v', 'w', 'x', 'y', 'z',
      'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
      'N', 'Ñ', 'O', 'P', 'Q', 'R', 'S', 'U', 'V', 'W', 'X', 'Y', 'Z',
      '!', '|', ',', '"', '#', '$', '%', '&', '=', '?', '¿', '¡', '´',
      '¨', '^', '{', '}', '[', ']', '`', '_', '_', ':', ';', ' '
    ];
    let operactionValid = false;
    for (let i = 0; i < charOperation.length; i++) {
      const search = letters.indexOf(charOperation.charAt(i));
      if (search === -1) {
        operactionValid = true;
      } else {
        operactionValid = false;
        break;
      }
    }

    return operactionValid;
  }

  /**
   * Cambia la configuracion del formulario para ocultar un campo especificado
   *
   * @private
   * @param {Array<BaseControl<Partial>>} form
   * @param {string} nameField
   * @param {boolean} hidden
   * @returns {Array<BaseControl<Partial>>}
   * @memberof RefactorDynamicFormComponent
   */
  private hiddenField(
    form: Array<BaseControl<Partial>>,
    nameField: string,
    hidden: boolean
  ): Array<BaseControl<Partial>> {
    form.forEach(field => {
      if (field.controlType !== 'container') {
        if (field.key === nameField) {
          field.hiddenCondiction = hidden;
        }
      } else {
        field['controls'] = this.hiddenField(field['controls'], nameField, hidden);
      }
    });
    return form;
  }

  /**
   * Cambia la configuracion del formulario para poner de solo lectura o escritura un campo especificado
   *
   * @private
   * @param {Array<BaseControl<Partial>>} form
   * @param {string} nameField
   * @param {boolean} readonly
   * @returns {Array<BaseControl<Partial>>}
   * @memberof RefactorDynamicFormComponent
   */
  private readonlyField(
    form: Array<BaseControl<Partial>>,
    nameField: string,
    readonly: boolean
  ): Array<BaseControl<Partial>> {
    form.forEach(field => {
      if (field.controlType !== 'container') {
        if (field.key === nameField) {
          field.readonly = readonly;
        }
      } else {
        field['controls'] = this.readonlyField(field['controls'], nameField, readonly);
      }
    });
    return form;
  }

  /**
   * Consulta si un campo dentro de un formulario esta oculto
   * 1 = Si
   * 0 = No
   * -1 = Campo no encontrado
   *
   * @private
   * @param {Array<BaseControl<Partial>>} form
   * @param {string} nameField
   * @returns {number}
   * @memberof RefactorDynamicFormComponent
   */
  private getHiddenField(
    form: Array<BaseControl<Partial>>,
    nameField: string
  ): number {
    let hidden = -1;
    form.forEach(field => {
      if (field.controlType !== 'container') {
        if (field.key === nameField) {
          if (field.hiddenCondiction) {
            hidden = 1;
          } else {
            hidden = 0;
          }
        }
      } else {
        hidden = this.getHiddenField(field['controls'], nameField);
      }
    });
    return hidden;
  }

  /**
   * Retorna el mes en cadena de texto
   * Nota: los meses inician desde 0 - Enero y finalizan en 11 - Diciembre
   *
   * @private
   * @param {number} month
   * @returns {string}
   * @memberof RefactorDynamicFormComponent
   */
  private getStringMonth(month: number): string {
    let stringMonth = '';
    if (month > -1 && month <= 11) {
      switch (month) {
        case 0:
          stringMonth = 'Enero';
          break;
        case 1:
          stringMonth = 'Febrero';
          break;
        case 2:
          stringMonth = 'Marzo';
          break;
        case 3:
          stringMonth = 'Abril';
          break;
        case 4:
          stringMonth = 'Mayo';
          break;
        case 5:
          stringMonth = 'Junio';
          break;
        case 6:
          stringMonth = 'Julio';
          break;
        case 7:
          stringMonth = 'Agosto';
          break;
        case 8:
          stringMonth = 'Septiembre';
          break;
        case 9:
          stringMonth = 'Obtubre';
          break;
        case 10:
          stringMonth = 'Noviembre';
          break;
      }
    }
    return stringMonth;
  }

  /**
   * Actualiza la opcion de los requisitos de la lista de chequeo
   *
   * @private
   * @param {*} data
   * @param {SubForma} form
   * @memberof RefactorDynamicFormComponent
   */
  private async selectCheckList(data: any, form: SubForma) {
    if (data.row && data.row.tabla) {
      const table = find(this.dataTable, {id_tabla: form.id_forma});
      if (table) {
        table.valores[data.row.index][table.labels[table.alias + '_opciones']] = data.value;
        await this.syncCheckList(data.row, form, 'modificar');
        await this.syncCheckListCurrent(data.row, form, 'modificar', true);
      }
    }
    this.purgeDataTable(this.dataTable);
    this.valid();
  }

  /**
   * Abrir formulario en modal de la la tabla dinamica
   *
   * @memberof RefactorDynamicFormComponent
   */
  openModalForm() {
    this.modalRef = this.modalService.show(
      this.templateModal,
      {
        class: 'modal-lg-personalized',
        keyboard: false,
        ignoreBackdropClick: true
      }
    );

    this.showForms[this.formSelect.alias] = true;
      if (!(this.cd as ViewRef).destroyed) {
        this.cd.detectChanges();
      }
  }

  /**
   * Cerrar formulario en modal de la tabla dinamica
   *
   * @memberof RefactorDynamicFormComponent
   */
  closeModalForm() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  /**
   * Ejecuta un for de forma sincronica
   *
   * @param {Array<any>} array
   * @param {*} callback
   * @memberof RefactorDynamicFormComponent
   */
  async asyncForEach(array: Array<any>, callback: any) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
      continue;
    }
  }


  /**
   * Actualiza las columans de un selector
   *
   * @param {Control} control
   * @param {SubForma} [subForm]
   * @memberof RefactorDynamicFormComponent
   */
  updatedControlColumns(control: Control, subForm?: SubForma) {
    const conditionsColumns = this.validCondictionsColumns(control);
    let selectionsColumns: string[] = [];
    const dataChange = {};
    selectionsColumns = conditionsColumns.columns;
    if (control.placeholder !== conditionsColumns.placeholder) {
      dataChange['placeholder'] =  conditionsColumns.placeholder;
      dataChange['columns'] =  conditionsColumns.columnsModal;
      if (subForm && subForm.formulario && subForm.formulario.length) {
        const controlIndexForm = findIndex(subForm.formulario[0]['controls'], {key: control.nombre_campo})
        if (controlIndexForm !== -1) {
          subForm.formulario[0]['controls'][controlIndexForm]['placeholder'] = conditionsColumns.placeholder;
          subForm.formulario[0]['controls'][controlIndexForm]['columns'] = conditionsColumns.columnsModal;
        }
      }
    } else {
      dataChange['placeholder'] =  control.placeholder;
      dataChange['columns'] =  control.propiedades['columnsSelectorModal'];
      if (subForm && subForm.formulario && subForm.formulario.length) {
        const controlIndexForm = findIndex(subForm.formulario[0]['controls'], {key: control.nombre_campo})
        if (controlIndexForm !== -1) {
          subForm.formulario[0]['controls'][controlIndexForm]['placeholder'] = control.placeholder;
          subForm.formulario[0]['controls'][controlIndexForm]['columns'] = control.propiedades['columnsSelectorModal'];
        }
      }
    }
    this.gns.set<any>({
      source: 'multipleProperties',
      destiny: control.alias + '-' + control.nombre_campo,
      action: 'loadingData',
      eventTriggered: 'change',
      data: <any> dataChange
    }, true);
  }

  /**
   * Consulta y refresca las opciones de los selects
   *
   * @private
   * @param {SubForma} subForm
   * @param {Control} control
   * @param {Datos[]} [dataForm]
   * @param {boolean} [update=false]
   * @param {boolean} [refreshForm=true]
   * @param {boolean} [returnControl=false]
   * @param {boolean} [dataFormulario=true]
   * @param {string} [idRecord]
   * @return {*}  {Promise<any>}
   * @memberof RefactorDynamicFormComponent
   */
  private async refresControlForm(
    subForm: SubForma,
    control: Control,
    dataForm?: Datos[],
    update: boolean = false,
    refreshForm: boolean = true,
    returnControl: boolean = false,
    dataFormulario: boolean = true,
    idRecord?: string
  ): Promise<any> {
    return new Promise(async (resolve) => {
      if (control.tipo_campo.nombre === 'ngSelect') {
        let selectionsColumns: string[] = [];
        const columnsMaster: Array<Option> = [];
        const condictionsColumns = this.validCondictionsColumns(control);
        selectionsColumns = condictionsColumns.columns;
        if (control.placeholder !== condictionsColumns.placeholder) {
          control.propiedades['columns_condicion'] = condictionsColumns.columns;
          control.propiedades['placeholder_condicion'] = condictionsColumns.placeholder;
          control.propiedades['condictions_modal_condicion'] = condictionsColumns.columnsModal;
        } else {
          control.propiedades['columns_condicion'] = null;
          control.propiedades['placeholder_condicion'] = null;
          control.propiedades['condictions_modal_condicion'] = null;
        }
        if (control.propiedades.tipo === 'TablaMaestra') {
          let specificEstructure: EstructuraEspecifica;
          let filterMaster: FiltroTableMasterGeneral[] = [];
          let columns: ValoresEspecificos[] = [];
          const colsMaster = find(this.acomulateColumns, {name: control.nombre_campo});
          if (!colsMaster) {
            specificEstructure = this.getStrutureSpecific(control, selectionsColumns);
            if (control.validaciones && control.validaciones.filtros && control.validaciones.filtros.length) {
              this.loadingStructureDependenceFiltros(
                specificEstructure,
                control.validaciones.filtros,
                control.lista_maestra[0]['estructura'],
              );
              filterMaster = this.GenerateFiltersMasterTable(control.validaciones.filtros, dataForm);
            }
            let validSearch = false;
            if (filterMaster.length === 1) {
              if (filterMaster[0].operador === 'IS NULL' || filterMaster[0].operador === 'IS NOT NULL') {
                validSearch = true;
              } else {
                if (filterMaster[0].valor) {
                  validSearch = true;
                }
              }
            } else if (filterMaster.length > 1) {
              validSearch = true;
            } else if (!filterMaster.length) {
              validSearch = true;
            }
            if (validSearch) {
              const filterSede = {};
              if (this.task && control.propiedades['validar_sede']) {
                filterSede['columna'] = control.propiedades['columna_validar_sede'];
                filterSede['tarea'] = this.taskActually.id;
              }
              columns = await this.rdfds.getColumnsSpecificMasterTable(
                specificEstructure,
                filterMaster,
                idRecord,
                filterSede
              );
            }
          } else {
            columns = colsMaster.columns;
          }

          columns.forEach(column => {
            let labelSelect = '';
            const optionsSelect = {};
            selectionsColumns.forEach((col, index) => {
              if (index > 0) {
                labelSelect += ' / ';
              }
              if (column.valores[col]) {
                labelSelect += column.valores[col];
                optionsSelect[col] = column.valores[col];
              } else {
                labelSelect += 'No aplica';
                optionsSelect[col] = 'No aplica';
              }
            });
            columnsMaster.push({value: column.id, key: labelSelect, others: optionsSelect});
          });

          if (control.propiedades['tipoSelector'] && control.propiedades['tipoSelector'] === 'EnModal') {
            const dataModalSelector: Array<any> = [];
            columns.forEach(row => {
              const d = Static.copyObjet(row.valores);
              d['id'] = row.id;
              dataModalSelector.push(d);
            });
            control.propiedades['dataSelectorModal'] = dataModalSelector;
          }

          control.propiedades['options'] = columnsMaster;
          if (this.dataTable.length) {
            this.dataTable.forEach(data => {
              if (data.alias === subForm.alias) {
                const d: any = this.loadingDataTable(subForm.id_forma);
                subForm.datos = new LocalDataSource(d);
                subForm.datos.refresh();
              }
            });
          }
        } else if (control.propiedades.tipo === 'RadicadosSistema') {
          const optionsDocuments: OptionDocumentsAssociations[] = [];
          const columnsModal: ColumnsTableModalSelect[] = [
            {
              key: 'key',
              label: 'Radicado',
              type: 'text'
            },
            {
              key: 'fecha_radicado',
              label: 'Fecha radicado',
              type: 'date-time-picker',
              category: 'calendar'
            },
          ];
          if (
            control.propiedades['tipo_documento_radicado'] &&
            control.propiedades['tipo_documento_radicado'].length
          ) {
            const listDocumentsAssociation = await this.rdfds.getDocumentAssociateProcess(
              control.propiedades['tipo_documento_radicado']
            );
            if (listDocumentsAssociation.length) {
              listDocumentsAssociation.forEach(document => {
                optionsDocuments.push({
                  id: document.tramite_id,
                  key: document.radicado,
                  value: document.tramite_id,
                  expediente: document.expediente,
                  fecha_radicado: document.fecha_radicado
                });
              });
            }
          }
          control.propiedades['columnsSelectorModal'] = columnsModal;
          control.propiedades['dataSelectorModal'] = optionsDocuments;
          control.propiedades['options'] = optionsDocuments;
        } else if (control.propiedades.tipo === 'ConsecutivosActas') {
          const optionsActas: OptionActas[] = [];
          const columnsModal: ColumnsTableModalSelect[] = [
            {
              key: 'consecutivo',
              label: 'Consecutivo acta AUCTIFF',
              type: 'text'
            },
          ];
          let value: any;
          if (this.finishTask) {
            if (dataForm) {
              const dataField = find(dataForm, {nombre_campo: control.nombre_campo});
              if (dataField) {
                value = dataField.valor;
              }
            } else {
              const dataField = find(this.data, {nombre_campo: control.nombre_campo});
              if (dataField) {
                value = dataField.valor;
              }
            }
          }
          const actas = await this.rdfds.getActasAUCTIFF(value);
          if (actas && actas.length) {
            actas.forEach(acta => {
              optionsActas.push({
                id: acta.idtalonario_acta,
                key: String(acta.consecutivo),
                consecutivo: String(acta.consecutivo),
                value: acta.idtalonario_acta
              });
            });
          }
          control.propiedades['columnsSelectorModal'] = columnsModal;
          control.propiedades['dataSelectorModal'] = optionsActas;
          control.propiedades['options'] = optionsActas;
        } else {
          if (
            control.propiedades['cargar_tabla'] &&
            control.propiedades['cargar_tabla']['form']
          ) {
            let formSelect: SubForma;
            if (this.form.alias === control.propiedades['cargar_tabla']['form']) {
              formSelect = find(this.form.sub_formas, {alias: control.propiedades['cargar_tabla']['formulario']});
              if (formSelect) {
                if (this.dataTable.length) {
                  this.dataTable.forEach(data => {
                    if (data.alias === formSelect.alias) {
                      data.valores.forEach(val => {
                        let labelSelect = '';
                        const optionsSelect = {};
                        let valid = true;
                        const groupsFilters: Array<FiltrosSelectores[]> = [];
                        selectionsColumns.forEach(async (col, index) => {
                          if (control.validaciones.filtros && control.validaciones.filtros.length) {
                            control.validaciones.filtros.sort((a, b) => a.index - b.index);
                            const validsFilters: Array<boolean> = [];
                            let groupFilter: FiltrosSelectores[] = [];
                            control.validaciones.filtros.forEach((filter, indexF) => {
                              groupFilter.push({
                                columna: filter.columna,
                                operador: filter.operador,
                                form: filter.form,
                                formulario: filter.formulario,
                                field: filter.field,
                                valor: filter.valor,
                                condicional: filter.condicional,
                                index: filter.index
                              });
                              if (
                                (filter.condicional && filter.condicional.toLowerCase() === 'o') ||
                                indexF === (control.validaciones.filtros.length - 1)
                              ) {
                                const tmpGroup: FiltrosSelectores[] = [];
                                groupFilter.forEach(filterG => {
                                  tmpGroup.push({
                                    columna: filterG.columna,
                                    operador: filterG.operador,
                                    form: filter.form,
                                    formulario: filter.formulario,
                                    field: filter.field,
                                    valor: filterG.valor,
                                    condicional: filterG.condicional,
                                    index: filterG.index
                                  });
                                });
                                groupsFilters.push(tmpGroup);
                                groupFilter = [];
                              }
                            });
                            if (groupsFilters.length) {
                              for (const filters of groupsFilters) {
                                const validFilter: Array<boolean> = [];
                                for (const filter of filters) {
                                  let valFilter = false;
                                  if (!filter.form) {
                                    switch (filter.operador) {
                                      case '!=':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] !== filter.valor
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case '>':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] > filter.valor
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case '>=':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] >= filter.valor
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case '<':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] < filter.valor
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case '<=':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] <= filter.valor
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case 'IS NULL':
                                        if (!val[data.labels[filter.columna]]) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case 'IS NOT NULL':
                                        if (val[data.labels[filter.columna]]) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case 'LIKE':
                                        if (val[data.labels[filter.columna]]) {
                                          const exist = val[data.labels[filter.columna]].indexOf(filter.valor);
                                          if (exist !== -1) {
                                            valFilter = true;
                                          } else {
                                            valFilter = false;
                                          }
                                        }
                                        break;
                                      case 'ILIKE':
                                        if (val[data.labels[filter.columna]]) {
                                          // tslint:disable-next-line:max-line-length
                                          const exist = val[data.labels[filter.columna]].toLowerCase().indexOf(filter.valor.toLowerCase());
                                          if (exist !== -1) {
                                            valFilter = true;
                                          } else {
                                            valFilter = false;
                                          }
                                        }
                                        break;
                                      case 'IN':
                                      if (val[data.labels[filter.columna]]) {
                                          let valueF = filter.valor;
                                          valueF = valueF.replace(/'/g, '');
                                          valueF = valueF.replace(/"/g, '');
                                          valueF = valueF.replace(/\s/g, '');
                                          valueF = valueF.slice(1, -1);
                                          const arrayValor = valueF.split(',');
                                          const exist = arrayValor.indexOf(val[data.labels[filter.columna]]);
                                          if (exist !== -1) {
                                            valFilter = true;
                                          } else {
                                            valFilter = false;
                                          }
                                        }
                                        break;
                                      case 'NOT IN':
                                        if (val[data.labels[filter.columna]]) {
                                          let valueF = filter.valor;
                                          valueF = valueF.replace(/'/g, '');
                                          valueF = valueF.replace(/"/g, '');
                                          valueF = valueF.replace(/\s/g, '');
                                          valueF = valueF.slice(1, -1);
                                          const arrayValor = valueF.split(',');
                                          const exist = arrayValor.indexOf(val[data.labels[filter.columna]]);
                                          if (exist === -1) {
                                            valFilter = true;
                                          } else {
                                            valFilter = false;
                                          }
                                        }
                                        break;
                                      default:
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          String(val[data.labels[filter.columna]]) === String(filter.valor)
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                    }
                                  } else {
                                    let valorField: any;
                                    if (this.task && this.form.alias === filter.form) {
                                      const formulario = find(this.form.sub_formas, {alias: filter.formulario});
                                      if (
                                        formulario &&
                                        (
                                          !formulario.tabla ||
                                          (this.formSelect && formulario.alias === this.formSelect.alias) ||
                                          control.propiedades['columna_general']
                                        )
                                      ) {
                                        const field = find(formulario.campos, {alias: filter.field});
                                        if (field) {
                                          const form = find(this.formularios, {name: formulario.alias});
                                          if (form && dataFormulario) {
                                            valorField = form.form.controls[field.nombre_campo].value;
                                          } else if (dataForm) {
                                            valorField = dataForm[field.nombre_campo];
                                          }
                                        }
                                      } else if (formulario) {
                                        valorField = [];
                                        if (this.dataTable && this.dataTable.length) {
                                          this.dataTable.forEach(tableData => {
                                            if (tableData.alias === formulario.alias) {
                                              tableData.valores.forEach(valD => {
                                                if (valD[tableData.labels[filter.field]]) {
                                                  valorField.push(valD[tableData.labels[filter.field]]);
                                                }
                                              });
                                            }
                                          });
                                        }
                                      } else {
                                        continue;
                                      }
                                    } else {
                                      if (
                                        this.taskActually &&
                                        this.taskActually.tarea_asociacion &&
                                        this.taskActually.tarea_asociacion.length
                                      ) {
                                        for (const association of this.taskActually.tarea_asociacion) {
                                          if (association.alias === filter.form) {
                                            if (association.datos) {
                                              const field = find(association.datos,
                                                {
                                                  alias_formulario: filter.formulario,
                                                  alias: filter.field
                                                }
                                              );
                                              if (field) {
                                                valorField = field.valor;
                                                break;
                                              }
                                            }
                                          }
                                        }
                                        if (!valorField) {
                                          valorField = [];
                                          this.dataTableAll.forEach(tableData => {
                                            if (tableData.alias === filter.formulario) {
                                              tableData.valores.forEach(valD => {
                                                if (valD[tableData.labels[filter.field]]) {
                                                  valorField.push(valD[tableData.labels[filter.field]]);
                                                }
                                              });
                                            }
                                          });
                                        }
                                      }
                                    }

                                    if (!valorField) {
                                      valorField = '';
                                    }

                                    switch (filter.operador) {
                                      case '!=':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] !== valorField
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case '>':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] > valorField
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case '>=':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] >= valorField
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case '<':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] < valorField
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case '<=':
                                        if (
                                          val[data.labels[filter.columna]] &&
                                          val[data.labels[filter.columna]] <= valorField
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case 'IS NULL':
                                        if (!val[data.labels[filter.columna]]) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case 'IS NOT NULL':
                                        if (val[data.labels[filter.columna]]) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                      case 'LIKE':
                                        if (val[data.labels[filter.columna]]) {
                                          const exist = val[data.labels[filter.columna]].indexOf(valorField);
                                          if (exist !== -1) {
                                            valFilter = true;
                                          } else {
                                            valFilter = false;
                                          }
                                        }
                                        break;
                                      case 'ILIKE':
                                        if (val[data.labels[filter.columna]]) {
                                          // tslint:disable-next-line:max-line-length
                                          const exist = val[data.labels[filter.columna]].toLowerCase().indexOf(valorField.toLowerCase());
                                          if (exist !== -1) {
                                            valFilter = true;
                                          } else {
                                            valFilter = false;
                                          }
                                        }
                                        break;
                                      case 'IN':
                                      if (val[data.labels[filter.columna]]) {
                                          const exist = valorField.indexOf(val[data.labels[filter.columna]]);
                                          if (exist !== -1) {
                                            valFilter = true;
                                          } else {
                                            valFilter = false;
                                          }
                                        }
                                        break;
                                      case 'NOT IN':
                                        if (val[data.labels[filter.columna]]) {
                                          const exist = valorField.indexOf(val[data.labels[filter.columna]]);
                                          if (exist === -1) {
                                            valFilter = true;
                                          } else {
                                            valFilter = false;
                                          }
                                        }
                                        break;
                                      default:
                                        if (
                                          (
                                            val[data.labels[filter.columna]] ||
                                            typeof val[data.labels[filter.columna]] === 'boolean'
                                          ) &&
                                          val[data.labels[filter.columna]] === valorField
                                        ) {
                                          valFilter = true;
                                        } else {
                                          valFilter = false;
                                        }
                                        break;
                                    }
                                  }
                                  validFilter.push(valFilter);
                                }
                                if (validFilter.length) {
                                  validFilter.forEach((valF, indexVF) => {
                                    if (indexVF === (validFilter.length - 1)) {
                                        validsFilters.push(valF);
                                    } else {
                                      if (!valF) {
                                        validsFilters.push(false);
                                      }
                                    }
                                  });
                                }
                              }
                              if (validsFilters.length) {
                                for (const valFS of validsFilters) {
                                  if (valFS) {
                                    valid = true;
                                    break;
                                  } else {
                                    valid = false;
                                  }
                                }
                              }
                            }
                          }
                          if (valid) {
                            const colP = col.split('-');
                            const field = find(formSelect.campos, {alias: colP[0]});
                            if (index > 0) {
                              labelSelect += ' / ';
                            }
                            if (val[data.labels[colP[0]]]) {
                              if (field && field.tipo_campo.nombre === 'ngSelect') {
                                if (colP.length && colP.length > 1) {
                                  let textColumn = '';
                                  colP.forEach((c, i) => {
                                    if (i > 0) {
                                      textColumn += c;
                                      if (i < (colP.length - 1)) {
                                        textColumn += '-';
                                      }
                                    }
                                  });
                                  const valColum = data.valueSelects[field.nombre_campo + '_' + val['id']][textColumn];
                                  if (valColum) {
                                  labelSelect += valColum;
                                  optionsSelect[col] = valColum;
                                  } else {
                                    labelSelect += 'No aplica';
                                    optionsSelect[col] = 'No aplica';
                                  }
                                } else {
                                  labelSelect += 'No aplica';
                                  optionsSelect[col] = 'No aplica';
                                }
                              } else if (field && field.tipo_campo.nombre === 'checkbox') {
                                labelSelect += 'Sí';
                                optionsSelect[col] = 'Sí';
                              } else {
                                labelSelect += val[data.labels[colP[0]]];
                                optionsSelect[col] = val[data.labels[colP[0]]];
                              }
                            } else {
                              optionsSelect[col] = 'No aplica';
                            }
                          }
                        });
                        if (valid) {
                          columnsMaster.push({value: val.id, key: labelSelect, others: optionsSelect});
                        }
                      });
                      if (control.propiedades['tipoSelector'] && control.propiedades['tipoSelector'] === 'EnModal') {
                        const dataModalSelector: Array<any> = [];
                        data.valores.forEach(row => {
                          const d = Static.copyObjet(row);
                          Object.keys(d).forEach(key => {
                            if (data.valueSelects[key + '_' + d['id']]) {
                              d[key] = data.valueSelects[key + '_' + d['id']];
                            }
                          });
                          dataModalSelector.push(d);
                        });
                        control.propiedades['dataSelectorModal'] = dataModalSelector;
                        if (
                          control.propiedades['columnsSelectorModal'] &&
                          control.propiedades['columnsSelectorModal'].length
                        ) {
                          control.propiedades['columnsSelectorModal'].forEach((column: ColumnsTableModalSelect) => {
                            if (data.labels[column.key]) {
                              column.key = data.labels[column.key];
                            }
                          });
                        }
                      }
                      control.propiedades['options'] = columnsMaster;
                      if (this.dataTable.length && dataFormulario) {
                        this.dataTable.forEach(dataT => {
                          if (dataT.alias === subForm.alias) {
                            const d: any = this.loadingDataTable(subForm.id_forma);
                            subForm.datos = new LocalDataSource(d);
                            subForm.datos.refresh();
                          }
                        });
                      }
                    }
                  });
                }
              }
            } else {
              const dataT = find(this.dataTableAll, {alias: control.propiedades['cargar_tabla']['formulario']});
              if (dataT) {
                dataT.valores.forEach(val => {
                  let labelSelect = '';
                  const optionsSelect = {};
                  let valid = true;
                  const groupsFilters: Array<FiltrosSelectores[]> = [];
                  selectionsColumns.forEach((col, index) => {
                    if (control.validaciones.filtros && control.validaciones.filtros.length) {
                      control.validaciones.filtros.sort((a, b) => a.index - b.index);
                      const validsFilters: Array<boolean> = [];
                      let groupFilter: FiltrosSelectores[] = [];
                      control.validaciones.filtros.forEach((filter, indexF) => {
                        groupFilter.push({
                          columna: filter.columna,
                          operador: filter.operador,
                          form: filter.form,
                          formulario: filter.formulario,
                          field: filter.field,
                          valor: filter.valor,
                          condicional: filter.condicional,
                          index: filter.index
                        });
                        if (
                          (filter.condicional && filter.condicional.toLowerCase() === 'o') ||
                          indexF === (control.validaciones.filtros.length - 1)
                        ) {
                          const tmpGroup: FiltrosSelectores[] = [];
                          groupFilter.forEach(filterG => {
                            tmpGroup.push({
                              columna: filterG.columna,
                              operador: filterG.operador,
                              form: filter.form,
                              formulario: filter.formulario,
                              field: filter.field,
                              valor: filterG.valor,
                              condicional: filterG.condicional,
                              index: filterG.index
                            });
                          });
                          groupsFilters.push(tmpGroup);
                          groupFilter = [];
                        }
                      });
                      if (groupsFilters.length) {
                        for (const filters of groupsFilters) {
                          const validFilter: Array<boolean> = [];
                          for (const filter of filters) {
                            let valFilter = false;
                            if (!filter.form) {
                              switch (filter.operador) {
                                case '!=':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] !== filter.valor
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case '>':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] > filter.valor
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case '>=':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] >= filter.valor
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case '<':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] < filter.valor
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case '<=':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] <= filter.valor
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case 'IS NULL':
                                  if (!val[dataT.labels[filter.columna]]) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case 'IS NOT NULL':
                                  if (val[dataT.labels[filter.columna]]) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case 'LIKE':
                                  if (val[dataT.labels[filter.columna]]) {
                                    const exist = val[dataT.labels[filter.columna]].indexOf(filter.valor);
                                    if (exist !== -1) {
                                      valFilter = true;
                                    } else {
                                      valFilter = false;
                                    }
                                  }
                                  break;
                                case 'ILIKE':
                                  if (val[dataT.labels[filter.columna]]) {
                                    // tslint:disable-next-line:max-line-length
                                    const exist = val[dataT.labels[filter.columna]].toLowerCase().indexOf(filter.valor.toLowerCase());
                                    if (exist !== -1) {
                                      valFilter = true;
                                    } else {
                                      valFilter = false;
                                    }
                                  }
                                  break;
                                case 'IN':
                                if (val[dataT.labels[filter.columna]]) {
                                    let valueF = filter.valor;
                                    valueF = valueF.replace(/'/g, '');
                                    valueF = valueF.replace(/"/g, '');
                                    valueF = valueF.replace(/\s/g, '');
                                    valueF = valueF.slice(1, -1);
                                    const arrayValor = valueF.split(',');
                                    const exist = arrayValor.indexOf(val[dataT.labels[filter.columna]]);
                                    if (exist !== -1) {
                                      valFilter = true;
                                    } else {
                                      valFilter = false;
                                    }
                                  }
                                  break;
                                case 'NOT IN':
                                  if (val[dataT.labels[filter.columna]]) {
                                    let valueF = filter.valor;
                                    valueF = valueF.replace(/'/g, '');
                                    valueF = valueF.replace(/"/g, '');
                                    valueF = valueF.replace(/\s/g, '');
                                    valueF = valueF.slice(1, -1);
                                    const arrayValor = valueF.split(',');
                                    const exist = arrayValor.indexOf(val[dataT.labels[filter.columna]]);
                                    if (exist === -1) {
                                      valFilter = true;
                                    } else {
                                      valFilter = false;
                                    }
                                  }
                                  break;
                                default:
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] === filter.valor
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                              }
                            } else {
                              let valorField: any;
                              if (this.task && this.form.alias === filter.form) {
                                const formulario = find(this.form.sub_formas, {alias: filter.formulario});
                                if (
                                  formulario &&
                                  (
                                    !formulario.tabla ||
                                    (this.formSelect && formulario.alias === this.formSelect.alias)
                                  )
                                ) {
                                  const field = find(formulario.campos, {alias: filter.field});
                                  if (field) {
                                    const form = find(this.formularios, {name: formulario.alias});
                                    if (form) {
                                      valorField = form.form.controls[field.nombre_campo].value;
                                    }
                                  }
                                } else if (formulario) {
                                  valorField = [];
                                  if (this.dataTable && this.dataTable.length) {
                                    this.dataTable.forEach(tableData => {
                                      if (tableData.alias === formulario.alias) {
                                        tableData.valores.forEach(valD => {
                                          if (valD[tableData.labels[filter.field]]) {
                                            valorField.push(valD[tableData.labels[filter.field]]);
                                          }
                                        });
                                      }
                                    });
                                  }
                                } else {
                                  continue;
                                }
                              } else {
                                if (
                                  this.taskActually &&
                                  this.taskActually.tarea_asociacion &&
                                  this.taskActually.tarea_asociacion.length
                                ) {
                                  for (const association of this.taskActually.tarea_asociacion) {
                                    if (association.alias === filter.form) {
                                      if (association.datos) {
                                        const field = find(association.datos, {alias: filter.field});
                                        if (field) {
                                          valorField = field.valor;
                                          break;
                                        }
                                      }
                                    }
                                  }
                                  if (!valorField) {
                                    valorField = [];
                                    this.dataTableAll.forEach(tableData => {
                                      if (tableData.alias === filter.formulario) {
                                        tableData.valores.forEach(valD => {
                                          if (valD[tableData.labels[filter.field]]) {
                                            valorField.push(valD[tableData.labels[filter.field]]);
                                          }
                                        });
                                      }
                                    });
                                  }
                                }
                              }

                              if (!valorField) {
                                valorField = '';
                              }

                              switch (filter.operador) {
                                case '!=':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] !== valorField
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case '>':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] > valorField
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case '>=':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] >= valorField
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case '<':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] < valorField
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case '<=':
                                  if (
                                    val[dataT.labels[filter.columna]] &&
                                    val[dataT.labels[filter.columna]] <= valorField
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case 'IS NULL':
                                  if (!val[dataT.labels[filter.columna]]) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case 'IS NOT NULL':
                                  if (val[dataT.labels[filter.columna]]) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                                case 'LIKE':
                                  if (val[dataT.labels[filter.columna]]) {
                                    const exist = val[dataT.labels[filter.columna]].indexOf(valorField);
                                    if (exist !== -1) {
                                      valFilter = true;
                                    } else {
                                      valFilter = false;
                                    }
                                  }
                                  break;
                                case 'ILIKE':
                                  if (val[dataT.labels[filter.columna]]) {
                                    // tslint:disable-next-line:max-line-length
                                    const exist = val[dataT.labels[filter.columna]].toLowerCase().indexOf(valorField.toLowerCase());
                                    if (exist !== -1) {
                                      valFilter = true;
                                    } else {
                                      valFilter = false;
                                    }
                                  }
                                  break;
                                case 'IN':
                                if (val[dataT.labels[filter.columna]]) {
                                    const exist = valorField.indexOf(val[dataT.labels[filter.columna]]);
                                    if (exist !== -1) {
                                      valFilter = true;
                                    } else {
                                      valFilter = false;
                                    }
                                  }
                                  break;
                                case 'NOT IN':
                                  if (val[dataT.labels[filter.columna]]) {
                                    const exist = valorField.indexOf(val[dataT.labels[filter.columna]]);
                                    if (exist === -1) {
                                      valFilter = true;
                                    } else {
                                      valFilter = false;
                                    }
                                  }
                                  break;
                                default:
                                  if (
                                    (
                                      val[dataT.labels[filter.columna]] ||
                                      typeof val[dataT.labels[filter.columna]] === 'boolean'
                                    ) &&
                                    val[dataT.labels[filter.columna]] === valorField
                                  ) {
                                    valFilter = true;
                                  } else {
                                    valFilter = false;
                                  }
                                  break;
                              }
                            }
                            validFilter.push(valFilter);
                          }
                          if (validFilter.length) {
                            validFilter.forEach((valF, indexVF) => {
                              if (indexVF === (validFilter.length - 1)) {
                                  validsFilters.push(valF);
                              } else {
                                if (!valF) {
                                  validsFilters.push(false);
                                }
                              }
                            });
                          }
                        }
                        if (validsFilters.length) {
                          for (const valFS of validsFilters) {
                            if (valFS) {
                              valid = true;
                              break;
                            } else {
                              valid = false;
                            }
                          }
                        }
                      }
                    }
                    if (valid) {
                      const colP = col.split('-');
                      if (index > 0) {
                        labelSelect += ' / ';
                      }
                      if (val[dataT.labels[colP[0]]]) {
                        if (dataT.valueSelects[dataT.labels[colP[0]] + '_' + val['id']]) {
                          if (
                            colP.length === 1 &&
                            typeof dataT.valueSelects[dataT.labels[colP[0]] + '_' + val['id']] !== 'object'
                          ) {
                            labelSelect += dataT.valueSelects[dataT.labels[colP[0]] + '_' + val['id']];
                            optionsSelect[col] = dataT.valueSelects[dataT.labels[colP[0]] + '_' + val['id']];
                          } else {
                            if (colP.length && colP.length > 1) {
                              let textColumn = '';
                              colP.forEach((c, i) => {
                                if (i > 0) {
                                  textColumn += c;
                                  if (i < (colP.length - 1)) {
                                    textColumn += '-';
                                  }
                                }
                              });
                              const valColum = dataT.valueSelects[dataT.labels[colP[0]] + '_' + val['id']][textColumn];
                              if (valColum) {
                              labelSelect += valColum;
                              optionsSelect[col] = valColum;
                              } else {
                                labelSelect += 'No aplica';
                                optionsSelect[col] = 'No aplica';
                              }
                            } else {
                              labelSelect += 'No aplica';
                              optionsSelect[col] = 'No aplica';
                            }
                          }
                        } else {
                          labelSelect += val[dataT.labels[colP[0]]];
                          optionsSelect[col] = val[dataT.labels[colP[0]]];
                        }
                      } else {
                        labelSelect += 'No aplica';
                        optionsSelect[col] = 'No aplica';
                      }
                    }
                  });
                  if (valid) {
                    columnsMaster.push({value: val.id, key: labelSelect, others: optionsSelect});
                  }
                });
                if (control.propiedades['tipoSelector'] && control.propiedades['tipoSelector'] === 'EnModal') {
                  const dataModalSelector: Array<any> = [];
                  dataT.valores.forEach(row => {
                    const d = Static.copyObjet(row);
                    Object.keys(d).forEach(key => {
                      if (dataT.valueSelects[key + '_' + d['id']]) {
                        d[key] = dataT.valueSelects[key + '_' + d['id']];
                      }
                    });
                    dataModalSelector.push(d);
                  });
                  control.propiedades['dataSelectorModal'] = dataModalSelector;
                  if (
                    control.propiedades['columnsSelectorModal'] &&
                    control.propiedades['columnsSelectorModal'].length
                  ) {
                    control.propiedades['columnsSelectorModal'].forEach((column: ColumnsTableModalSelect) => {
                      if (dataT.labels[column.key]) {
                          column.key = dataT.labels[column.key];
                      }
                    });
                  }
                }
                control.propiedades['options'] = columnsMaster;
                if (this.dataTable.length && dataFormulario) {
                  this.dataTable.forEach(data => {
                    if (data.alias === subForm.alias) {
                      const d: any = this.loadingDataTable(subForm.id_forma);
                      subForm.datos = new LocalDataSource(d);
                      subForm.datos.refresh();
                    }
                  });
                }
              }
            }
          } else if (control.propiedades['condicion']) {
            if (this.task) {
              if (this.condictions && this.condictions.length) {
                const condictionsOptions: Array<OptionCondiction> = [];
                const condiction = find(this.condictions, {alias: control.propiedades['condicion']});
                if (condiction) {
                  control.label = condiction.condicion;
                  if (condiction.opciones && condiction.opciones.length) {
                    condiction.opciones.forEach(option => {
                      condictionsOptions.push(
                        {
                          key: option.mascara ? option.mascara : option.opcion,
                          value: option.opcion,
                          idOption: option.id_opcion
                        }
                      );
                    });
                  }
                  control.propiedades['options'] = condictionsOptions;
                } else {
                  control.label = 'Condición: ' + control.propiedades['condicion'];
                  control.propiedades['options'] = [];
                }
              } else {
                control.label = 'Condición: ' + control.propiedades['condicion'];
                control.propiedades['options'] = [];
              }
            } else {
              control.label = 'Condición: ' + control.propiedades['condicion'];
              control.propiedades['options'] = [];
            }
          }
        }
        let valueControl: any;
        if (dataForm) {
          let exist: any;
          if (dataForm[control.nombre_campo]) {
            exist = find(control.propiedades['options'], {value: dataForm[control.nombre_campo]});
            if (!exist) {
              dataForm[control.nombre_campo] = null;
              dataForm[control.nombre_campo + '_valor'] = null;
            }
            valueControl = dataForm[control.nombre_campo];
          } else {
            const value = find(dataForm, {alias_formulario: subForm.alias, nombre_campo: control.nombre_campo});
            const valueIndex = findIndex(
              dataForm,
              {
                alias_formulario: subForm.alias,
                nombre_campo: control.nombre_campo
              }
            );
            if (value) {
              exist = find(control.propiedades['options'], {value: value.valor});
              if (!exist) {
                dataForm[valueIndex].valor = null;
              }
              valueControl = dataForm[valueIndex].valor;
            }
          }
        }
        if (!returnControl && refreshForm) {
          // if (dataForm) {
          //   subForm.formulario = await this.rdffs.getForm(subForm, this.templatesFomr, dataForm, update);
          // } else {
          //   subForm.formulario = await this.rdffs.getForm(subForm, this.templatesFomr, this.data, update);
          // }
          const options = control.propiedades['tipoSelector'] === 'EnModal' ?
                            control.propiedades['dataSelectorModal']
                          : control.propiedades['options'];
          const property = control.propiedades['tipoSelector'] === 'EnModal' ?
                            'data'
                          : 'options';
          if (control.propiedades['tipoSelector'] === 'EnModal') {
            const placeholder = control.propiedades['placeholder_condicion'] ?
                                  control.propiedades['placeholder_condicion']
                                : control.placeholder;
            const columns = control.propiedades['condictions_modal_condicion'] ?
                              control.propiedades['condictions_modal_condicion']
                            : control.propiedades['columnsSelectorModal'] ?
                              control.propiedades['columnsSelectorModal']
                            : [];
            const dataChange = {
              data: options,
              options: control.propiedades['options'],
              placeholder: placeholder,
              columns: columns
            };
            this.gns.set<any>({
              source: 'multipleProperties',
              destiny: control.alias + '-' + control.nombre_campo,
              action: 'loadingData',
              eventTriggered: 'change',
              data: <any> dataChange
            }, true);
          } else {
            this.gns.set<any>({
              source: property,
              destiny: control.alias + '-' + control.nombre_campo,
              action: 'loadingData',
              eventTriggered: 'change',
              data: <any> options
            }, true);
          }
          if (this.formularios.length) {
            const ctrl = find(subForm.formulario[0]['controls'], {key: control.nombre_campo});
            if (ctrl) {
              this.formularios.forEach((formulario, index) => {
                if (formulario.name === subForm.alias && formulario.form.controls[control.nombre_campo]) {
                  if (valueControl !== formulario.form.controls[control.nombre_campo].value) {
                    formulario.form.controls[control.nombre_campo].setValue(
                      valueControl,
                      {
                        onlySelf: false,
                        emitEvent: false,
                        emitModelToViewChange: true,
                        emitViewToModelChange: true
                      }
                    );
                  }
                }
              });
            }
          }
        } else {
          resolve(control);
        }
      }
      resolve(true);
    });
  }

  /**
   * Validad la informacion a guardar de x formulario
   *
   * @private
   * @param {*} data
   * @param {SubForma} form
   * @param {boolean} [alert=true]
   * @returns {boolean}
   * @memberof RefactorDynamicFormComponent
   */
  private validDataForm(data: any, form: SubForma, alert: boolean = true): boolean {
    let valid = true;
    if (form.campos.length) {
      const groupCheckbox = {};
      if (form.estilo['groupCheckbox'] && form.estilo['groupCheckbox'].length) {
        form.estilo['groupCheckbox'].forEach((group: any) => {
          groupCheckbox[group['nombre']] = [];
        });
      }
      const formulario = find(this.formularios, {name: form.alias});
      for (const field of form.campos) {
        if (field.tipo_campo.nombre === 'number') {
          if (field.propiedades['separadorMiles'] && data[field.nombre_campo] !== undefined) {
            if (isNaN(Number(data[field.nombre_campo]))) {
              data[field.nombre_campo] = Number(Static.numberFormatWithoutThousandsSeparator(
                data[field.nombre_campo],
                field.propiedades['separadorMiles'] ? field.propiedades['separadorMiles'] : null,
                field.propiedades['separadorDecimales'] ? field.propiedades['separadorDecimales'] : null
              ));
            } else {
              data[field.nombre_campo] = Number(data[field.nombre_campo]);
            }
          } else {
            if (data[field.nombre_campo] !== undefined) {
              data[field.nombre_campo] = Number(data[field.nombre_campo]);
            }
          }
        }
        const hiddenField = this.getHiddenField(form.formulario, field.nombre_campo);
        if (data[field.nombre_campo] === undefined || hiddenField === 1 || hiddenField === -1) {
          if (data[field.nombre_campo] === undefined) {
            if (field.tipo_campo.nombre === 'checkbox') {
              if (formulario && formulario.form.controls[field.nombre_campo].value) {
                data[field.nombre_campo] = formulario && formulario.form.controls[field.nombre_campo].value;
              } else {
                data[field.nombre_campo] = false;
              }
            }
          }
          continue;
        } else {
          if (field.tipo_campo.nombre === 'checkbox') {
            if (
              field.propiedades['tipoCheckbox'] === 'opcionMultiple' &&
              groupCheckbox[field.propiedades['grupoCheckbox']]
            ) {
              groupCheckbox[field.propiedades['grupoCheckbox']].push(field);
            } else {
              if (field.requerido) {
                if (!data[field.nombre_campo]) {
                  if (alert) {
                    this.toastr.warning(
                      'Hay campos requeridos sin llenar, verifique e inténtelo de nuevo',
                      'Información incompleta', {
                        positionClass: 'toast-top-center'
                      }
                    );
                    formulario.form.controls[field.nombre_campo].setValue(null);
                  }
                  valid = false;
                  break;
                }
              }
            }
          }
        }
      }
      if (valid) {
        if (form.estilo['groupCheckbox'] && form.estilo['groupCheckbox'].length) {
          form.estilo['groupCheckbox'].forEach((group: any) => {
            if (valid) {
              let contador = 0;

              if (groupCheckbox[group['nombre']] && groupCheckbox[group['nombre']].length) {
                groupCheckbox[group['nombre']].forEach((field: Control) => {
                  if (data[field.nombre_campo]) {
                    contador++;
                  }
                });
              }

              if (group['min'] && contador < group['min']) {
                valid = false;
                if (group['mensajeMin']) {
                  if (alert) {
                    this.toastr.warning(group['mensajeMin'], 'Información incompleta', {
                      positionClass: 'toast-top-center'
                    });
                  }
                } else {
                  if (alert) {
                    this.toastr.warning(
                      'Debe seleccionar al menos ' + group['min'] + ' opciones para el grupo ' + group['nombre'],
                      'Información incompleta', {
                        positionClass: 'toast-top-center'
                      }
                    );
                  }
                }
              } else if (group['max'] && contador > group['max']) {
                if (group['mensajeMax']) {
                  if (alert) {
                    this.toastr.warning(group['mensajeMax'], 'Información incompleta', {
                      positionClass: 'toast-top-center'
                    });
                  }
                } else {
                  if (alert) {
                    this.toastr.warning(
                      'No puede seleccionar mas de ' + group['max'] + ' opciones para el grupo ' + group['nombre'],
                      'Información incompleta', {
                        positionClass: 'toast-top-center'
                      }
                    );
                  }
                }
                valid = false;
              }
            }
          });
        }
      }
    }
    return valid;
  }

  /**
   * Esta funcion se encarga de caragar la estrutura de dependencias para la consulta a la maestra
   * con las columnas seleccionadas en los filtros
   *
   * @param {EstructuraEspecifica} structure
   * @param {FiltrosSelectores[]} filters
   * @param {ColumnaMaestra[]} structureMaster
   * @memberof RefactorDynamicFormComponent
   */
  private loadingStructureDependenceFiltros(
    structure: EstructuraEspecifica,
    filters: FiltrosSelectores[],
    structureMaster: ColumnaMaestra[]
  ) {
    const listColumns: Array<string> = [];
    const blockColumns: Array<string[]> = [];
    if (filters && filters.length) {
      filters.forEach(filter => {
        listColumns.push(filter.columna);
      });
      let columnDependence = '';
      listColumns.forEach((col, index) => {
        const cols = col.split('_');
        if (cols.length === 1) {
          listColumns.splice(index, 1);
        } else {
          if (columnDependence !== cols[0]) {
            columnDependence = cols[0];
            const blockColumnsRecolector: Array<string> = [];
            listColumns.forEach((colDep: string, indexDep: number) => {
              const columnsRef = colDep.split('_');
              if (columnsRef[0] === columnDependence) {
                blockColumnsRecolector.push(colDep);
              }
            });
            blockColumns.push(blockColumnsRecolector);
          }
        }
      });
      if (blockColumns.length) {
        blockColumns.forEach(columnsSeleted => {
          const history = this.loadingEstructureColumns(
            structureMaster,
            columnsSeleted,
            Number(columnsSeleted[0].split('_')[0])
          );

          if (history) {
            const indexExist = findIndex(structure.dependencia, {maestra: history.maestra});
            if (indexExist === -1) {
              structure.dependencia.push(history);
            } else {
              this.mergeDependenceStruture(structure.dependencia[indexExist], history.dependencia);
            }
          }
        });
      }
    }
  }

  /**
   * Esta funcion se encarga de mesclar una estructura de dependencia en un estructura de maestra principal
   * Se utiliza para mesclar las dependencias de las columnas de filtros y las columnas de vista
   *
   * @param {EstructuraEspecifica} structure
   * @param {EstructuraEspecifica[]} dependence
   * @memberof RefactorDynamicFormComponent
   */
  private mergeDependenceStruture(
    structure: EstructuraEspecifica,
    dependence: EstructuraEspecifica[]
  ) {
    if (dependence && dependence.length) {
      dependence.forEach(history => {
        const indexExist = findIndex(structure.dependencia, {maestra: history.maestra});
        if (indexExist === -1) {
          structure.dependencia.push(history);
        } else {
          this.mergeDependenceStruture(structure.dependencia[indexExist], history.dependencia);
        }
      });
    }
  }

  /**
   * valida y ejecuta la sincronizacion con las tablas sincronizadas en las tareas asociadas
   *
   * @private
   * @param {*} data
   * @param {SubForma} form
   * @param {*} [valueSelects={}]
   * @param {AccionSincronizacionTabla} [action='agregar']
   * @memberof RefactorDynamicFormComponent
   */
  private syncDataTable(
    data: any,
    form: SubForma,
    valueSelects: any = {},
    action: AccionSincronizacionTabla = 'agregar'
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (data) {
        const dataSyncTable: SincronizacionTabla = {
          valor: [],
        };
        const tasks: Array<number> = [];
        if (this.formAssociationSync && this.formAssociationSync.length) {
          this.formAssociationSync.forEach(formAssociation => {
            if (formAssociation.id_tarea !== this.taskActually.id) {
              if (formAssociation.forma && formAssociation.forma.length) {
                formAssociation.forma.forEach(formA => {
                  if (formA.tabla && formA.campos && formA.campos.length) {
                    const dataS = {};
                    const vSelect = {};
                    form.campos.forEach(field => {
                      if (field.sincronizado) {
                        const fieldExist = find(formA.campos, {alias: field.alias});
                        if (fieldExist) {
                          if (fieldExist.tipo_campo.nombre === field.tipo_campo.nombre) {
                            if (action !== 'eliminar') {
                              if (data[field.nombre_campo]) {
                                dataS[fieldExist.nombre_campo] = data[field.nombre_campo];
                                if (field.tipo_campo.nombre === 'ngSelect') {
                                  if (valueSelects[field.nombre_campo + '_' + data['id']]) {
                                    // tslint:disable-next-line:max-line-length
                                    vSelect[fieldExist.nombre_campo + '_' + data['id']] = valueSelects[field.nombre_campo + '_' + data['id']];
                                  }
                                }
                              }
                              if (form.estilo['formulario_pestaña']) {
                                const tabFormulario = find(
                                  this.form.sub_formas,
                                  {alias: form.estilo['formulario_pestaña']}
                                );
                                if (tabFormulario) {
                                  const controlsGeneral = filter(
                                    tabFormulario.campos,
                                    ctrl => ctrl.propiedades['columna_general']
                                  );
                                  if (controlsGeneral.length) {
                                    controlsGeneral.forEach(fieldGeneral => {
                                      dataS[fieldGeneral.nombre_campo] = data[fieldGeneral.nombre_campo];
                                    });
                                  }
                                }
                              }
                            } else {
                              if (typeof data !== 'object') {
                                dataS['id'] = data;
                              } else {
                                dataS['id'] = data['id'];
                              }
                            }
                          }
                        }
                      }
                    });
                    if (Object.keys(dataS).length) {
                      if (action !== 'eliminar') {
                        dataS['id'] = data['id'];
                      }
                      dataSyncTable.valor.push({
                        tarea: formAssociation.id_tarea,
                        data: dataS,
                        id_tabla: formA.id_forma,
                        alias: formA.alias,
                        accion: action,
                        id_registro: dataS['id'],
                        valueSelects: vSelect,
                      });
                      const existTask = tasks.indexOf(formAssociation.id_tarea);
                      if (existTask === -1) {
                        tasks.push(formAssociation.id_tarea);
                      }
                    }
                  }
                });
              }
            }
          });
        }
        if (tasks && tasks.length) {
          // this.eventSyncDataTable.emit({tabla: dataSyncTable, tareas: tasks});
          this.rdfds.syncFormTask({tabla: dataSyncTable, tareas: tasks}).then(() => {
            resolve(true);
          });
        } else {
          resolve(true);
        }
      }
    });
  }

  /**
   * valida y ejecuta la sincronizacion con las tablas sincronizadas en la tarea actual
   *
   * @private
   * @param {*} data
   * @param {SubForma} form
   * @param {AccionSincronizacionTabla} [action='agregar']
   * @memberof RefactorDynamicFormComponent
   */
  private syncDataTablesActually(
    data: any,
    form: SubForma,
    action: AccionSincronizacionTabla = 'agregar'
  ) {
    if (form.campos && form.campos.length) {
      const dataTable = find(this.dataTable, {id_tabla: form.id_forma});
      if (dataTable) {
        if (this.formAssociationSync && this.formAssociationSync.length) {
          this.formAssociationSync.forEach(formAssociation => {
            if (formAssociation.id_tarea === this.taskActually.id) {
              if (formAssociation.forma && formAssociation.forma.length) {
                formAssociation.forma.forEach(formA => {
                  if (formA.tabla && formA.campos && formA.campos.length && formA.id_forma !== form.id_forma) {
                    const dataS = {};
                    const vSelect = {};
                    form.campos.forEach(field => {
                      if (field.sincronizado) {
                        const fieldExist = find(formA.campos, {alias: field.alias});
                        if (fieldExist) {
                          if (fieldExist.tipo_campo.nombre === field.tipo_campo.nombre) {
                            if (data[field.nombre_campo]) {
                              dataS[fieldExist.nombre_campo] = data[field.nombre_campo];
                              if (field.tipo_campo.nombre === 'ngSelect') {
                                if (dataTable.valueSelects[field.nombre_campo + '_' + data['id']]) {
                                  // tslint:disable-next-line:max-line-length
                                  vSelect[fieldExist.nombre_campo + '_' + data['id']] = dataTable.valueSelects[field.nombre_campo + '_' + data['id']];
                                }
                              }
                            }
                          }
                        }
                      }
                    });
                    if (Object.keys(dataS).length) {
                      const indexDataTableA = findIndex(this.dataTable, {id_tabla: formA.id_forma});
                      if (indexDataTableA !== -1) {
                        if (
                        this.dataTable[indexDataTableA] &&
                        this.dataTable[indexDataTableA].valores
                        ) {
                          if (action !== 'eliminar') {
                            if (action === 'modificar') {
                              if (this.dataTable[indexDataTableA].valores.length) {
                                this.dataTable[indexDataTableA].valores.forEach(val => {
                                  if (val['id'] === data['id']) {
                                    const keyDataS = Object.keys(dataS);
                                    if (keyDataS && keyDataS.length) {
                                      keyDataS.forEach(key => {
                                        val[key] = dataS[key];
                                      });
                                    }
                                  }
                                });
                              } else {
                                dataS['id'] = data['id'];
                                this.dataTable[indexDataTableA].valores.push(dataS);
                              }
                            } else  if ('agregar') {
                              dataS['id'] = data['id'];
                              this.dataTable[indexDataTableA].valores.push(dataS);
                            }
                            const keyValueSelectS = Object.keys(vSelect);
                            if (keyValueSelectS && keyValueSelectS.length) {
                              keyValueSelectS.forEach(key => {
                                this.dataTable[indexDataTableA].valueSelects[key] = vSelect[key];
                              });
                            }
                          } else {
                            if (this.dataTable[indexDataTableA].valores.length) {
                              this.dataTable[indexDataTableA].valores.forEach((val, index) => {
                                if (val['id'] === data['id']) {
                                  this.dataTable[indexDataTableA].valores.splice(index, 1);
                                }
                              });
                            }
                          }
                        }
                      } else {
                        if (action !== 'eliminar') {
                          const labelsA: Object = new Object();
                          const subForm = find(this.form.sub_formas, {id_forma: formA.id_forma});
                          if (subForm) {
                            subForm.campos.forEach(fieldSub => {
                              labelsA[fieldSub.alias] = fieldSub.nombre_campo;
                            });
                          }
                          dataS['id'] = data['id'];
                          const tablaDatos: TablaDatos = {
                            nombre: formA.nombre,
                            id_tabla: formA.id_forma,
                            alias: formA.alias,
                            labels: labelsA,
                            valueSelects: vSelect,
                            valores: [dataS]
                          };
                          this.dataTable.push(tablaDatos);
                        }
                      }
                      this.orderIndexVal(formA.id_forma, false);
                    }
                  }
                });
              }
            }
          });
        }
      }
    }
  }

  /**
   * Controla los eventos de accion del seletor en modal
   *
   * @param {AccionModal} data
   * @memberof RefactorDynamicFormComponent
   */
  async actionSelectModal(data: AccionModal) {
    log.debug(data);
    if (this.task) {
      this.dataAccionModal = data;
      switch (data.accion) {
        case 'eliminar':
          this.confirmActionSelectModal.open();
          break;
        case 'agregar':
          this.actionRow = 'Agregar';
          this.masterTable = data.temporalData['nombre'];
          this.idMasterTable = data.temporalData['id'];
          this.modificar = false;
          this.registroSeleccionado = null;
          this.structureMaster = data.temporalData['estructura'];
          this.configMasterAccessControl = data.temporalData['control_acceso_maestra'];
          this.configDefaultValues = Static.copyObjet(data.temporalData['valores_defecto_maestra']);
          this.dataDefaultValueMaster = this.getDataDefaultValueMaster(this.configDefaultValues);
          this.openModalFormMasterTable();
          break;
        case 'actualizar':
          this.loadingProcess = true;
          this.messaggeLoading = 'Cargando el registro...';
          this.actionRow = 'Modificar';
          this.masterTable = data.temporalData['nombre'];
          this.idMasterTable = data.temporalData['id'];
          this.modificar = true;
          this.registroSeleccionado = await this.rdfds.getInformationDynamicTableMaster(
            data.registroSeleccionado['id']
          ).catch(err => this.loadingProcess = false);
          this.structureMaster = data.temporalData['estructura'];
          this.configMasterAccessControl = data.temporalData['control_acceso_maestra'];
          this.openModalFormMasterTable();
          this.loadingProcess = false;
          break;
      }
    } else {
      this.toastr.warning('Esta acción no está permitida para la previsualización de la forma', 'Acción no permitida');
    }
  }

  /**
   * Elimina el regitro seleccionado
   *
   * @param {boolean} res
   * @memberof RefactorDynamicFormComponent
   */
  async deleteRowSelectModal(res: boolean) {
    if (res) {
      switch (this.dataAccionModal.accion) {
        case 'eliminar':
          const idregistro = this.dataAccionModal.registroSeleccionado['id'];
          this.tds.deleteInformationDynamicTableMaster(idregistro).subscribe(async resp => {
            if (resp) {
              if (
                this.dataAccionModal.temporalData['form'] &&
                this.dataAccionModal.temporalData['control']
              ) {
                this.loadingModalSelector(
                  this.dataAccionModal.temporalData['control'],
                  this.dataAccionModal.temporalData['form']
                );
              }
              this.dataAccionModal = null;
            } else {
              log.debug('No se pudo eliminar el registro.');
            }
          });
          break;
      }
    }
  }

  /**
   * Abre el modal con el formulario renderizado de la tabla maestra
   *
   * @private
   * @memberof RefactorDynamicFormComponent
   */
  private openModalFormMasterTable() {
    this.modalRefMasterTable = this.modalService.show(
      this.templateRefactorMasterTable,
        {
          class: 'modal-lg-personalized',
          backdrop: 'static'
        }
    );
  }

  /**
   * Cierra el modal del formulario renderizado de la tabla maestra
   *
   * @param {boolean} [loading=false]
   * @memberof RefactorDynamicFormComponent
   */
  closeModal(loading: boolean = false) {
    this.actionRow = 'Agregar';
    this.masterTable = '';
    this.modificar = false;
    this.registroSeleccionado = null;
    this.structureMaster = [];
    this.configMasterAccessControl = [];
    this.configDefaultValues = [];
    this.dataDefaultValueMaster = null;
    this.idMasterTable = 0;
    this.modalRefMasterTable.hide();
    if (loading) {
      if (
        this.dataAccionModal.temporalData['form'] &&
        this.dataAccionModal.temporalData['control']
      ) {
        this.gns.set<any>({
          source: 'RefactorDynamicFormComponent',
          destiny: 'ModalSelectComponent-' + this.dataAccionModal.temporalData['control'].nombre_campo,
          action: 'changePropertie',
          eventTriggered: 'change',
          data: <any> { loader: true }
        }, true);
        this.loadingModalSelector(
          this.dataAccionModal.temporalData['control'],
          this.dataAccionModal.temporalData['form']
        );
      }
      this.dataAccionModal = null;
    }
  }

  /**
   * Carga las opciones del modal
   *
   * @private
   * @param {Control} control
   * @param {SubForma} form
   * @memberof RefactorDynamicFormComponent
   */
  private async loadingModalSelector(control: Control, form: SubForma) {
    await Static.asyncForEach(this.form.sub_formas, async subForm => {
      const formulario = find(this.formularios, {name: subForm.alias});
      if (formulario) {
        const controls = filter(
          subForm.campos,
          field => (
                    field.tipo_campo.nombre === 'ngSelect' &&
                    field.lista_maestra[0].id === control.lista_maestra[0].id &&
                    field.propiedades['tipoSelector'] === 'EnLista'
                   ) ||
                   field.nombre_campo === control.nombre_campo
        );
        if (controls.length) {
          await Static.asyncForEach(controls, async ctrl => {
            await this.refresControlForm(
              subForm,
              ctrl,
              this.getDataForm(formulario.form, subForm),
              false,
              ctrl.propiedades['tipoSelector'] === 'EnModal' ? false : true
            );
          });
        }
        if (controls.length) {
          for (const ctrl of controls) {
            if (
              ctrl.propiedades['tipoSelector'] === 'EnModal' &&
              control.nombre_campo === ctrl.nombre_campo
            ) {
              let dataLoading: Array<any> = [];
              if (ctrl.propiedades['dataSelectorModal']) {
                dataLoading = ctrl.propiedades['dataSelectorModal'];
              }
              const indexForm = findIndex(this.form.sub_formas, {id_forma: subForm.id_forma});
              if (indexForm !== -1) {
                this.loadingOptionsControl(
                  ctrl.propiedades['dataSelectorModal'],
                  ctrl,
                  this.form.sub_formas[indexForm].formulario
                );
              }
              this.gns.set<any>({
                source: 'RefactorDynamicFormComponent',
                destiny: 'ModalSelectComponent-' + ctrl.nombre_campo,
                action: 'loadingData',
                eventTriggered: 'click',
                data: <any> dataLoading
              }, true);
            }
          }
        }
        this.dataAccionModal = null;
      }
    });
  }

  /**
   * Actualiza las opciones de un campo ya configurado
   *
   * @private
   * @param {*} options
   * @param {Control} control
   * @param {BaseControl<any>[]} configForm
   * @memberof RefactorDynamicFormComponent
   */
  private loadingOptionsControl(options: any, control: Control, configForm: BaseControl<any>[]) {
    if (configForm.length) {
      configForm.forEach(ctlConfig => {
        if (ctlConfig.controlType === 'container') {
          this.loadingOptionsControl(options, control, ctlConfig['controls']);
        } else {
          if (ctlConfig.key === control.nombre_campo) {
            ctlConfig['data'] = options;
          }
        }
      });
    }
  }

  /**
   * valida y ejecuta la sincronizacion con las tablas sincronizadas en las tareas asociadas
   *
   * @private
   * @param {*} data
   * @param {SubForma} form
   * @param {AccionSincronizacionTabla} [action='agregar']
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  private syncCheckList(
    data: any,
    form: SubForma,
    action: AccionSincronizacionTabla = 'agregar'
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (data) {
        const dataSyncTable: SincronizacionTabla = {
          valor: [],
        };
        const tasks: Array<number> = [];
        if (this.formAssociationSync && this.formAssociationSync.length) {
          this.formAssociationSync.forEach(formAssociation => {
            if (formAssociation.id_tarea !== this.taskActually.id) {
              if (formAssociation.forma && formAssociation.forma.length) {
                formAssociation.forma.forEach(formA => {
                  if (
                    formA.tabla &&
                    (formA.estilos.hasOwnProperty('sincronizado') && formA.estilos['sincronizado']) &&
                    (
                      formA.estilos.hasOwnProperty('aliasSincronizado') &&
                      formA.estilos['aliasSincronizado'] === form.estilo['aliasSincronizado']
                    )
                  ) {
                    const dataS = {};
                    const vSelect = {};

                    const fieldOptionAs = find(formA.campos, {alias: formA.alias + '_opciones'});
                    const fieldOption = find(form.campos, {alias: form.alias + '_opciones'});
                    const fieldReqAs = find(formA.campos, {alias: formA.alias + '_requisitos'});
                    const fieldReq = find(form.campos, {alias: form.alias + '_requisitos'});
                    if (fieldOptionAs && fieldOption) {
                      dataS[fieldOptionAs.nombre_campo] = data[fieldOption.nombre_campo];
                    }
                    if (fieldReqAs && fieldReq) {
                      dataS[fieldReqAs.nombre_campo] = data[fieldReq.nombre_campo];
                    }
                    dataS['id'] = data['id'];
                    dataS['sync'] = true;
                    dataS['id_registro'] = data['id_registro'];

                    dataSyncTable.valor.push({
                      tarea: formAssociation.id_tarea,
                      data: dataS,
                      id_tabla: formA.id_forma,
                      alias: formA.alias,
                      accion: action,
                      id_registro: dataS['id'],
                      valueSelects: vSelect,
                    });
                    if (Object.keys(dataS).length) {
                      const existTask = tasks.indexOf(formAssociation.id_tarea);
                      if (existTask === -1) {
                        tasks.push(formAssociation.id_tarea);
                      }
                    }
                  }
                });
              }
            }
          });
        }
        if (tasks && tasks.length) {
          // this.eventSyncDataTable.emit({tabla: dataSyncTable, tareas: tasks});
          this.rdfds.syncFormTask({tabla: dataSyncTable, tareas: tasks}).then(() => {
            resolve(true);
          });
        } else {
          resolve(true);
        }
      }
    });
  }

  /**
   * Sincroniza las listas de chekeo en la forma actual
   *
   * @private
   * @param {*} data
   * @param {SubForma} form
   * @param {AccionSincronizacionTabla} [action='agregar']
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  private syncCheckListCurrent(
    data: any,
    form: SubForma,
    action: AccionSincronizacionTabla = 'agregar',
    refreshDependentTables: boolean = false
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (data) {
        const dataSyncTable: SincronizacionTabla = {
          valor: [],
        };
        const tasks: Array<number> = [];
        if (this.formAssociationSync && this.formAssociationSync.length) {
          this.formAssociationSync.forEach(formAssociation => {
            if (formAssociation.id_tarea === this.taskActually.id) {
              if (formAssociation.forma && formAssociation.forma.length) {
                formAssociation.forma.forEach(async formA => {
                  if (
                    formA.tabla &&
                    (formA.estilos.hasOwnProperty('sincronizado') && formA.estilos['sincronizado']) &&
                    (
                      formA.estilos.hasOwnProperty('aliasSincronizado') &&
                      formA.estilos['aliasSincronizado'] === form.estilo['aliasSincronizado']
                    ) &&
                    form.alias !== formA.alias
                  ) {
                    const dataS = {};
                    const vSelect = {};

                    const fieldOptionAs = find(formA.campos, {alias: formA.alias + '_opciones'});
                    const fieldOption = find(form.campos, {alias: form.alias + '_opciones'});
                    const fieldReqAs = find(formA.campos, {alias: formA.alias + '_requisitos'});
                    const fieldReq = find(form.campos, {alias: form.alias + '_requisitos'});
                    if (fieldOptionAs && fieldOption) {
                      dataS[fieldOptionAs.nombre_campo] = data[fieldOption.nombre_campo];
                    }
                    if (fieldReqAs && fieldReq) {
                      dataS[fieldReqAs.nombre_campo] = data[fieldReq.nombre_campo];
                    }
                    dataS['id'] = data['id'];
                    dataS['sync'] = true;
                    dataS['id_registro'] = data['id_registro'];

                    const indexDataTable = findIndex(this.dataTable, {id_tabla: formA.id_forma});
                    if (indexDataTable !== -1) {
                      const row = find(this.dataTable[indexDataTable].valores, {id_registro: dataS['id_registro']});
                      if (!row) {
                        action = 'modificar';
                      }
                      if (action === 'agregar') {
                        this.dataTable[indexDataTable].valores.push(dataS);
                      } else if (action === 'modificar') {
                        const indexValor = findIndex(this.dataTable[indexDataTable].valores, {id: dataS['id']});
                        if (indexValor !== -1) {
                          this.dataTable[indexDataTable].valores[indexValor] = dataS;
                        } else {
                          this.dataTable[indexDataTable].valores.push(dataS);
                        }
                      }
                    } else {
                      const labelsA: Object = new Object();
                      const subForm = find(this.form.sub_formas, {id_forma: formA.id_forma});
                      if (subForm) {
                        subForm.campos.forEach(fieldSub => {
                          labelsA[fieldSub.alias] = fieldSub.nombre_campo;
                        });
                        const tablaDatos: TablaDatos = {
                          nombre: formA.nombre,
                          id_tabla: formA.id_forma,
                          alias: formA.alias,
                          labels: labelsA,
                          valueSelects: vSelect,
                          valores: [dataS]
                        };
                        this.dataTable.push(tablaDatos);
                      }
                    }
                    if (refreshDependentTables) {
                      await this.orderIndexVal(formA.id_forma, false);
                    }
                  }
                });
              }
            }
          });
        }
      }
      resolve(true);
    });
  }

  /**
   * Genera la estructura de una maestra para la consulta de listas de chequeo
   *
   * @private
   * @param {string} idMaster
   * @param {string} column
   * @returns {EstructuraEspecifica}
   * @memberof RefactorDynamicFormComponent
   */
  private generateStructureMasterTable(idMaster: string, column: string, ): EstructuraEspecifica {
    const structure: EstructuraEspecifica = {
      maestra: idMaster,
      columnas: [],
      dependencia: []
    };
    if (column) {
      const cols = column.split('_');
      if (cols.length > 1) {
        let structureCol = '';
        const idMasterCol = cols[0];
        cols.splice(0, 1);
        cols.forEach((col, i) => {
          if (i !== 0) {
            structureCol += '_';
          }
          structureCol += col;
        });
        structure.dependencia.push(this.generateStructureMasterTable(idMasterCol + ' ', structureCol));
      } else {
        structure.columnas.push(cols[0] + ' ');
      }
    }

    return structure;
  }

  /**
   * Realiza la consulta de la maestra de una lista de chequeo
   *
   * @private
   * @param {SubForma} subForm
   * @returns {Promise<ValoresEspecificos[]>}
   * @memberof RefactorDynamicFormComponent
   */
  private getTableMaster(subForm: SubForma, refresh: boolean = false): Promise<ValoresEspecificos[]> {
    return new Promise(async (resolve) => {
      let columns: ValoresEspecificos[];
      const colsMaster = find(this.acomulateColumns, {name: subForm.nombre + '_tabla'});
      if (!colsMaster || refresh) {
        let specificEstructure: EstructuraEspecifica;
        let filterMaster: FiltroTableMasterGeneral[] = [];
        let idRecords: string;

        specificEstructure = this.generateStructureMasterTable(
          subForm.estilo['maestra'],
          subForm.estilo['columna_seleccionada']
        );
        if (subForm.estilo['filtros_maestra'] && subForm.estilo['filtros_maestra'].length) {
          this.loadingStructureDependenceFiltros(
            specificEstructure,
            subForm.estilo['filtros_maestra'],
            subForm.estilo['maestra'],
          );
          filterMaster = this.GenerateFiltersMasterTable(subForm.estilo['filtros_maestra']);
        }

        if (subForm.estilo['registros_especificos'] && subForm.estilo['registros_especificos'].length) {
          idRecords = '(';
          subForm.estilo['registros_especificos'].forEach((record: any, i: number) => {
            idRecords += record;
            if (i < (subForm.estilo['registros_especificos'].length - 1)) {
              idRecords += ', ';
            }
          });
          idRecords += ')';
        }

        columns = await this.rdfds.getColumnsSpecificMasterTable(specificEstructure, filterMaster, idRecords);
        let add = true;
        let indexColumns = -1;
        if (refresh) {
          indexColumns = findIndex(this.acomulateColumns, {name: subForm.nombre + '_tabla'});
          if (indexColumns !== -1) {
            add = false;
          }
        }
        if (add) {
          this.acomulateColumns.push({
            name: subForm.nombre + '_tabla',
            columns: columns
          });
        } else {
          this.acomulateColumns[indexColumns].columns = columns;
        }
      } else {
        columns = colsMaster.columns;
      }
      resolve(columns);
    });
  }

  /**
   * Se encarga de generar la estructura de los filtros para la consulta de la maestra
   *
   * @private
   * @param {FiltrosSelectores[]} filters
   * @param {Datos[]} [dataForm]
   * @returns {FiltroTableMasterGeneral[]}
   * @memberof RefactorDynamicFormComponent
   */
  private GenerateFiltersMasterTable (filters: FiltrosSelectores[], dataForm?: Datos[]): FiltroTableMasterGeneral[] {
    const filterMaster: FiltroTableMasterGeneral[] = [];
    filters.forEach(filter => {
      if (filter.columna) {
        let valorField: any;
        if (filter.form) {
          if (this.form.alias === filter.form) {
            const formulario = find(this.form.sub_formas, {alias: filter.formulario});
            if (
              formulario &&
              (
                !formulario.tabla ||
                (this.formSelect && formulario.alias === this.formSelect.alias)
              )
            ) {
              const field = find(formulario.campos, {alias: filter.field});
              if (field) {
                const form = find(this.formularios, {name: formulario.alias});
                if (form) {
                  let data: Datos;
                  if (dataForm) {
                    valorField = form.form.controls[field.nombre_campo].value;
                  } else {
                    data = find(this.data, {nombre_campo: field.nombre_campo});
                  }
                  if (data) {
                    valorField = data.valor;
                  }
                } else if (dataForm) {
                  if (Array.isArray(dataForm)) {
                    valorField = result(find(dataForm, {nombre_campo: field.nombre_campo}), 'valor');
                  } else {
                    valorField = dataForm[field.nombre_campo];
                  }
                }
              }
            } else if (formulario) {
              if (this.dataTable && this.dataTable.length) {
                const tableData = find(this.dataTable, {alias: formulario.alias});
                if (tableData) {
                  valorField = '(';
                  if (tableData.valores && tableData.valores.length) {
                    tableData.valores.forEach((valD, indexD) => {
                      if (valD[tableData.labels[filter.field]]) {
                        valorField += '\'' + valD[tableData.labels[filter.field]] + '\'';
                        if (indexD < (tableData.valores.length - 1)) {
                          valorField += ',';
                        }
                      }
                    });
                  }
                  valorField += ')';
                }
              }
            }
          } else {
            if (
              this.taskActually &&
              this.taskActually.tarea_asociacion &&
              this.taskActually.tarea_asociacion.length
            ) {
              const association = find(this.taskActually.tarea_asociacion, {alias: filter.form});
              if (association) {
                if (association.datos) {
                  const field = find(association.datos,
                    {
                      alias_formulario: filter.formulario,
                      alias: filter.field
                    }
                  );
                  if (field) {
                    valorField = field.valor;
                  }
                }
              }
              if (valorField === undefined) {
                const tableData = find(this.dataTableAll, {alias: filter.formulario});
                if (tableData) {
                  valorField = '(';
                  if (tableData.valores && tableData.valores.length) {
                    tableData.valores.forEach((valD, indexD) => {
                      if (valD[tableData.labels[filter.field]]) {
                        valorField += '\'' + valD[tableData.labels[filter.field]] + '\'';
                      }
                      if (indexD < (tableData.valores.length - 1)) {
                        valorField += ',';
                      }
                    });
                  }
                  valorField += ')';
                }
              }
            }
          }
        } else {
          valorField = filter.valor;
        }

        if (typeof valorField !== 'boolean' && !valorField) {
          valorField = '';
        } else if (typeof valorField === 'boolean') {
          valorField = String(valorField);
        }

        if (filter.operador && (filter.operador === 'LIKE' || filter.operador === 'ILIKE')) {
          valorField = '%' + valorField + '%';
        }
        let valid = true;

        if (filter.operador && (filter.operador === 'IN' || filter.operador === 'NOT IN')) {
          if (valorField === '()') {
            valid = false;
          }
        }

        if (valid) {
          const cols = filter.columna.split('_');
          if (cols.length && cols.length > 1) {
            if (filter.condicional) {
              filterMaster.push({
                maestra: cols[cols.length - 2],
                columna: cols[cols.length - 1],
                valor: valorField,
                operador: filter.operador ? filter.operador : '=',
                condicional: filter.condicional
              });
            } else {
              filterMaster.push({
                maestra: cols[cols.length - 2],
                columna: cols[cols.length - 1],
                valor: valorField,
                operador: filter.operador ? filter.operador : '=',
              });
            }
          } else {
            if (filter.condicional) {
              filterMaster.push({
                columna: cols[cols.length - 1],
                valor: valorField,
                operador: filter.operador ? filter.operador : '=',
                condicional: filter.condicional
              });
            } else {
              filterMaster.push({
                columna: cols[cols.length - 1],
                valor: valorField,
                operador: filter.operador ? filter.operador : '=',
              });
            }
          }
        }
      }
    });
    return filterMaster;
  }

  /**
   * Ejecuta las sincronizaciones de las listas de chequeo de forma sincronica
   *
   * @private
   * @param {SyncTaskListCheck} infoCheckList
   * @param {SyncTaskListCheck} infoCheckListCurrent
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  private syncTasks(infoCheckList: SyncTaskListCheck, infoCheckListCurrent: SyncTaskListCheck): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.syncCheckList(infoCheckList.data, infoCheckList.form, infoCheckList.action).then(() => {
        this.syncCheckListCurrent(
          infoCheckListCurrent.data,
          infoCheckListCurrent.form,
          infoCheckListCurrent.action
        ).then(() => {
          resolve(true);
        }).catch(err => {
          log.error(err);
          resolve(false);
        });
      }).catch(err => {
        log.error(err);
        resolve(false);
      });
    });
  }

  /**
   * Valida las condiciones de las columnas de un control tipo ngSelect
   *
   * @private
   * @memberof RefactorDynamicFormComponent
   */
  private validCondictionsColumns(
    control: Control
  ): {columns: string[], placeholder: string, columnsModal: ColumnsTableModalSelect[]} {
    let placeholder = '';
    let columns: string[] = [];
    let columnsModal: ColumnsTableModalSelect[];
    if (
      control.validaciones.condiciones_columnas &&
      control.validaciones.condiciones_columnas.length
    ) {
      for (const condiction of control.validaciones.condiciones_columnas) {
        let date = false;
        let existCondiction = false;
        let value: any;
        let field: Control;
        const moment = require('moment');
        if (!Number(condiction.valor)) {
          if (condiction.valor &&  moment(new Date(String(condiction.valor))).isValid()) {
            date = true;
          } else if (condiction.fechaActual) {
            condiction.valor = new Date();
            date = true;
          } else {
            date = false;
          }
        } else {
          date = false;
        }
        const valueCondiction = this.getValueCondiction(condiction);
        existCondiction = valueCondiction.existCondiction;
        value = valueCondiction.value;
        field = valueCondiction.field;
        if (existCondiction) {
          if (condiction.siEs === 'Vacio' || value) {
            switch (condiction.siEs) {
              case 'Vacio':
                if (
                  !value ||
                  value === ''
                ) {
                  columns = condiction.columnas;
                  placeholder = condiction.placeholder;
                  columnsModal = condiction.columnas_selector_modal;
                }
                break;
              case 'Diferente':
                if (!date) {
                  if (String(value).toLowerCase() !== String(condiction.valor).toLowerCase()) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                } else {
                  let dtValorControl: Date = null;
                  if (field && field.tipo_campo.nombre === 'date-time-picker') {
                    let valorCondiction: string = null;
                    let valorControl: string = null;
                    const dtValor: Date = new Date(condiction.valor);
                    switch (field.propiedades && field.propiedades['tipo']) {
                      case 'calendar':
                        valorCondiction = dtValor.toLocaleDateString();
                        dtValorControl = new Date(value);
                        if (moment(dtValorControl).isValid()) {
                          valorControl = dtValorControl.toLocaleDateString();
                        }
                        break;
                      case 'timer':
                        dtValor.setSeconds(0, 0);
                        valorCondiction = dtValor.toLocaleTimeString();
                        dtValorControl = new Date(value);
                        if (moment(dtValorControl).isValid()) {
                          dtValorControl.setSeconds(0, 0);
                          valorControl = dtValorControl.toLocaleTimeString();
                        }
                        break;
                      default:
                        dtValor.setSeconds(0, 0);
                        valorCondiction = dtValor.toLocaleDateString();
                        valorCondiction += ' ' + dtValor.toLocaleTimeString();
                        dtValorControl = new Date(value);
                        if (moment(dtValorControl).isValid()) {
                          dtValorControl.setSeconds(0, 0);
                          valorControl = dtValorControl.toLocaleDateString();
                          valorControl += ' ' + dtValorControl.toLocaleTimeString();
                        }
                        break;
                    }
                    if (valorControl !== valorCondiction) {
                      columns = condiction.columnas;
                      placeholder = condiction.placeholder;
                      columnsModal = condiction.columnas_selector_modal;
                    }
                  } else {
                    dtValorControl = new Date(value);
                    // tslint:disable-next-line:max-line-length
                    if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() !== new Date(condiction.valor).toLocaleDateString()) {
                      columns = condiction.columnas;
                      placeholder = condiction.placeholder;
                      columnsModal = condiction.columnas_selector_modal;
                    }
                  }
                }
                break;
              case 'Mayor a':
                if (!date) {
                  if (Number(value) > Number(condiction.valor)) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                } else {
                  let dtValorControl: Date = null;
                  let valorCondiction: Date = null;
                  valorCondiction = new Date(condiction.valor);
                  dtValorControl = new Date(value);
                  if (field && field.tipo_campo.nombre === 'date-time-picker') {
                    switch (field.propiedades && field.propiedades['tipo']) {
                      case 'calendar':
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                            dtValorControl.setHours(0, 0, 0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setHours(0, 0, 0, 0);
                        }
                        break;
                      case 'timer':
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                          dtValorControl.setDate(new Date().getDate());
                          dtValorControl.setMonth(new Date().getMonth());
                          dtValorControl.setFullYear(new Date().getFullYear());
                          dtValorControl.setSeconds(0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setDate(new Date().getDate());
                          valorCondiction.setMonth(new Date().getMonth());
                          valorCondiction.setFullYear(new Date().getFullYear());
                          valorCondiction.setSeconds(0, 0);
                        }
                        break;
                      default:
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                          dtValorControl.setSeconds(0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setSeconds(0, 0);
                        }
                        break;
                    }
                  } else {
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                  }
                  // Operacion
                  if (
                    (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                    (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                    dtValorControl > valorCondiction
                  ) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                }
                break;
              case 'Mayor o igual a':
                if (!date) {
                  if (Number(value) >= Number(condiction.valor)) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                } else {
                  let dtValorControl: Date = null;
                  let valorCondiction: Date = null;
                  valorCondiction = new Date(condiction.valor);
                  dtValorControl = new Date(value);
                  if (field && field.tipo_campo.nombre === 'date-time-picker') {
                    switch (field.propiedades && field.propiedades['tipo']) {
                      case 'calendar':
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                            dtValorControl.setHours(0, 0, 0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setHours(0, 0, 0, 0);
                        }
                        break;
                      case 'timer':
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                          dtValorControl.setDate(new Date().getDate());
                          dtValorControl.setMonth(new Date().getMonth());
                          dtValorControl.setFullYear(new Date().getFullYear());
                          dtValorControl.setSeconds(0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setDate(new Date().getDate());
                          valorCondiction.setMonth(new Date().getMonth());
                          valorCondiction.setFullYear(new Date().getFullYear());
                          valorCondiction.setSeconds(0, 0);
                        }
                        break;
                      default:
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                          dtValorControl.setSeconds(0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setSeconds(0, 0);
                        }
                        break;
                    }
                  } else {
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                  }
                  // Operacion
                  if (
                    (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                    (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                    dtValorControl >= valorCondiction
                  ) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                }
                break;
              case 'Menor a':
                if (!date) {
                  if (Number(value) < Number(condiction.valor)) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                } else {
                  let dtValorControl: Date = null;
                  let valorCondiction: Date = null;
                  valorCondiction = new Date(condiction.valor);
                  dtValorControl = new Date(value);
                  if (field && field.tipo_campo.nombre === 'date-time-picker') {
                    switch (field.propiedades && field.propiedades['tipo']) {
                      case 'calendar':
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                            dtValorControl.setHours(0, 0, 0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setHours(0, 0, 0, 0);
                        }
                        break;
                      case 'timer':
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                          dtValorControl.setDate(new Date().getDate());
                          dtValorControl.setMonth(new Date().getMonth());
                          dtValorControl.setFullYear(new Date().getFullYear());
                          dtValorControl.setSeconds(0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setDate(new Date().getDate());
                          valorCondiction.setMonth(new Date().getMonth());
                          valorCondiction.setFullYear(new Date().getFullYear());
                          valorCondiction.setSeconds(0, 0);
                        }
                        break;
                      default:
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                          dtValorControl.setSeconds(0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setSeconds(0, 0);
                        }
                        break;
                    }
                  } else {
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                  }
                  // Operacion
                  if (
                    (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                    (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                    dtValorControl < valorCondiction
                  ) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                }
                break;
              case 'Menor o igual a':
                if (!date) {
                  if (Number(value) <= Number(condiction.valor)) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                } else {
                  let dtValorControl: Date = null;
                  let valorCondiction: Date = null;
                  valorCondiction = new Date(condiction.valor);
                  dtValorControl = new Date(value);
                  if (field && field.tipo_campo.nombre === 'date-time-picker') {
                    switch (field.propiedades && field.propiedades['tipo']) {
                      case 'calendar':
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                            dtValorControl.setHours(0, 0, 0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setHours(0, 0, 0, 0);
                        }
                        break;
                      case 'timer':
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                          dtValorControl.setDate(new Date().getDate());
                          dtValorControl.setMonth(new Date().getMonth());
                          dtValorControl.setFullYear(new Date().getFullYear());
                          dtValorControl.setSeconds(0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setDate(new Date().getDate());
                          valorCondiction.setMonth(new Date().getMonth());
                          valorCondiction.setFullYear(new Date().getFullYear());
                          valorCondiction.setSeconds(0, 0);
                        }
                        break;
                      default:
                        if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                          dtValorControl.setSeconds(0, 0);
                        }
                        if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                          valorCondiction.setSeconds(0, 0);
                        }
                        break;
                    }
                  } else {
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                  }
                  // Operacion
                  if (
                    (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                    (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                    dtValorControl <= valorCondiction
                  ) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                }
                break;
              default:
                if (!date) {
                  if (String(value).toLowerCase() === String(condiction.valor).toLowerCase()) {
                    columns = condiction.columnas;
                    placeholder = condiction.placeholder;
                    columnsModal = condiction.columnas_selector_modal;
                  }
                } else {
                  let dtValorControl: Date = null;
                  if (field && field.tipo_campo.nombre === 'date-time-picker') {
                    let valorCondiction: string = null;
                    let valorControl: string = null;
                    const dtValor: Date = new Date(condiction.valor);
                    switch (field.propiedades && field.propiedades['tipo']) {
                      case 'calendar':
                        valorCondiction = dtValor.toLocaleDateString();
                        dtValorControl = new Date(value);
                        if (moment(dtValorControl).isValid()) {
                          valorControl = dtValorControl.toLocaleDateString();
                        }
                        break;
                      case 'timer':
                        dtValor.setSeconds(0, 0);
                        valorCondiction = dtValor.toLocaleTimeString();
                        dtValorControl = new Date(value);
                        if (moment(dtValorControl).isValid()) {
                          dtValorControl.setSeconds(0, 0);
                          valorControl = dtValorControl.toLocaleTimeString();
                        }
                        break;
                      default:
                        dtValor.setSeconds(0, 0);
                        valorCondiction = dtValor.toLocaleDateString();
                        valorCondiction += ' ' + dtValor.toLocaleTimeString();
                        dtValorControl = new Date(value);
                        if (moment(dtValorControl).isValid()) {
                          dtValorControl.setSeconds(0, 0);
                          valorControl = dtValorControl.toLocaleDateString();
                          valorControl += ' ' + dtValorControl.toLocaleTimeString();
                        }
                        break;
                    }
                    if (valorControl === valorCondiction) {
                      columns = condiction.columnas;
                      placeholder = condiction.placeholder;
                      columnsModal = condiction.columnas_selector_modal;
                    }
                  } else {
                    dtValorControl = new Date(value);
                    // tslint:disable-next-line:max-line-length
                    if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() === new Date(condiction.valor).toLocaleDateString()) {
                      columns = condiction.columnas;
                      placeholder = condiction.placeholder;
                      columnsModal = condiction.columnas_selector_modal;
                    }
                  }
                }
                break;
            }
            if (columns.length) {
              break;
            }
          }
        }
      }
    }
    if (!columns.length) {
      if (control.propiedades['tipo'] && control.propiedades['tipo'] === 'TablaForma') {
        if (control.propiedades['cargar_tabla']) {
          columns = control.propiedades['cargar_tabla']['column'];
        }
      } else if (control.propiedades['tipo'] === 'TablaMaestra') {
        columns = control.propiedades['columnas_seleccionadas'];
      }
      placeholder = control.placeholder;
      columnsModal = null;
     }
    return {columns: columns, placeholder: placeholder, columnsModal: columnsModal};
  }

  /**
   * Retorna el valor de el campo de una condicion e identifica si existe el campo en el contexto
   *
   * @private
   * @param {CondicionColumnaSelector} condiction
   * @returns {{value: any, existCondiction: boolean}}
   * @memberof RefactorDynamicFormComponent
   */
  private getValueCondiction(
    condiction: CondicionColumnaSelector
  ): {value: any, field: Control, existCondiction: boolean} {
    let existCondiction = false;
    let value: any;
    let formulario: SubForma;
    let associationForm: TareaAsociacion;
    let field: Control;
    let dependence: FormGroup;
    if (condiction.forma === this.form.alias) {
      formulario = find(this.form.sub_formas, {alias: condiction.formulario});
    } else {
      if (this.taskActually && this.taskActually.tarea_asociacion && this.taskActually.tarea_asociacion.length) {
        this.taskActually.tarea_asociacion.forEach(association => {
          if (association.alias === condiction.forma) {
            associationForm = association;
          }
        });
      }
    }
    if (formulario) {
      field = find(formulario.campos, {alias: condiction.campo});
      if (field) {
        dependence = result(find(this.formularios, {name: formulario.alias}), 'form');
        if (dependence) {
          if (dependence.controls[field.nombre_campo]) {
            existCondiction = true;
            value = dependence.controls[field.nombre_campo].value;
          }
        }
      }
    } else if (associationForm) {
      if (associationForm.datos && associationForm.datos.length) {
        const dataV = find(
          associationForm.datos,
          {alias_formulario: condiction.formulario, alias: condiction.campo}
        );
        if (dataV) {
          existCondiction = true;
          value = dataV.valor;
        }
      }
    }
    return {value: value, existCondiction: existCondiction, field: field};
  }

  /**
   * Retorna la estructura especifica de las columnas para la consulta de la maestra
   *
   * @private
   * @param {Control} control
   * @returns {EstructuraEspecifica}
   * @memberof RefactorDynamicFormComponent
   */
  private getStrutureSpecific(control: Control, columns: string[]): EstructuraEspecifica {
    const specificEstructure: EstructuraEspecifica = {
      maestra: String(control.lista_maestra[0].id),
      columnas: [],
      dependencia: [],
    };
    if (
      columns &&
      columns.length
    ) {
      columns.forEach(col => {
        const cols = col.split('_');
        const column = Number(cols[0]);
        if (cols.length === 1) {
          const structure = find(control.lista_maestra[0].estructura, {id: column});
          if (structure) {
            specificEstructure.columnas.push(column + ' ');
          }
        }
      });
      const blockColumns: Array<string[]> = [];
        let columnDependence = '';
        columns.forEach((col, index) => {
        const column = col.split('_');
        if (column.length > 1) {
          if (columnDependence !== column[0]) {
            columnDependence = column[0];
            const blockColumnsRecolector: Array<string> = [];
            columns.forEach((colDep, indexDep) => {
              const columnsRef = colDep.split('_');
              if (columnsRef[0] === columnDependence) {
                blockColumnsRecolector.push(colDep);
              }
            });
            blockColumns.push(blockColumnsRecolector);
          }
        }
      });
      blockColumns.forEach(columnsSeleted => {
        const history = this.loadingEstructureColumns(
          control.lista_maestra[0]['estructura'],
          columnsSeleted,
          Number(columnsSeleted[0].split('_')[0])
        );

        if (history) {
          specificEstructure.dependencia.push(history);
        }
      });
    }
    return specificEstructure;
  }

  /**
   * Ejecuta el auto guardado, guarda todos los formularios y emite el evento para finalizar la tarea
   *
   * @private
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  private autoSaveForm(): Promise<boolean> {
    return new Promise(async (resolve) => {
      await Static.asyncForEach(this.form.sub_formas, async subForm => {
        if (!subForm.tabla && !subForm.hidde) {
          const formulario = find(this.formularios, {name: subForm.alias});
          if (formulario && !formulario.saved) {
            await this.sended(formulario.form.value, subForm);
          }
        }
      });
      this.finishAutoSave.emit(true);
      resolve(true);
    });
  }

  /**
   * Ejecuta el auto guardado de los formularios configurados
   *
   * @private
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  private autoSaveFormulario(): Promise<boolean> {
    return new Promise(async (resolve) => {
      await Static.asyncForEach(this.form.sub_formas, async subForm => {
        if (!subForm.tabla && subForm.estilo['auto_saved'] && !subForm.hidde) {
          const formulario = find(this.formularios, {name: subForm.alias});
          if (formulario && formulario.form) {
            const data = Static.copyObjet(formulario.form.value);
            if (formulario && !formulario.saved && this.validDataForm(data, subForm, false)) {
              await this.sended(data, subForm, true);
            }
          }
        }
      });
      resolve(true);
    });
  }

  /**
   * Carga la fuente de datos configurada hacia una maestra del sistema en una tabla dinamica
   *
   * @private
   * @param {SubForma} subForm
   * @returns {Promise<boolean>}
   * @memberof RefactorDynamicFormComponent
   */
  private loadDataSourceFromMaster(subForm: SubForma): Promise<boolean> {
    return new Promise(async (resolve, _reject) => {
      const values = await this.getMasterDataSource(subForm);
      const columnsSelected: string[] = this.getColumnsSelectMasterDataSource(subForm);
      const columnsMaster: any[] = [];
      const dataTable: TablaDatos = ({
        alias: subForm.alias,
        nombre: subForm.nombre,
        id_tabla: subForm.id_forma,
        labels: {},
        valores: [],
        valueSelects: {},
      });
      subForm.campos.forEach(field => {
        dataTable.labels[field.alias] = field.nombre_campo;
      });

      values.forEach(value => {
        let labelSelect = '';

        columnsSelected.forEach((col, index) => {
          if (index > 0) {
            labelSelect += ' / ';
          }
          if (value.valores[col]) {
            labelSelect += value.valores[col] ;
          } else {
            labelSelect += 'No aplica';
          }
        });
        columnsMaster.push({value: value.id, key: labelSelect});
      });
      const shortid = require('shortid');
      await this.asyncForEach(columnsMaster, async (val: any) => {
      // data.valores.forEach(async val => {
        const selects: Object = new Object();
        const value = {
          id: shortid.generate()
        };
        subForm.estilo['fuente']['campos'].forEach((fieldAlias: string) => {
          const field = find(subForm.campos, {alias: fieldAlias});
          if (field && dataTable.labels[field.alias]) {
            if (field.tipo_campo.nombre === 'ngSelect') {
              value[field.nombre_campo] = val['value'];
              dataTable.valueSelects[field.nombre_campo + '_' + value['id']] = val['key'];
            } else {
              value[field.nombre_campo] = val['key'];
            }
          }
        });
        dataTable.valores.push(value);
        await Static.asyncForEach(subForm.campos, async field => {
          if (!value[field.nombre_campo] && field.validaciones.operaciones.length) {
            await Static.asyncForEach(field.validaciones.operaciones, async opr => {
              if (!value[field.nombre_campo]) {
                const resultOperaction = await this.executeOperation(
                  subForm,
                  field,
                  opr,
                  value,
                  dataTable.valueSelects
                );
                if (resultOperaction) {
                  value[field.nombre_campo] = resultOperaction;
                }
              }
            });
          }
        });

        await this.syncDataTable(value, subForm, selects);
      });
      this.dataTable.push(dataTable);
      const table = find(this.dataTable, {id_tabla: dataTable.id_tabla});
      if (table) {
        await Static.asyncForEach(table.valores, async val => {
          await this.updatedTableFount(val, subForm, table.valueSelects);
          this.syncDataTablesActually(val, subForm, 'agregar');
        });
      }
      this.purgeDataTable(this.dataTable);
      const d: any = this.loadingDataTable(subForm.id_forma);
      subForm.datos = new LocalDataSource(d);
      subForm.datos.refresh();
      this.valid();
      resolve(true);
    });
  }

  /**
   * Retorna los registros obtenidos de la consulta a la maestra
   * configurada para la fuente de datos de una tabla dinamica
   *
   * @private
   * @param {SubForma} subForm
   * @returns {Promise<ValoresEspecificos[]>}
   * @memberof RefactorDynamicFormComponent
   */
  private getMasterDataSource(subForm: SubForma): Promise<ValoresEspecificos[]> {
    return new Promise(async (resolve) => {
      let idRecords: string;
      let filterMaster: FiltroTableMasterGeneral[] = [];
      const specificEstructure: EstructuraEspecifica = this.getStructureMasterDataSource(subForm);
      if (subForm.estilo['fuente']['filtros'] && subForm.estilo['fuente']['filtros'].length) {
        this.loadingStructureDependenceFiltros(
          specificEstructure,
          subForm.estilo['fuente']['filtros'],
          subForm.estilo['fuente']['maestra'],
        );
        filterMaster = this.GenerateFiltersMasterTable(
          subForm.estilo['fuente']['filtros']
        );
      }
      // Esta funcion se utiliza en caso de necesitarse registros especificos en la fuente de datos desde una maestra
      if (
        subForm.estilo['fuente']['registros_especificos'] &&
        subForm.estilo['fuente']['registros_especificos'].length
      ) {
        idRecords = '(';
        subForm.estilo['fuente']['registros_especificos'].forEach((record: any, i: number) => {
          idRecords += record;
          if (i < (subForm.estilo['fuente']['registros_especificos'].length - 1)) {
            idRecords += ', ';
          }
        });
        idRecords += ')';
      }
      const columns = await this.rdfds.getColumnsSpecificMasterTable(specificEstructure, filterMaster, idRecords);
      resolve(columns);
    });
  }

  /**
   * Retorna la estructura de la consulta a la maestra
   * configurada para la fuente de datos de una tabla dinamica
   *
   * @private
   * @param {SubForma} subForm
   * @returns {EstructuraEspecifica}
   * @memberof RefactorDynamicFormComponent
   */
  private getStructureMasterDataSource(subForm: SubForma): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const columnsSelected: string[] = this.getColumnsSelectMasterDataSource(subForm);
    if (columnsSelected.length) {
      columnsSelected.forEach(column => {
        const structure = this.generateStructureMasterTable(
          subForm.estilo['fuente']['maestra'],
          column
        );
        if (!specificEstructure) {
          specificEstructure = structure;
        } else {
          specificEstructure.columnas = specificEstructure.columnas.concat(structure.columnas);
          specificEstructure.dependencia = specificEstructure.dependencia.concat(structure.dependencia);
        }
      });
    }
    return specificEstructure;
  }

  /**
   * Retorna las columnas seleccionadas para la consulta de la maestra
   * configurada para la fuente de datos de una tabla dinamica
   *
   * @private
   * @param {SubForma} subForm
   * @returns {string[]}
   * @memberof RefactorDynamicFormComponent
   */
  private getColumnsSelectMasterDataSource(subForm: SubForma): string[] {
    let columnsSelected: string[] = [];
    if (subForm.estilo['fuente']['campos'] && subForm.estilo['fuente']['campos'].length) {
      let typeSelect = false;
      for (const field of subForm.estilo['fuente']['campos']) {
        const fieldExist = find(subForm.campos, {alias: field});
        if (fieldExist && fieldExist.tipo_campo.nombre === 'ngSelect') {
          columnsSelected = fieldExist.propiedades['columnas_seleccionadas'];
          typeSelect = true;
          break;
        }
      }
      if (!typeSelect) {
        columnsSelected = subForm.estilo['fuente']['estructura'];
      }
    } else {
      columnsSelected = subForm.estilo['fuente']['estructura'];
    }
    return columnsSelected;
  }

  /**
   * Controla las acciones del componente de editar en tabla
   *
   * @private
   * @param {InputTableComponent} instance
   * @param {Control} control
   * @param {SubForma} form
   * @memberof RefactorDynamicFormComponent
   */
  private controlTableEditComponent(instance: InputTableComponent, control: Control, form: SubForma) {
    instance.control = control;
    instance.subform = form;
    instance.columnsLabel = control.propiedades['columnsSelectorModal'] ?
                              control.propiedades['columnsSelectorModal']
                            : [];
    instance.selectionsColumns = this.validCondictionsColumns(control).columns;
    instance.loadingOptions = (
      subForm,
      ctrl,
      dataForm,
      update,
      refreshForm,
      returnControl,
      rowData
    ) => {
      if (ctrl.tipo_campo.nombre === 'ngSelect') {
        return new Promise(async (resolve) => {
          this.formSelect = subForm;
          this.update = true;
          if (!this.tableUpdate) {
            this.tableUpdate = true;
          }
          this.indexSelectUpdate = rowData.index;
          this.tmpIndexRow = rowData.index;
          this.tmpControl = await this.refresControlForm(
            subForm,
            ctrl,
            rowData,
            update,
            refreshForm,
            returnControl
          );
          resolve(this.tmpControl);
        });
      }
    };
    instance.runOperations = (subForm, ctrl, rowData) => {
      return new Promise(async (resolve, reject) => {
        if (this.componentRef) {
          this.componentRef.destroy();
        }
        const formulario = await this.rdffs.getForm(subForm, this.templatesFomr, rowData, true);
        const factory = this.cfr.resolveComponentFactory(DynamicFormComponent);
        this.componentRef = this.emulateForm.createComponent(factory);
        this.componentRef.instance.returnCreatedForm = true;
        this.componentRef.instance.controls = formulario;
        const formG = this.componentRef.instance.form;
        this.accumulateForm(formG, subForm.alias, true);
        this.formSelect = subForm;
        this.update = true;
        if (!this.tableUpdate) {
          this.tableUpdate = true;
        }
        this.indexSelectUpdate = rowData.index;
        this.tmpIndexRow = rowData.index;
        if (control.tipo_campo.nombre === 'ngSelect') {
          instance.temporalValue = this.componentRef.instance.form.controls[control.nombre_campo].value;
        }
        resolve(true);
      });
    };
    instance.dataUpdate.subscribe(async (data: UpdateData) => {
      if (this.task && data.saved) {
        this.formSelect = data.subForm;
        const indexForm = findIndex(this.formularios, {name: data.subForm.alias});
        if (indexForm !== -1) {
          this.formularios.splice(indexForm, 1);
        }
        this.update = true;
        if (!this.tableUpdate) {
          this.tableUpdate = true;
        }
        this.indexSelectUpdate = data.row.index;
        this.tmpControl = null;
        this.tmpIndexRow = -1;
        if (this.componentRef) {
          this.componentRef.destroy();
        }
        await Static.asyncForEach(this.formSelect.campos, async (ctrl: Control) => {
          if (ctrl.tipo_campo.nombre === 'ngSelect') {
            ctrl = await this.refresControlForm(this.formSelect, ctrl, Static.copyObjet(data.row), true, false, true);
          }
        });
          const formulario = await this.rdffs.getForm(data.subForm, this.templatesFomr, data.row, true);
        const factory = this.cfr.resolveComponentFactory(DynamicFormComponent);
        this.componentRef = this.emulateForm.createComponent(factory);
        this.componentRef.instance.returnCreatedForm = true;
        this.componentRef.instance.formCreated.subscribe(
          async (formG: FormGroup) => {
            this.nameFormChange = '';
            await this.accumulateForm(formG, data.subForm.alias, true);
            this.componentRef.instance.onSubmit(true);
          }
        );
        this.componentRef.instance.sended.subscribe((dataS: any) => {
          const dataForm = merge(dataS, data.row);
          this.sendedTable(dataForm, data.subForm, control.alias);
        });
        this.componentRef.instance.controls = formulario;
      } else {
        this.closeAddDataTable();
        this.formSelect = null;
        this.update = false;
        if (this.tableUpdate) {
          this.tableUpdate = false;
        }
        this.indexSelectUpdate = -1;
        this.tmpControl = null;
        this.tmpIndexRow = -1;
        if (this.componentRef) {
          this.componentRef.destroy();
        }
        this.valid();
      }
    });
  }

  /**
   * Carga la lista de opciones del selector del filtro en la tabla dinamica
   * para los selectores
   *
   * @param {SubForma} subForm
   * @memberof RefactorDynamicFormComponent
   */
  loadOptionsColumnSelect(subForm: SubForma) {
    const indexForm = findIndex(this.form.sub_formas, {id_forma: subForm.id_forma});
    if (subForm && subForm.campos.length) {
      const apply = find(
        subForm.campos,
        (el) => el.tipo_campo.nombre === 'ngSelect' && el.propiedades['mostrarTabla'] && !el.propiedades['sin_filtro']
      );
      if (apply) {
        this.loadingDataSource[subForm.alias] = true;
        subForm.campos.forEach(control => {
          if (
            control.tipo_campo.nombre === 'ngSelect' &&
            control.propiedades['mostrarTabla'] &&
            !control.propiedades['sin_filtro']
          ) {
            let keyField = '';
            if (control.propiedades['modificar_tabla'] && !this.finishTask) {
              keyField = control.nombre_campo;
            } else {
              keyField = control.nombre_campo + '_valor';
            }
            if (
              this.form.sub_formas[indexForm].configuracion_tabla &&
              this.form.sub_formas[indexForm].configuracion_tabla['columns'] &&
              this.form.sub_formas[indexForm].configuracion_tabla['columns'][keyField]
            ) {
              // tslint:disable-next-line: max-line-length
              this.form.sub_formas[indexForm].configuracion_tabla['columns'][keyField]['filter']['config']['list'] = this.listOptionsColumnSelect(
                subForm.id_forma,
                control.alias,
                control.propiedades['modificar_tabla'] && !this.finishTask ? true : false
              );
            }
          }
        });
      }
    }
    setTimeout(() => {
      this.loadingDataSource[subForm.alias] = false;
    }, 300);
  }

  /**
   * Retorna la lista de opciones para el selector del filtro de una columna tipo ngSelect
   *
   * @private
   * @param {number} idForm
   * @param {string} aliasControl
   * @returns
   * @memberof RefactorDynamicFormComponent
   */
  private listOptionsColumnSelect(idForm: number, aliasControl: string, valueId: boolean = false) {
    const tbl = find(this.dataTable, {id_tabla: idForm});
    const form = find(this.form.sub_formas, {id_forma: idForm});
    const control = find(form.campos, {alias: aliasControl});
    const list: any[] = [];
    const columns = this.getColumns(control.propiedades['columnsSelectorModal'] ?
                                      control.propiedades['columnsSelectorModal']
                                    : []);
    const selectionsColumns = this.validCondictionsColumns(control).columns;
    if (tbl && control) {
      tbl.valores.forEach(val => {
        const labelTitle = this.loadingColumnsLabel(
          tbl.valueSelects[control.nombre_campo + '_' + val['id']],
          columns,
          selectionsColumns
        );
        const exist = find(list, {title: labelTitle});
        if (!exist) {
          list.push({
            value: valueId ?
                    val[control.nombre_campo]
                   : tbl.valueSelects[control.nombre_campo + '_' + val['id']],
            title: labelTitle
          });
        }
      });
    }
    return list;
  }

  /**
   * Retorna todas las columnas incluyendo las columnas dependientes en un mismo nivel
   *
   * @param {ColumnsTableModalSelect[]} c
   * @return {*}  {ColumnsTableModalSelect[]}
   * @memberof RefactorDynamicFormComponent
   */
  getColumns(c: ColumnsTableModalSelect[]): ColumnsTableModalSelect[] {
    const cols: ColumnsTableModalSelect[] = [];
    c.forEach(column => {
      if (!column.columnsDependence || !column.columnsDependence.length) {
        cols.push(column);
      } else {
        const cs = this.getColumns(column.columnsDependence);
        if (cs.length) {
          cs.forEach(cl => {
            cols.push(cl);
          });
        }
      }
    });
    return cols;
  }

  /**
   * Cargar label de un valor
   *
   * @param {*} value
   * @param {ColumnsTableModalSelect[]} columnsT
   * @param {string[]} selectionsColumns
   * @return {*}  {string}
   * @memberof RefactorDynamicFormComponent
   */
  loadingColumnsLabel(value: any, columnsT: ColumnsTableModalSelect[], selectionsColumns: string[]): string {
    let labelString = '';
    if (columnsT.length && columnsT.length > 1 && value) {
      for (let i = 0; i < selectionsColumns.length; i++) {
        const configColum = find(columnsT, {key: selectionsColumns[i]});
        const indexConfigColum = findIndex(columnsT, {key: selectionsColumns[i]});
        if (configColum) {
          const labels = columnsT[i].label.split(' - ');
          let label = '';
          if (labels.length > 1) {
            label = labels[1];
          } else {
            label = labels[0];
          }
          let element = label + ': ';
          if (typeof value === 'object') {
            if (
              configColum.type !== 'ngSelect' ||
              (
                value.hasOwnProperty(configColum.key) &&
                typeof value[configColum.key] !== 'object'
              )
            ) {
              if (value[configColum.key]) {
                element += value[configColum.key] + ' ';
              } else {
                element += 'No aplica ';
              }
            } else {
              const columns = String(configColum.key).split('-');
              if (columns.length && columns.length > 1) {
                let textColumn = '';
                columns.forEach((c, ix) => {
                  if (ix > 0) {
                    textColumn += c;
                    if (ix < (columns.length - 1)) {
                      textColumn += '-';
                    }
                  }
                });
                if (value[columns[0]][textColumn]) {
                  element += value[columns[0]][textColumn] + ' ';
                } else {
                  element += 'No aplica ';
                }
              } else {
                element += 'No aplica ';
              }
            }
          } else {
            const valueColumns = String(value).split('/');
            if (valueColumns.length && indexConfigColum < valueColumns.length) {
              element += valueColumns[indexConfigColum];
            } else {
              element += 'No aplica ';
            }
          }
          if (i > 0) {
            labelString += '/ ' + element;
          } else {
            labelString = element;
          }
        } else {
          if (i > 0) {
            labelString += '/ Columna: No aplica';
          } else {
            labelString = 'Columna: No aplica';
          }
        }
      }
      labelString = labelString;
    } else {
      if (value) {
        if (
          typeof value === 'object'
        ) {
          if (value.hasOwnProperty(selectionsColumns[0])) {
            labelString = value[selectionsColumns[0]];
          } else {
            labelString = '';
          }
        } else {
          labelString = value;
        }
      } else {
        labelString = '';
      }
    }
    return labelString;
  }

  /**
   * Genera la informacion configurada para los valores por defecto
   *
   * @private
   * @param {ValoresMaestraPorDefectoSeletor[]} configDefaultValues
   * @returns {*}
   * @memberof RefactorDynamicFormComponent
   */
  private getDataDefaultValueMaster(configDefaultValues: ValoresMaestraPorDefectoSeletor[]): any {
    const data: any = {};
    if (configDefaultValues && configDefaultValues.length) {
      configDefaultValues.forEach(defaultValue => {
        if (!data.hasOwnProperty(defaultValue.columna + ' ')) {
          if (defaultValue.tipo_valor === 'especifico') {
            data[defaultValue.columna + ' '] = defaultValue.valor;
            defaultValue['apply'] = true;
          } else {
            if (defaultValue.forma === this.form.alias) {
              const formulario = find(this.formularios, {name: defaultValue.formulario});
              const subForm = find(this.form.sub_formas, {alias: defaultValue.formulario});
              if (formulario && subForm) {
                const field = find(subForm.campos, {alias: defaultValue.campo});
                if (field && formulario.form.value[field.nombre_campo]) {
                  data[defaultValue.columna + ' '] = formulario.form.value[field.nombre_campo];
                  defaultValue['apply'] = true;
                }
              }
            } else {
              const associate = find(this.taskActually.tarea_asociacion, {alias: defaultValue.forma});
              if (associate) {
                const dataFielAssociate = find(
                  associate.datos,
                  {
                    alias_formulario: defaultValue.formulario,
                    alias: defaultValue.campo
                  }
                );
                if (dataFielAssociate) {
                  data[defaultValue.columna + ' '] = dataFielAssociate.valor;
                  defaultValue['apply'] = true;
                }
              }
            }
          }
        }
      });
    }
    return data;
  }

  /**
   * Valida si el registro a ingresar es unico y si ya se encuentra agregado
   *
   * @private
   * @param {*} data
   * @param {SubForma} form
   * @returns {boolean}
   * @memberof RefactorDynamicFormComponent
   */
  private validateUniqueRecords(data: any, form: SubForma): boolean {
    let valid = true;
    const uniqueFields = filter(form.campos, f => f.propiedades['unico']);
    const table = find(this.dataTable, {id_tabla: form.id_forma});
    if (uniqueFields.length && table) {
      const dataFilter = {};
      uniqueFields.forEach(field => {
        dataFilter[field.nombre_campo] = data[field.nombre_campo];
      });
      const controlsGeneral = filter(form.campos, ctrl => ctrl.propiedades['columna_general']);
      if (controlsGeneral.length) {
        controlsGeneral.forEach(field => {
          dataFilter[field.nombre_campo] = data[field.nombre_campo];
        });
      }
      if (form.estilo['formulario_pestaña']) {
        const tabFormulario = find(
          this.form.sub_formas,
          {alias: form.estilo['formulario_pestaña']}
        );
        if (tabFormulario) {
          const controlsGeneralPrincipal = filter(
            tabFormulario.campos,
            ctrl => ctrl.propiedades['columna_general']
          );
          if (controlsGeneralPrincipal.length) {
            const formulario = find(this.formularios, {name: tabFormulario.alias});
            if (formulario) {
              controlsGeneralPrincipal.forEach(fieldGeneral => {
                dataFilter[fieldGeneral.nombre_campo] = formulario.form.value[fieldGeneral.nombre_campo];
              });
            }
          }
        }
      }
      let exist: any;
      if (this.indexSelectUpdate !== -1 && (this.update || this.updateForm[form.alias])) {
        const valuesFilter = filter(table.valores, dataFilter);
        if (valuesFilter.length) {
          exist = find(valuesFilter, (v: any) => v['index'] !== this.indexSelectUpdate);
        }
      } else {
        exist = find(table.valores, dataFilter);
      }
      if (exist) {
        valid = false;
      }
    }
    return valid;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/refactor-dynamic-form/refactor-dynamic-form.component.ts